
<template>
    <div class="wrap">
          <!--页面header-->
          <div class="title">
            <i class="el-icon-back" @click="back()"></i>
            <span v-if="$route.query.qobj_id">编辑电路编程</span>
            <span v-else>创建电路编程</span>
          </div>
           <!-- 页面提示-->

             <el-tag
                :key="tag"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)"
                class="account">
                <span>!</span>
                {{tag}}
                <h6 class="glossary" @click="toHelp()">量子门词汇表</h6>
              </el-tag>
           <!-- 电路编辑表单-->
          <div class="programbox">
           <!--电路编程-->
           <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="140px"
            class="demo-ruleForm"
            style="width:700px"
           >
            <el-form-item label="实验名称" prop="name">
              <el-input v-model="ruleForm.name" style="width:400px;font-size:12px"></el-input>
               <div
                style="font-size:12px;height:20px;line-height:20px;color: rgba(0, 0, 0, 0.45)"
              >2-20个字符，不能以特殊字符及数字开头，只能包含特殊字符中的"_"或"-"。</div>
            </el-form-item>
            <el-form-item label="量子计算机" prop="selectMechine">

               <el-select placeholder="请选择量子计算机" v-model="runRuleForm.name" @change="changevalue($event)" @visible-change="saveBeforeValue($event,runRuleForm.id)"  >
                <el-option
                  v-for="(item,key,index) in form.computed"
                  :label="item.machineName"
                  :key="index"
                  :value="key"
                  :disabled="item.onlineState=='online'? false:true"
                 
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运行次数" prop="testNum">
              <el-select placeholder="请选择运行次数" v-model="runRuleForm.shots" @change="shotsChange($event)">
                <el-option label="1024" value="1024"></el-option>
                <el-option label="4096" value="4096"></el-option>
                <el-option label="8192" value="8192"></el-option>
              </el-select>
             
            </el-form-item>
             <el-form-item label="描述" prop="describe">
              <el-input
                v-model="ruleForm.describe"
                placeholder="请输入描述信息"
                style="width:400px;"
                :rows="4"
                type="textarea"
                resize="none"
              ></el-input>
              <div
                style="font-size:12px;color: rgba(0, 0, 0, 0.45);height:20px;line-height:20px"
              >1-100个字符</div>
            </el-form-item>
            </el-form>
          </div>
       <div class="create_wrap">
            <div class="create_title">
                  <div class="title_text">
                    电路编程
                    <span class="title_info">（基于图形界面实现量子电路编程）</span>
                  </div>
                  <div class="title_text1">
                    代码编程
                   <span class="title_info">
                     （基于OPENQASM进行量子计算代码编程）
                   </span>
                  </div>
              </div>
            <div class="create_box">
              <div class="create">
                    <ul id="lis">
                       <!-- <li name="a" idx="20" ref="dragBox" @touchstart="touchstartHandle('dragBox',$event)"   @touchend="touchmoveHandle('dragBox',$event)" >
                          <em draggable='false'>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-h.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                           </span>
                        </em>
                       </li> -->
                      
                      <li draggable="true" idx="1" @dragstart="dragstart($event)" @ name="h" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                           <i class="iconfont icon-bianji" ></i>
                          <span class="bit">

                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-h.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                           </span>
                        </em>
                      </li>
                      <li draggable="true" idx="2" @dragstart="dragstart($event)" name="s" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">

                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-s.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="3" @dragstart="dragstart($event)" name="sdg" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">

                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-sdg.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="12" @dragstart="dragstart($event)" name="tdg" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-t1.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="11" @dragstart="dragstart($event)" name="t" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-t.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="9" @dragstart="dragstart($event)" name="cx" v-if="selectMechine == 'simulation'" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <span class="bit">
                            <svg class="icon" aria-hidden="true">
                              <use xlink:href="#icon-qcicon-cx"></use>
                            </svg>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="10" @dragstart="dragstart($event)" name="swap" v-if="selectMechine == 'simulation'" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <span class="bit">
                            <svg class="icon" aria-hidden="true">
                                <use xlink:href="#icon-qcicon-swap"></use>
                            </svg>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="4" @dragstart="dragstart($event)" name="id" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent   @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">

                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-id.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="5" @dragstart="dragstart($event)" name="x" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-x.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="6" @dragstart="dragstart($event)" name="y" @touchstart="touchstartHandle('dragBox',$event)"  @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-y.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="7" @dragstart="dragstart($event)" name="z" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false' >
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-z.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="8" @dragstart="dragstart($event)" name="measure" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/font/qcicon-measure.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="21" @dragstart="dragstart($event)" name="u1" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <!-- <i class="iconfont icon-tianjiaaddto1"></i> -->
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/u1.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="22" @dragstart="dragstart($event)" name="u2" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/u2.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="13" @dragstart="dragstart($event)" name="u3" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/u3.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="14" @dragstart="dragstart($event)" name="rx" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/rx.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="15" @dragstart="dragstart($event)" name="ry" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/ry.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="16" @dragstart="dragstart($event)" name="rz" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/rz.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="17" @dragstart="dragstart($event)" name="x_half" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/x1.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="18" @dragstart="dragstart($event)" name="y_half" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/y1.svg" alt="" name="bitSvg" style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="19" @dragstart="dragstart($event)" name="cz" v-if="selectMechine == 'simulation'" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <!-- <i class="iconfont iconclose-circle"></i> -->
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/cz.svg" alt=""  style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                      <li draggable="true" idx="20" @dragstart="dragstart($event)" name="toffoli" v-if="selectMechine == 'simulation'" @touchstart="touchstartHandle('dragBox',$event)" @touchmove.prevent  @touchend="touchmoveHandle('dragBox',$event)">
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="bit">
                            <span class="icon" draggable='false'>
                                <img src="../../assets/icon/toff.svg" alt=""  style="display:inline-block;width:25px" draggable='false'>
                            </span>
                          </span>
                        </em>
                      </li>
                     <div
                        draggable="true"
                        idx="9"
                        @dragstart="dragdouble($event)"
                        style="display:none"
                        class="circleQuantum"
                      >
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="circle"></span>
                          <span class="quantumline"></span>
                          <span class="circleend">  </span>
                          <span class="close"></span>
                          <span class="editquantum"></span>
                        </em>
                      </div>
                      <div
                        draggable="true"
                        idx="10"
                        @dragstart="dragdouble($event)"
                        style="display:none"
                        class="xQuantum"
                      >
                        <em draggable='false'>
                          <i class="iconfont iconclose-circle"></i>
                          <span class="xStart"><i class="iconfont icon-close-copy"></i></span>
                          <span class="quantumline"></span>
                          <span class="xEnd"> <i class="iconfont icon-close-copy"></i> </span>
                          <span class="close"></span>
                          <span class="editquantum"></span>
                        </em>
                      </div>
                       <div class="tianchong"></div>
                    </ul>
                    <div class="tip">
                        拖拽量子门到横线（量子寄存器）即可创建电子电路，通过编辑实现多量子比特门量子位连接
                    </div>
                    <div class="line_scroll" draggable="false">
                      <div class="line_wrap" ref="imageDom"></div>
                      <div class="line_wrap_mondel">
                        <div class="line clearfix">
                          <div class="left">
                            <span class="iconfontPng noclick">
                              <i class="el-icon-remove-outline"></i>
                            </span>
                            <span class="orderNum" draggable="false">
                              q[<input
                                type="text"
                                value="0"
                                class="orderValue"
                                readonly="true"
                                disabled="true"
                              />]&nbsp;&nbsp;|&nbsp;0 >
                            </span>
                          </div>
                          <span class="right" @drop="drop($event)">
                            <i class="bgline1" id="box1"></i>
                            <div class="online_wrap" id="box" @click="deleteOne($event)"></div>
                          </span>
                        </div>
                      </div>
                      <div class="addline" @click="addline()">
                        <i class="el-icon-circle-plus-outline"></i>
                        <span>增加量子寄存器</span>
                      </div>
                      <div class="c1">
                        <span class="left">c{{num1}}</span>
                        <span class="right_c1">
                          <i class="bgline"></i>
                        </span>
                      </div>
                    </div>
              </div>


           <!--语言编程-->
          <div class="mycode_wrap">
            <textarea ref="mycode" class="codesql" v-model="code" style="display:none"></textarea>
          </div>
        </div>

          <div class="submitButton">
              <el-button type="primary" size="mini" @click="operationTest('ruleForm')" :loading='isloadimgbtn'>运行</el-button>
              <el-button size="mini" @click="save('ruleForm')">保存</el-button>
              <el-button size="mini" @click="clear()">清空</el-button>
              <el-button size="mini" @click="clickGeneratePicture()" >图形导出</el-button>
              <el-button size="mini" @click="downloadCode()" >导出代码</el-button>
          </div>
      </div>
       <div class="bar_wrap">
          <div class="bar1" v-show='islimit'>
              <p>预期投影概率</p>
              <div id="charts" ></div>
          </div>
           <div class="bar1" v-show='!islimit'>
              <p>预期投影概率</p>
               <div class="tip">投影概率展示仅适用于≤4位量子比特的线路，请根据实际计算需求进行调整使用</div>
          </div>
          <div class="bar1" v-show='islimit'>
              <p>预期密度矩阵</p>
               <div id="charts0" ></div>
          </div>
           <div class="bar1" v-show='!islimit'>
              <p>预期密度矩阵</p>
               <div class="tip">密度矩阵展示仅适用于≤4位量子比特的线路，请根据实际计算需求进行调整使用</div>
          </div>
          <div class="bar2" v-show='islimit'>
              <p>预期振幅</p>
               <div id="charts1" ></div>
          </div>
           <div class="bar1" v-show='!islimit'>
              <p>预期振幅</p>
               <div class="tip">振幅展示仅适用于≤4位量子比特的线路，请根据实际计算需求进行调整使用</div>
          </div>
       </div>
           <!--运行结果列表-->
          <div class="taskList" v-if="thisTestList">
            <h4>实验任务列表</h4>
            <el-table
              :data="dataList1"
              style="width: 100%"
              :header-cell-style="{'text-align':'left',background:'rgba(0, 0, 0, 0.04)'}"
              :cell-style="{'text-align':'left'}"
            >
              <el-table-column prop="taskId" label="任务序号" width="180" >
                <template slot-scope="scope">
                  <el-popover
                    placement="top-start"
                    width="300"
                    trigger="hover"
                    :content="scope.row.id"
                  >
                    <span
                      slot="reference"
                      style="cursor:pointer;color:#2186FB;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                      @click="toDetail(scope.row.id)"
                    >{{ scope.row.id }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="computer" label="量子计算机" width="180">
                <template slot-scope="scope" >
                  <span v-if="scope.row.type=='computer'">浪潮量子计算机01</span>
                  <span v-else-if="scope.row.type=='simulation'">浪潮量子计算模拟机</span>
                </template>
              </el-table-column>
              <el-table-column prop="shotsNum" label="运行次数">
                <template slot-scope="scope">{{ scope.row.shots }}</template>
              </el-table-column>
              <el-table-column prop="submitTime" label="提交时间">
                <template slot-scope="scope">{{ scope.row.creationtime }}</template>
              </el-table-column>
              <el-table-column prop="State" label="状态">
                <template slot-scope="scope">
                  <span class="success_status" v-if="scope.row.status === 'DONE'">
                    <b></b>
                    <span>完成</span>
                  </span>
                  <span class="success_status" v-else-if="scope.row.status === 'CREATED'">
                    <b class="start"></b>
                    <span>创建</span>
                  </span>
                  <span class="success_status" v-else-if="scope.row.status === 'INITIALIZING'">
                    <b class="start"></b>
                    <span>初始化</span>
                  </span>
                  <span class="error_status" v-else-if="scope.row.status === 'INITIALIZING_ERROR'">
                    <b class="wrong"></b>
                    <span>初始化错误</span>
                  </span>
                  <span class="success_status" v-else-if="scope.row.status === 'VALIDATING'">
                    <b></b>
                    <span>证实</span>
                  </span>
                  <span class="error_status" v-else-if="scope.row.status === 'VALIDATING_ERROR'">
                    <b class="wrong"></b>
                    <span>证实错误</span>
                  </span>
                  <span class="success_status" v-else-if="scope.row.status === 'QUEUED'">
                    <b class="start"></b>
                    <span>排队</span>
                  </span>
                  <span class="error_status" v-else-if="scope.row.status === 'CANCELLED'">
                    <b class="quit"></b>
                    <span>排队取消</span>
                  </span>
                  <span class="success_status" v-else-if="scope.row.status === 'RUNNING'">
                    <b class="start"></b>
                    <span>执行</span>
                  </span>
                  <span class="error_status" v-else-if="scope.row.status === 'ERROR'">
                    <b class="wrong"></b>
                    <span>执行错误</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="finshTime" label="完成时间">
                <template slot-scope="scope">
                  <span v-if="!scope.row.completetime">--</span>
                  <span v-else>{{scope.row.completetime}}</span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              style="display:flex;justify-content: flex-end;"
              @current-change="current_change"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next"
              :total="total"
            ></el-pagination>
          </div>
    <!-- 编辑量子门角度 -->
      <el-dialog title="编辑量子门角度" :visible.sync="dialogEditAngle" width="500px" class="editQuantum" >
      <el-form :rules="angleRules" ref="angleForm" :model="angleform" >
        <el-form-item label="弧度" :label-width="formLabelWidth" style='width:400px;height:30px' v-if="isSingleangle" prop="angle">
          <el-input autocomplete="off" v-model="angleform.angle" @change='angleChange($event)'></el-input>
        </el-form-item>
        <el-form-item label="弧度1" :label-width="formLabelWidth" style='width:400px;height:30px' v-if="isDoubleangle||isMultiangle" prop="angle" >
          <el-input autocomplete="off" v-model="angleform.angle1"></el-input>
        </el-form-item>
         <el-form-item label="弧度2" :label-width="formLabelWidth" style='width:400px;height:30px' v-if="isDoubleangle" prop="angle">
          <el-input autocomplete="off" v-model="angleform.angle2"></el-input>
        </el-form-item>
        <el-form-item label="弧度2" :label-width="formLabelWidth" style='width:400px;height:30px' v-if="isMultiangle" prop="angle">
          <el-input autocomplete="off" v-model="angleform.angle3"></el-input>
        </el-form-item>
         <el-form-item label="弧度3" :label-width="formLabelWidth" style='width:400px;height:30px' v-if="isMultiangle" prop="angle">
          <el-input autocomplete="off" v-model="angleform.angle4"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogEditAngle = false">取 消</el-button>
        <el-button type="primary" @click="changeAngle()">确 定</el-button>
      </div>
    </el-dialog>

     <!--编辑跨线量子弹窗-->
    <el-dialog title="编辑纠缠量子位置" :visible.sync="dialogFormVisibledouble" width="500px" class="editQuantum">
      <el-form >
        <el-form-item label="起始位置" :label-width="formLabelWidth" style='width:400px;height:30px'>
          <el-input autocomplete="off" v-model="start" @input="startInput($event)"></el-input>
        </el-form-item>
        <el-form-item label="结束位置" :label-width="formLabelWidth" style='width:400px;height:30px'>
          <el-input autocomplete="off" v-model="end"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibledouble = false">取 消</el-button>
        <el-button type="primary" @click="editQuantum(quantumTwo)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="编辑纠缠量子位置" :visible.sync="dialogFormVisibledouble1" width="500px" class="editQuantum">
      <el-form >
        <el-form-item label="起始位置" :label-width="formLabelWidth" style='width:400px;height:30px'>
          <el-input autocomplete="off" v-model="toffstart" @input="startInput($event)"></el-input>
        </el-form-item>
        <el-form-item label="中间位置" :label-width="formLabelWidth" style='width:400px;height:30px'>
          <el-input autocomplete="off" v-model="toffmiddle"></el-input>
        </el-form-item>
        <el-form-item label="结束位置" :label-width="formLabelWidth" style='width:400px;height:30px'>
          <el-input autocomplete="off" v-model="toffend"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibledouble1 = false">取 消</el-button>
        <el-button type="primary" @click="editQuantumThree(quantumThree)">确 定</el-button>
      </div>
    </el-dialog>
 </div>
</template>



<script>
import echarts from "echarts";
import Cookies from 'js-cookie'
import 'codemirror/theme/ambiance.css'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
// import { getToken } from '@/utils/auth'
let CodeMirror = require('codemirror/lib/codemirror')
require('codemirror/addon/edit/matchbrackets')
require('codemirror/addon/selection/active-line')
require('codemirror/mode/sql/sql')
require('codemirror/addon/hint/show-hint')
require('codemirror/addon/hint/sql-hint')
import html2canvas from "html2canvas"
import canvg from "canvg";
// import {
//   querymechineInfo,
//   saveExperiment,
//   queryExperiment,
//   queyOneTaskInfoList,
//   deleteExperiment,
//   getValidate,
//   editExperiment,
//   queyTaskInfoList,
//   RequestMethod,
//   getModelList,
//   getChart
// } from "../../api/index";
export default {
  name: "DndList",
  data() {
    var validateLength = (rule, value, callback) => {
        if (value.replace(/[^x00-xff]/g, 'xx').length<=100 ) {
          callback();
        } else {
          callback(new Error('不能超过 100 个字符'));
        }
      };
    var validateLength1 = (rule, value, callback) => {
      if (value.replace(/[^x00-xff]/g, 'xx').length<=20&&value.replace(/[^x00-xff]/g, 'xx').length>=2 ) {
        callback();
      } else {
        callback(new Error('长度在 2 到 20 个字符'));
      }
    };
    return {
       coordinate: {
            client: {},
            elePosition: {}
        },
      isloadimgbtn:false,//运行按钮是否不可点击
      beforeSaveId:'001',
      beforeSaveValue:'',
      selectMechine:'simulation',
      angleform:{
        angle:1.570796,
        angle1:1.570796,
        angle2:-3.141593,
        angle3:4.712389,
        angle4:1.570796,
      },
      angle:1.570796,
      angle1:1.570796,
      angle2:-3.141593,
      angle3:4.712389,
      angle4:1.570796,
      dialogEditAngle:false,
      allTaskListTime:null,
      runRuleForm:{
        name:'浪潮量子计算模拟机',
        id:'001',
        shots:'1024'
      },
      flag:-1,//提示显示
      cols:0,//brr的总列数
      start: 0,//开始位置
      end: 0,//结束位置
      toffstart:0,//三比特开始位置
      toffmiddle:1,//三比特中间位置
      toffend:2,//三比特结束位置
      user_id: "", //用户id
      device_name: "",
      thisTestList: false, //试验任务列表的显隐
      qubit_labels: [], //[qreg_name, n]，用于指示相应的物理量子比特作为第n个量子比特的量子寄存器qreg_name
      instructions: [], //量子实验执行的量子指令列表
      header: {}, //qobj元数据
      qubits: [], //量子比特列表
      qubitdata: {}, //量子存储数据
      testId: "", //编辑实验id
      is_sample: "", // 量子寄存器保持一致
      form: {
        computed: [],
        shots: []
      }, //保存弹窗
      value:'',//下拉框值
      deletebtn: true, //是否禁用删除按钮
      formLabelWidth: "120px",
      dialogFormVisible: false, //保存弹窗
      dialogFormVisibledouble: false, //两比特跨线量子弹窗
      dialogFormVisibledouble1: false, //三比特跨线量子弹窗
      centerDialogVisible: false, //运行电路编程弹窗
      checked: false, //复选框是否选中
      disabled: false, //经典寄存器是否不可编辑
      num1: 1, //经典寄存器的数值
      num: 1, //量子寄存器的数值
      ruleForm: {
        name: "", //实验名称
        describe: "", //描述
        quantumRegister: 1, //量子寄存器
        classicRegister: 1 //经典寄存器
      },
      angleRules:{
        angle:[
          {required: true, message: "请输入弧度值", trigger: "blur"},
          // {type: String, message: "请输入角度值"},
          {
            pattern: /-?((pi)([+\-*\/]\d))|\d|-?\d[+\-*\/](pi)*$/gi,
            message:"请输入合法表达式！",
            trigger: "blur"
          },
        ]
      },
      rules: {
        name: [
          { required: true, message: "请输入实验名称", trigger: "blur" },
          {
            pattern: /^(?![\._\,\-\:\d])[\_\-\:\u4e00-\u9fa5\w]+$/,
            message:"不能以特殊字符和数字开头，只可包含特殊字符中的'_'，'-'",
            trigger: "blur"
          },
          {
            validator:validateLength1,
            trigger: "blur"
          }
        ],
        describe: [
          {
            validator:validateLength,
            trigger: "blur"
          }
        ]
      }, //表单验证
      runRules:{
          name:[{required:true, message: '请选择量子计算机', trigger: 'change'}],
          shots:[{required:true, message: '请选择运行次数', trigger: 'change'}],
      },
      register: 0, //寄存器（横线）编号
      arr: [], //存放量子
      moveNode1: "", //当前正在拖动的量子
      memory_slots: 1024, //在此量子实验中使用的测量slot总数
      clbit_labels: [], //内存memory_slots列表
      currentPage: 1, //当前页
      pageSize: 5, //每页条数
      total: 0, //总页数
      device_id: "", //量子实验任务要运行的计算机ID
      schema_version: "",//用于编译qobj的schema版本
      shots: 1024,//每个量子实验的重复次数
      dataList1: [], //运行后实验的列表
      open: false, //是否编辑
      qobj_id: "",//用户生成的qobj的id
      brr: [], //存放量子改变的值以获取改变前的值
      column: 0, //量子所在列
      doubleposition: 0,//跨线元素位置
      drr: [],//跨线时存储位置变化的数组
      position: 0,//所在行
      oldStart: 0,//一开始开始位置
      newStart: 0,//结束位置
      indexList:[],//存放全为0的列号
      brr:[],//删除模拟操作数组
      code: '',//QASM代码
      editor:null,//代码编辑器
      publicCode:'',//语言编程公用部分
      quantumTwo:null,//跨线元素
      selectValue:"001",//下拉框选项值
      codeEdite:'',//语言编程代码
      isturn:true,//语言编程和电路编程的开关
      imgUrl:'',//导出电路编程图图片存储地址
      dynamicTags:['量子计算支持通过图形界面实现量子电路。基于图形界面的操作可以快速高效实现对量子门的控制，更为直观创建量子电路。'],
      verifyCode:true,//代码验证是否通过
      codeArr:[],//代码数组
      isoverLimit:false,//是否超出数量限制
      oldEnd:0,//更改前的结束位置
      isSingleangle:true,//u1门
      isDoubleangle:false,//u2门
      isMultiangle:true,//u3门
      angleQuantum:null,//带弧度的量子门
      projectionX:[],//预期投影x轴
      projectionY:[],//预期投影y轴
      densityX:[],//预期密度x轴
      densityY:[],//预期密度y轴
      densityZ:[],//预期密度z轴
      amplitudeX:[],//预期振幅X轴
      amplitudeY:[],//预期振幅y轴
      amplitudeColor:[],//预期振幅相位
      islimit:true,//是否显示三位柱状图
      dataZoom:null,//预期投影柱状图滚动条
      dataZoom1:null,//预期振幅柱状图滚动条
      isscreen:false,//是否是大屏
    };
  },
  computed: {},
  watch: {
    //监听预期振幅X轴
    amplitudeX(newValue,oldValue){
      if(newValue != oldValue){
        this.expectedAmplitude()
      }
    },
    //监听预期密度z轴
    densityZ(newValue,oldValue){
      if(newValue != oldValue){
        this.expectedDensity()
      }
    },
    //监听预期密度x轴
    densityX(newValue,oldValue){
      if(newValue != oldValue){
        this.expectedDensity()
      }
    },
    //监听预期投影概率x轴图表信息
    projectionX(newValue,oldValue){
      if(newValue != oldValue){
        this.expectedProjection()
      }
    },
    //监听量子存储数组变化
    arr(newValue,oldValue){
      if(newValue != oldValue){
        this.rexCode()
      }
    },
      //监听编辑器中代码变化
    codeEdite(newValue,oldValue){
      if(newValue != oldValue){
        this.rexCode()
      }
    }
  },
  mounted() {
    // this.getMechineInfo()
    this.expectedDensity()
    this.expectedProjection()
    this.expectedAmplitude()
    this.setTestName();
    this.addline();
    if (this.$route.query.qobj_id) {
      this.getEditInfo();
      if(this.num >4){
        return false
      }else{
        this.getChartInfo()
      }
      
    }
      this.deletebtn = false;
      this.queryTaskList();
    //创建开始定时器开始
    this.allTaskListTime = setInterval(() =>{
      this.queryTaskList();
    },15000);
      // let time = setInterval(() => {
        this.queryTaskList();
      // },5000);
      this.open = true;
      this.qasmShow()
  },
  destroyed() {
    //在页面销毁后，清除定时器
    this.Onclear();
  },
  methods:{
    //开始触屏事件操作
   touchstartHandle(refName, e) {
      const li = document.getElementsByTagName("li");
      this.moveNode1 = e.target.parentNode.parentNode.parentNode.parentNode.cloneNode(true);//克隆拖拽元素
      this.moveNode1.setAttribute("class", "online");
      this.isscreen = true
    },
    //触屏拖拽过程事件
    touchmoveHandle(refName, e) {
      let touchendDom = document.elementFromPoint(event.changedTouches[0].pageX, event.changedTouches[0].pageY)
      let _this = this;
      const lineRight = document.getElementsByClassName("right");
      let tianchong = document.getElementsByClassName("tianchong")[0];
      tianchong.setAttribute("name", "tianchong");
        if(touchendDom.getAttribute('class')=='doublequantum'||touchendDom.getAttribute('name')=='bitSvg'||touchendDom.getAttribute('name')=='tianchong'||touchendDom.getAttribute('class') == "iconfont icon-tianjiaaddto1"){
            _this.insertQuantum(e)
         }else{
          let __this = _this;
          let online
           online = document.getElementById("box" +touchendDom.getAttribute("id"));
          //拖拽两比特跨线量子
          if (__this.moveNode1.getAttribute("name") === "cx"||__this.moveNode1.getAttribute("name") === "swap"||__this.moveNode1.getAttribute("name") === "cz") {
            if(touchendDom.getAttribute("id")-0+1>=__this.num){
              __this.$message.error("请选择正确位置放置")
              return
            }
            __this.moveNode1.lastChild.setAttribute("end",touchendDom.getAttribute("id")-0+1)//设置结束位置属性
            const onlineChild = online.childNodes;
            if(onlineChild!==null){
              for (var k = onlineChild.length - 1; k >= 0; k--) {
              online.removeChild(onlineChild[k]);
            }
          }
          let max = 0;
            __this.start = touchendDom.getAttribute("id") - 0;//开始位置
            __this.end = Number(__this.start) + 1;//结束位置
            for (var q = Number(__this.start); q <= Number(__this.end); q++) {
              if (__this.arr[q].length > max) {
                max = __this.arr[q].length;
              }
            }
            if(__this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length-1]){

              if(__this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length-1].getAttribute('name')==='measure'){//最后一个元素是测量元素时
                for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                  for (var p = __this.arr[s].length; p < max-1; p++) {
                  __this.arr[s][p] = tianchong.cloneNode(true);
                }
             }
            }else{//最后一个元素不是测量元素时

              for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                for (var p = __this.arr[s].length; p < max; p++) {
                __this.arr[s][p] = tianchong.cloneNode(true);
              }
             }
            }
           }
            //保证测量在最后
            let linelength =__this.arr[Number(touchendDom.getAttribute("id"))].length;//此行长度
            let open = true;
            for (var a = 0; a < linelength; a++) {
              if(__this.arr[Number(touchendDom.getAttribute("id"))][a].getAttribute("name")==="measure"){//当是测量元素时
                  open = false;
              }
            }
              if(__this.arr[Number(touchendDom.getAttribute("id"))][linelength - 1] !='undefined'&&open==false){//当此行倒数第二个元素存在且最后一个元素是测量时
                  if (__this.arr[Number(touchendDom.getAttribute("id"))][linelength - 1].getAttribute("name") === "tianchong") {//当此行倒数第二个元素是填充时
                    for (var i = linelength - 1; i >= 0; i--) {
                      if (__this.arr[Number(touchendDom.getAttribute("id"))][i].getAttribute("name") === "measure") {//如果该行存在测量元素
                        // __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(linelength,1)
                        __this.arr[touchendDom.getAttribute("id") - 0].splice(i,0,__this.moveNode1);
                        let tianline = tianchong.cloneNode(true)
                        tianline.setAttribute("line",'line')
                        __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(i,0,tianline.cloneNode(true));
                      }
                    }
            } else if ( __this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length - 1].getAttribute("name") === "measure") {//如果该行最后一个元素是测量元素
              __this.arr[touchendDom.getAttribute("id") - 0].splice(
                __this.arr[touchendDom.getAttribute("id") - 0].length - 1,0,__this.moveNode1);
               let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(
                    __this.arr[touchendDom.getAttribute("id") - 0].length - 2,0,tianline.cloneNode(true)
                  );
            } else if (
              __this.arr[Number(touchendDom.getAttribute("id")) + 1][__this.arr[Number(touchendDom.getAttribute("id")) + 1].length - 2].getAttribute("name") === "measure"
            ) {//如果拖放的所在行的下一行的倒数第二个个元素是测量时
              __this.arr[touchendDom.getAttribute("id") - 0].splice(
                __this.arr[touchendDom.getAttribute("id") - 0 + 1].length - 1,0, __this.moveNode1
              );
              let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(
                    __this.arr[touchendDom.getAttribute("id") - 0].length - 2,0, tianline.cloneNode(true));
            }
          }else{
            let tianchongQ = tianchong.cloneNode(true)
            tianchongQ.setAttribute('line','line')
            if(__this.arr[touchendDom.getAttribute("id") - 0].length>=__this.arr[touchendDom.getAttribute("id") - 0+1].length){//当拖放的所在行比下一行的量子门数量多时
                 __this.arr[touchendDom.getAttribute("id") - 0].push(__this.moveNode1);
                let col =  __this.arr[touchendDom.getAttribute("id") - 0].length-1
              if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col]){
                if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col].getAttribute('line')=='line'){//如果拖拽的所在行的下一行的位置为填充
                  __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }else if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col].getAttribute('quantum') == 'quantum'){//如果拖拽的所在行的下一行的位置为量子比特门
                  __this.arr[touchendDom.getAttribute("id") - 0 +1].splice(col,0,tianchongQ.cloneNode(true))
                }else{//如果拖拽的所在行的下一行的位置没有元素
                  __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }
              }else{
                 __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
              }
            }else{//当拖放的所在行比下一行的量子门数量少时
              let positionCol = __this.arr[touchendDom.getAttribute("id") - 0+1].length
              __this.arr[touchendDom.getAttribute("id") - 0][positionCol] = __this.moveNode1
              __this.arr[touchendDom.getAttribute("id") - 0+1][positionCol] = tianchongQ
              for(var emp = 0;emp<=positionCol;emp++){
                if(!__this.arr[touchendDom.getAttribute("id") - 0][emp]){//拖放的线上元素之前有不存在元素的位置用填充占位
                  __this.arr[touchendDom.getAttribute("id") - 0][emp] = tianchong.cloneNode(true)
                }
              }
            }
          }
            for (var b = 0;b < __this.arr.length;b++) {
              var online1 = document.getElementById("box" +b);
                const onlineChild = online1.childNodes;
                if(onlineChild!==null){
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                  online1.removeChild(onlineChild[k]);
                }
              }
                for(var qindex=0;qindex<__this.arr[b].length;qindex++){
                  var i = __this.arr[b][qindex]
                  i.setAttribute("index", qindex);
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position", b);
                  }
                  i.setAttribute("index", qindex);
                  online.appendChild(i);
                  __this.qasmShow()
              };
            }
           } else if(__this.moveNode1.getAttribute("name") === "h"||__this.moveNode1.getAttribute("name") === "s"||__this.moveNode1.getAttribute("name") === "sdg"||__this.moveNode1.getAttribute("name") === "id"||__this.moveNode1.getAttribute("name") === "x"||__this.moveNode1.getAttribute("name") === "y"||__this.moveNode1.getAttribute("name") === "z"||__this.moveNode1.getAttribute("name") === "measure"||__this.moveNode1.getAttribute("name") === "t"||__this.moveNode1.getAttribute("name") === "tdg"
            ||__this.moveNode1.getAttribute("name") ==='u1'||__this.moveNode1.getAttribute("name") ==='u2'||__this.moveNode1.getAttribute("name") ==='u3'||__this.moveNode1.getAttribute("name") ==='rx'||__this.moveNode1.getAttribute("name") ==='ry'||__this.moveNode1.getAttribute("name") ==='rz'||__this.moveNode1.getAttribute("name") ==='x_half'||__this.moveNode1.getAttribute("name") ==='y_half'
           ) {
            //拖拽单个量子
            if (__this.arr[touchendDom.getAttribute("id") - 0].length != 0) {//如果拖放行上已经存在元素
              if (__this.arr[touchendDom.getAttribute("id") - 0][__this.arr[touchendDom.getAttribute("id") - 0].length - 1].getAttribute("idx") !== "8") {//如果拖放行的最后一个元素不是测量元素
                const onlineChild = online.childNodes;
                if(__this.arr[touchendDom.getAttribute("id") - 0][__this.arr[touchendDom.getAttribute("id") - 0].length-1].getAttribute("name")==='tianchong'&&__this.arr[touchendDom.getAttribute("id") - 0][__this.arr[touchendDom.getAttribute("id") - 0].length-1].getAttribute("line")!="line"){
                    __this.arr[touchendDom.getAttribute("id") - 0].splice(__this.arr[touchendDom.getAttribute("id") - 0].length-1,1)
                }
                __this.arr[touchendDom.getAttribute("id") - 0].push(__this.moveNode1);
                __this.arr[touchendDom.getAttribute("id") - 0].forEach((i, index) => {
                  if(i){//如果元素存在
                    if (i.getAttribute("name") !== "tianchong") {
                      i.setAttribute("quantum", "quantum");
                    }
                    
                    if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {//如果是跨线量子门
                      i.setAttribute("position",Number(touchendDom.getAttribute("id")));
                    }

                    i.setAttribute("index", index);
                    online.appendChild(i);
                    _this.qasmShow()
                   }
                  }
                );
              } else {//如果拖放行的最后一个元素是测量元素
                if (__this.moveNode1.getAttribute("idx") !== "8") {//如果拖拽的元素不是测量元素
                  const onlineChild = online.childNodes;
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                    online.removeChild(onlineChild[k]);
                  }
                  __this.arr[touchendDom.getAttribute("id") - 0].splice(
                    __this.arr[touchendDom.getAttribute("id") - 0].length - 1,
                    0,
                    __this.moveNode1
                  );
                   for (var l = 0; l < __this.arr.length; l++) {
                        let tianNum = 0;
                        let door = 'open'
                        let linetian = 0
                      for (var c = 0; c < __this.arr[l].length; c++) {
                        if (
                          __this.arr[l][c].getAttribute("name") ==="tianchong"
                        ) {//获取填充数量
                          tianNum++;
                        }
                        if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){//如果是跨线的填充
                            door = 'close'
                            linetian=c
                        }
                        if (tianNum === __this.arr[l].length&&door==='open') {//如果此行都是纯填充就置空
                          __this.arr[l] = [];

                        }else if(tianNum === __this.arr[l].length&&door==='close'){//如果此行中存在跨线填充
                        __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                    }
                      }
                      let boxNum = document.getElementById("box"+l)
                        let boxNumChild = boxNum.childNodes
                        for (var k = boxNumChild.length - 1; k >= 0; k--) {
                            boxNum.removeChild(boxNumChild[k]);
                          }
                          if(!__this.$route.query.qobj_id){//如果不存在实验id
                            __this.arr[l].forEach((ele,index)=>{
                              if(ele){
                                  ele.setAttribute("index",index)
                                  boxNum.appendChild(ele)
                              }
                        })
                      }else{//如果存在实验id
                      let item;
                      const box = document.getElementById("box" + l);
                      const boxChild = box.childNodes;
                      for (var k = boxChild.length - 1; k >= 0; k--) {
                        box.removeChild(boxChild[k]);
                      }
                      for (var j = 0; j < __this.arr[l].length; j++) {
                        if(__this.arr[l][j]){//元素存在时
                            item = __this.arr[l][j];
                            if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                              if(item.getAttribute('class')!='turnCx'){
                                 item.setAttribute("class", "online");
                              }
                            }
                          if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){//当是单量子比特门时
                            item.firstChild.lastChild.setAttribute("class",'bit')
                          }else if(item.getAttribute('name')=='cx'){//cx门时
                            if(item.getAttribute('class')!='turnCx'){
                               item.setAttribute('class','circle1')
                            }
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='swap'){//swap门时
                            item.setAttribute('class','xStart1')
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='cz'){
                            item.setAttribute('class','circle1')
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='toffoli'){
                            if(item.getAttribute('class')=='toffcircle2'){
                              item.firstChild.firstChild.setAttribute('class','quantumline4')
                            }else if(item.getAttribute('class')=='circle1'){
                              if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                  item.firstChild.firstChild.setAttribute('class','circle2')
                                }else{
                                  item.firstChild.firstChild.setAttribute('class','circle3')
                                }
                            }
                        }
                        }else{//元素不存在时用填充占位
                          __this.arr[l][j]=tianchong.cloneNode(true)
                            item = __this.arr[l][j].cloneNode(true);
                        }
                        __this.arr.forEach((ele,index) =>{
                            ele.forEach((element,inx) =>{
                              if(element){
                                element.setAttribute("index",inx)
                              }
                            })
                          })
                        box.appendChild(item);
                        };
                      }
                    }
                  __this.arr[touchendDom.getAttribute("id") - 0].forEach((i, index) => {
                    if(i){
                      if (i.getAttribute("name") !== "tianchong") {//给量子门设置属性
                        i.setAttribute("quantum", "quantum");
                      }
                      if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {//给跨线量子设置位置信息
                        i.setAttribute("position",Number(touchendDom.getAttribute("id")));
                      }
                      i.setAttribute("index", index);
                      online.appendChild(i);
                     }
                    }
                  );
                } else {//如果拖拽的元素时测量时
                  const onlineChild = online.childNodes;
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                    online.removeChild(onlineChild[k]);
                  }
                   for (var l = 0; l < __this.arr.length; l++) {
                             let tianNum = 0;
                             let door = 'open'
                             let linetian = 0
                            for (var c = 0; c < __this.arr[l].length; c++) {
                              if (__this.arr[l][c].getAttribute("name") ==="tianchong") {//获取填充数量
                                tianNum++;
                              }
                              if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){//是跨线填充元素时
                                  door = 'close'
                                  linetian=c
                              }
                              if (tianNum === __this.arr[l].length&&door==='open') {//一行都是纯填充时就置空
                                __this.arr[l] = [];

                              }else if(tianNum === __this.arr[l].length&&door==='close'){//一行都是填充但是存在跨线填充时
                              __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                            }
                          }
                            let boxNum = document.getElementById("box"+l)
                                let boxNumChild = boxNum.childNodes
                                for (var k = boxNumChild.length - 1; k >= 0; k--) {
                                    boxNum.removeChild(boxNumChild[k]);
                                  }
                                  if(!__this.$route.query.qobj_id){//不存在实验id
                                    __this.arr[l].forEach((ele,index)=>{
                                      if(ele){
                                        ele.setAttribute('index',index)
                                        boxNum.appendChild(ele)
                                      }
                                    })
                                  }else{//存在实验id
                                    let item;
                                    const box = document.getElementById("box" + l);
                                      const boxChild = box.childNodes;
                                      for (var k = boxChild.length - 1; k >= 0; k--) {
                                        box.removeChild(boxChild[k]);
                                      }
                                    for (var j = 0; j < __this.arr[l].length; j++) {
                                      if(__this.arr[l][j]){
                                          item = __this.arr[l][j]
                                        if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){//给量子比特门添加属性
                                             if(item.getAttribute('class')!='turnCx'){
                                                  item.setAttribute("class", "online");
                                               }
                                          }
                                        if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                          item.firstChild.lastChild.setAttribute("class",'bit')
                                        }else if(item.getAttribute('name')=='cx'){
                                          if(item.getAttribute('class')!='turnCx'){
                                            item.setAttribute('class','circle1')
                                          }
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='swap'){
                                          item.setAttribute('class','xStart1')
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='cz'){
                                          item.setAttribute('class','circle1')
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='toffoli'){
                                            if(item.getAttribute('class')=='toffcircle2'){
                                              item.firstChild.firstChild.setAttribute('class','quantumline4')
                                            }else if(item.getAttribute('class')=='circle1'){
                                               if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                                  item.firstChild.firstChild.setAttribute('class','circle2')
                                                }else{
                                                  item.firstChild.firstChild.setAttribute('class','circle3')
                                                }
                                            }
                                          }
                                      }else{
                                        __this.arr[l][j]=tianchong.cloneNode(true)
                                          item = __this.arr[l][j].cloneNode(true);
                                      }
                                      __this.arr.forEach((ele,index) =>{
                                          ele.forEach((element,inx) =>{
                                            if(element){
                                               element.setAttribute("index",inx)
                                            }
                                          })
                                        })
                                      box.appendChild(item);
                                      };
                                  }

                          }
                  __this.arr[touchendDom.getAttribute("id") - 0].forEach((i, index) => {//给拖放行的所有元素重新添加属性
                      if (i.getAttribute("name") !== "tianchong") {
                        i.setAttribute("quantum", "quantum");
                      }
                      if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                        i.setAttribute( "position",Number(touchendDom.getAttribute("id")));
                      }
                      i.setAttribute("index", index);
                      online.appendChild(i);

                    }
                  );
                }
                _this.qasmShow()
              }
            } else {
               for (var l = 0; l < __this.arr.length; l++) {
                    let tianNum = 0;
                      let door = 'open'
                      let linetian = 0
                    for (var c = 0; c < __this.arr[l].length; c++) {
                      if (
                        __this.arr[l][c].getAttribute("name") ==="tianchong"
                      ) {
                        tianNum++;
                      }
                      if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){
                          door = 'close'
                          linetian=c
                      }
                      if (tianNum === __this.arr[l].length&&door==='open') {
                        __this.arr[l] = [];

                      }else if(tianNum === __this.arr[l].length&&door==='close'){
                      __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                      }
                    }
                  let boxNum = document.getElementById("box"+l)
                  if(boxNum){
                    let boxNumChild = boxNum.childNodes
                    for (var k = boxNumChild.length - 1; k >= 0; k--) {
                        boxNum.removeChild(boxNumChild[k]);
                      }
                    if(!__this.$route.query.qobj_id){
                        __this.arr[l].forEach((ele,index)=>{
                          if(ele){
                             ele.setAttribute('index',index)
                            boxNum.appendChild(ele)
                          }
                        })
                      }else{//存在实验id进行属性的重新设置
                            let item;
                            const box = document.getElementById("box" + l);
                            const boxChild = box.childNodes;
                            for (var k = boxChild.length - 1; k >= 0; k--) {
                              box.removeChild(boxChild[k]);
                            }
                            for (var j = 0; j < __this.arr[l].length; j++) {
                              if(__this.arr[l][j]){
                                item = __this.arr[l][j];
                              if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                 if(item.getAttribute('class')!='turnCx'){
                                     item.setAttribute("class", "online");
                                  }
                              }
                              if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                item.firstChild.lastChild.setAttribute("class",'bit')
                              }else if(item.getAttribute('name')=='cx'){
                                if(item.getAttribute('class')!='turnCx'){
                                  item.setAttribute('class','circle1')
                                }
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                              }else if(item.getAttribute('name')=='swap'){
                                item.setAttribute('class','xStart1')
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                              }else if(item.getAttribute('name')=='cz'){
                                item.setAttribute('class','circle1')
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                               }else if(item.getAttribute('name')=='toffoli'){
                                  if(item.getAttribute('class')=='toffcircle2'){
                                    item.firstChild.firstChild.setAttribute('class','quantumline4')
                                  }else if(item.getAttribute('class')=='circle1'){
                                     if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                        item.firstChild.firstChild.setAttribute('class','circle2')
                                      }else{
                                        item.firstChild.firstChild.setAttribute('class','circle3')
                                      }
                                  }
                                }
                              }else{
                                __this.arr[l][j]=tianchong.cloneNode(true)
                                  item = __this.arr[l][j].cloneNode(true);
                                }
                                __this.arr.forEach((ele,index) =>{
                                  ele.forEach((element,inx) =>{
                                    if(element){
                                       element.setAttribute("index",inx)
                                    }
                                  })
                                })
                                box.appendChild(item);
                          };
                      }
                  }
              }
              __this.arr[touchendDom.getAttribute("id") - 0].push(__this.moveNode1);
              __this.arr[touchendDom.getAttribute("id") - 0].forEach((i, index) => {
                if(i){
                  if (i.getAttribute("name") !== "tianchong") {
                    i.setAttribute("quantum", "quantum");
                  }
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position",Number(touchendDom.getAttribute("id")));
                    // i.setAttribute("position", i);
                  }
                  i.setAttribute("index", index);
                  online.appendChild(i);
                 }
                }
               );
              __this.qasmShow()
            }
           }else if(__this.moveNode1.getAttribute("name") ==='toffoli'){
             let start = touchendDom.getAttribute("id") - 0
             let middle = touchendDom.getAttribute("id") - 0+1
             let end = touchendDom.getAttribute("id") - 0+2
             _this.moveNode1.setAttribute('middle',middle)
             _this.moveNode1.setAttribute('start',start)
             _this.moveNode1.setAttribute('end',end)
            if(touchendDom.getAttribute("id")-0+1>=_this.num){
              _this.$message.error("请选择正确位置放置")
              return
            }
            if(end>=_this.num){
              _this.$message.error("请选择正确位置放置")
              return
            }
            __this.moveNode1.lastChild.setAttribute("end",touchendDom.getAttribute("id")-0+1)//设置结束位置属性
            const onlineChild = online.childNodes;
            if(onlineChild!==null){
              for (var k = onlineChild.length - 1; k >= 0; k--) {
              online.removeChild(onlineChild[k]);
            }
          }
          let max = 0;
            __this.start = touchendDom.getAttribute("id") - 0;//开始位置
            __this.end = Number(__this.start) + 1;//结束位置
            for (var q = Number(__this.start); q <= Number(__this.end); q++) {
              if (__this.arr[q].length > max) {
                max = __this.arr[q].length;
              }
            }
            if(__this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length-1]){

              if(__this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length-1].getAttribute('name')==='measure'){//最后一个元素是测量元素时
                for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                  for (var p = __this.arr[s].length; p < max-1; p++) {
                  __this.arr[s][p] = tianchong.cloneNode(true);
                }
             }
            }else{//最后一个元素不是测量元素时

              for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                for (var p = __this.arr[s].length; p < max; p++) {
                __this.arr[s][p] = tianchong.cloneNode(true);
              }
             }
            }
           }
            //保证测量在最后
            let linelength =__this.arr[Number(touchendDom.getAttribute("id"))].length;//此行长度
            let open = true;
            for (var a = 0; a < linelength; a++) {
              if(__this.arr[Number(touchendDom.getAttribute("id"))][a].getAttribute("name")==="measure"){//当是测量元素时
                  open = false;
              }
            }
              if(__this.arr[Number(touchendDom.getAttribute("id"))][linelength - 1] !='undefined'&&open==false){//当此行倒数第二个元素存在且最后一个元素是测量时
                  if (__this.arr[Number(touchendDom.getAttribute("id"))][linelength - 1].getAttribute("name") === "tianchong") {//当此行倒数第二个元素是填充时
                    for (var i = linelength - 1; i >= 0; i--) {
                      if (__this.arr[Number(touchendDom.getAttribute("id"))][i].getAttribute("name") === "measure") {//如果该行存在测量元素
                        // __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(linelength,1)
                        __this.arr[touchendDom.getAttribute("id") - 0].splice(i,0,__this.moveNode1);
                        let tianline = tianchong.cloneNode(true)
                        tianline.setAttribute("line",'line')
                        __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(i,0,tianline.cloneNode(true));
                      }
                    }
            } else if ( __this.arr[Number(touchendDom.getAttribute("id"))][__this.arr[Number(touchendDom.getAttribute("id"))].length - 1].getAttribute("name") === "measure") {//如果该行最后一个元素是测量元素
              __this.arr[touchendDom.getAttribute("id") - 0].splice(
                __this.arr[touchendDom.getAttribute("id") - 0].length - 1,0,__this.moveNode1);
               let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(
                    __this.arr[touchendDom.getAttribute("id") - 0].length - 2,0,tianline.cloneNode(true)
                  );
            } else if (
              __this.arr[Number(touchendDom.getAttribute("id")) + 1][__this.arr[Number(touchendDom.getAttribute("id")) + 1].length - 2].getAttribute("name") === "measure"
            ) {//如果拖放的所在行的下一行的倒数第二个个元素是测量时
              __this.arr[touchendDom.getAttribute("id") - 0].splice(
                __this.arr[touchendDom.getAttribute("id") - 0 + 1].length - 1,0, __this.moveNode1
              );
              let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[touchendDom.getAttribute("id") - 0 + 1].splice(
                    __this.arr[touchendDom.getAttribute("id") - 0].length - 2,0, tianline.cloneNode(true));
            }
          }else{
            let tianchongQ = tianchong.cloneNode(true)
            tianchongQ.setAttribute('line','line')
            if(__this.arr[touchendDom.getAttribute("id") - 0].length>=__this.arr[touchendDom.getAttribute("id") - 0+1].length){//当拖放的所在行比下一行的量子门数量多时
                 __this.arr[touchendDom.getAttribute("id") - 0].push(__this.moveNode1);
                let col =  __this.arr[touchendDom.getAttribute("id") - 0].length-1
              if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col]){
                if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col].getAttribute('line')=='line'){//如果拖拽的所在行的下一行的位置为填充
                  __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }else if(__this.arr[touchendDom.getAttribute("id") - 0 +1][col].getAttribute('quantum') == 'quantum'){//如果拖拽的所在行的下一行的位置为量子比特门
                  __this.arr[touchendDom.getAttribute("id") - 0 +1].splice(col,0,tianchongQ.cloneNode(true))
                }else{//如果拖拽的所在行的下一行的位置没有元素
                  __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }
              }else{
                 __this.arr[touchendDom.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
              }
            }else{//当拖放的所在行比下一行的量子门数量少时
              let positionCol = __this.arr[touchendDom.getAttribute("id") - 0+1].length
              __this.arr[touchendDom.getAttribute("id") - 0][positionCol] = __this.moveNode1
              __this.arr[touchendDom.getAttribute("id") - 0+1][positionCol] = tianchongQ
              for(var emp = 0;emp<=positionCol;emp++){
                if(!__this.arr[touchendDom.getAttribute("id") - 0][emp]){//拖放的线上元素之前有不存在元素的位置用填充占位
                  __this.arr[touchendDom.getAttribute("id") - 0][emp] = tianchong.cloneNode(true)
                }
              }
            }
          }
            for (var b = 0;b < __this.arr.length;b++) {
              var online1 = document.getElementById("box" +b);
                const onlineChild = online1.childNodes;
                if(onlineChild!==null){
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                  online1.removeChild(onlineChild[k]);
                }
              }
                for(var qindex=0;qindex<__this.arr[b].length;qindex++){
                  var i = __this.arr[b][qindex]
                  i.setAttribute("index", qindex);
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position", b);
                  }
                  i.setAttribute("index", qindex);
                  online.appendChild(i);
                  __this.qasmShow()
              };
            }
           }
          }
        
      

    },
    //获取图表信息
    async  getChartInfo(){
      this.instructions = [];
      this.qubit_labels = [];
      this.header = {};
      let beforeline = 0
      let  column = 0
      let maxlength = 0
      this.memory_slots = 0
      for(var h=0;h<this.arr.length;h++){
        if(this.arr[h].length>maxlength){//获取线路图的最大长度
          maxlength = this.arr[h].length
        }
      }
      for (var j = beforeline; j < maxlength; j++) {
        for(var i=0;i<this.arr.length;i++){
          if(this.arr[i][j]){
            let  name = this.arr[i][j].getAttribute("name");//元素名称
          // this.qubits = [i];
          if(name==='cx'||name==='swap'||name==='cz'||name==='toffoli'){//多量子比特门时
            column = Number(this.arr[i][j].getAttribute("index"))//该量子比特的所在列
            for(var a=0;a<this.num;a++){
              for(var b=beforeline;b<column;b++){
                if(this.arr[a][b]!==undefined){
                  const namel = this.arr[a][b].getAttribute('name')
                  if(namel !=='tianchong'&&namel !='cx'&&namel !='swap'&&namel !='cz'&&namel!=='measure'){//该量子比特为单量子比特且不为测量元素时
                    if(namel=='u1'||namel=='rx'||namel=='ry'||namel=='rz'){
                       let angle = this.arr[a][b].getAttribute('angle')-0
                       this.instructions.push({name:namel,qubits:[a],angle:[angle]})
                     }else if(namel=='u2'){
                        let angle1 = this.arr[a][b].getAttribute('angle1')-0
                        let angle2 = this.arr[a][b].getAttribute('angle2')-0
                        this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2]})
                     }else if(namel=='u3'){
                        let angle1 = this.arr[a][b].getAttribute('angle1')-0
                        let angle2 = this.arr[a][b].getAttribute('angle2')-0
                        let angle3 = this.arr[a][b].getAttribute('angle3')-0
                        this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2,angle3]})
                     }else{
                        this.instructions.push({name:namel,qubits:[a]})
                     }
                  }
                }
              }
            }
            for(var m=0;m<this.num;m++){
              if(this.arr[m][column]){
                let name = this.arr[m][column].getAttribute("name")//元素名称
               if(name==='cx'||name==='swap'||name==='cz'){//多量子比特门时
                const start = Number(this.arr[m][column].getAttribute("position"))
                let end
                if(this.arr[m][column].getAttribute('class')=='turnCx'){
                  end = Number(this.arr[m][column].firstChild.getAttribute("end"))
                }else{
                  end = Number(this.arr[m][column].lastChild.getAttribute("end"))
                }
                this.qubits = [start,end]
                this.instructions.push({name:name,qubits:this.qubits})
              }else if(name==='toffoli'){
                  const start = Number(this.arr[m][column].getAttribute("start"))
                  const middle = Number(this.arr[m][column].getAttribute("middle"))
                  const end = Number(this.arr[m][column].getAttribute("end"))
                  this.qubits = [start,middle,end]
                  this.instructions.push({name:name,qubits:this.qubits})
              }else if(name !=='tianchong'&&name !='cx'&&name !='swap'&&name !='cz'&&name !=='measure'){//该量子比特为单量子比特且不为测量元素时
                this.qubits = [m]
                // this.instructions.push({name:name,qubits:this.qubits})
                if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                   let angle = this.arr[m][column].getAttribute('angle')-0
                   this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                 }else if(name=='u2'){
                    let angle1 = this.arr[m][column].getAttribute('angle1')-0
                    let angle2 = this.arr[m][column].getAttribute('angle2')-0
                    this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                 }else if(name=='u3'){
                    let angle1 = this.arr[m][column].getAttribute('angle1')-0
                    let angle2 = this.arr[m][column].getAttribute('angle2')-0
                    let angle3 = this.arr[m][column].getAttribute('angle3')-0
                    this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                 }else{
                   this.instructions.push({name:name,qubits:this.qubits})
                 }
               }
              }
            }
           beforeline = column +1
          }
          }
        }
      }
      if(beforeline<=maxlength){
           for(var k=0;k<this.arr.length;k++){
             for(var g=beforeline;g<maxlength;g++){
               if(this.arr[k][g]){
                   name = this.arr[k][g].getAttribute("name")
                  if(name!=='measure'){//不为测量元素的量子
                    this.qubits = [k]
                    // this.instructions.push({name:name,qubits:this.qubits})
                     if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                       let angle =this.arr[k][g].getAttribute('angle')-0
                       this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                     }else if(name=='u2'){
                        let angle1 =this.arr[k][g].getAttribute('angle1')-0
                        let angle2 =this.arr[k][g].getAttribute('angle2')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                     }else if(name=='u3'){
                        let angle1 =this.arr[k][g].getAttribute('angle1')-0
                        let angle2 =this.arr[k][g].getAttribute('angle2')-0
                        let angle3 =this.arr[k][g].getAttribute('angle3')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                     }else{
                       this.instructions.push({name:name,qubits:this.qubits})
                     }
                 }
               }
             }
           }
         }
         for (var j = 0; j < this.arr.length; j++) {
           this.arr[j].forEach(ele => {
             const name = ele.getAttribute("name");
             if (name === "measure") {//测量元素的操作
               this.memory_slots++;
               this.instructions.push({
                 memory: [j],
                 name: name,
                 qubits: [j]
               });
             }
           });
         }
         this.arr.forEach((ele, index) => {
           this.qubit_labels.push(["q", index]);
         });
         this.clbit_labels=[]
         for (var k = 0; k < this.memory_slots; k++) {
           this.clbit_labels.push(["c", k]);
         }
         this.header = {
           creg_sizes: [["c", this.num1]], //[creg_name, size]列表
           name: "circuit0", //提交的此量子实验的量子线路名称
           qubit_labels: this.qubit_labels, //[qreg_name, n]，用于指示相应的物理量子比特作为第n个量子比特的量子寄存器qreg_name
           qreg_sizes: ["q", this.num], //[qreg_name, size]的列表，用于指定QASM量子寄存器和它们的尺寸
           n_qubits: this.num, //后端机器的量子比特数，等于量子实验中最大的量子比特数
           memory_slots: this.memory_slots, //在此量子实验中使用的测量slot总数
           clbit_labels: this.clbit_labels //内存memory_slots列表，每一个元素是[creg_name, n]，用于指示经典寄存器creg_name的第n个元素对应的memory slot
         };
         this.qubitdata = {
           experiments: [
             {
               instructions: this.instructions, //量子实验执行的量子指令列表
               header: this.header,
               config: {
                 n_qubits: this.num, //后端机器的量子比特数
                 memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
               }
             }
           ],
           schema_version: this.schema_version, //用于编译qobj的schema版本
           type: this.selectMechine, //用于量子实验的指令类型，QASM还是PULSE
           qobj_id: this.qobj_id, //用户生成的qobj的id
           device_id: this.device_id?this.device_id:'001', //量子实验任务要运行的计算机ID
           device_name: this.device_name,
           // user_id: this.user_id,
           config: {
             shots: this.shots, //每个量子实验的重复次数
             n_qubits: this.num, //后端机器的量子比特数
             memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
           }
         };
              const params = {
              experiments: JSON.parse(
                JSON.stringify(Object.values(this.qubitdata)[0])
              ),
              schema_version: Object.values(this.qubitdata)[1], //用于编译qobj的schema版本
              type: Object.values(this.qubitdata)[2], //用于量子实验的指令类型，QASM还是PULSE
              qobj_id: Object.values(this.qubitdata)[3], //用户生成的qobj的id
              device_id: Object.values(this.qubitdata)[4], //量子实验任务要运行的计算机ID
              device_name: Object.values(this.qubitdata)[5],
              // user_id: Object.values(this.qubitdata)[6],
              config: JSON.parse(JSON.stringify(Object.values(this.qubitdata)[6])),
              programming:this.publicCode+this.code
            };
         const data = {
           d3_data:[
             ["0", "0", "1.00000000", "0"],
             ["0", "1", "0", "0"],
             ["1", "0", "0", "0"],
             ["1", "1", "0", "0"]
           ],
           d3_xy:["0", "1"],
           x:["0"],
           y_mod:["1.00000000"],
           y_percent:["1.00000000"],
           y_phase:["0.00000000"]
         }

         this.projectionX = data.x
         this.projectionY = data.y_percent
         this.densityX = data.d3_xy
         this.densityY = data.d3_xy
         this.densityZ = data.d3_data
         this.amplitudeX = data.x
         this.amplitudeY = data.y_mod
         this.amplitudeColor = data.y_phase
    },
     //预期密度矩阵
     expectedDensity(){
       const $ = this.$echarts.init(document.getElementById("charts0"));
       var data = this.densityZ
        $.setOption({
          visualMap: {
          left: "92%",
          min: -Math.PI,
          max: Math.PI,
          inRange: {
            color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
            }
          },
          tooltip: {
            formatter: function (params) {
              return (
                '['+params.value[0]+','+params.value[1]+'] = '+ (params.value[2]-0).toFixed(4)+
                "<br/>" +
                "相位角度" +
                " : " +(params.value[3]-0).toFixed(4)
               
              );
            },
          },
           xAxis3D: {
              type: 'category',
              data: this.densityX
          },
           yAxis3D: {
            type: 'category',
            data: this.densityY
          },
           zAxis3D: {
              type: 'value'
          },
          grid3D: {
              boxWidth: 100,
              boxDepth: 100,
              viewControl: {
                  // projection: 'orthographic'
              },
              light: {
                  main: {
                      intensity: 1.2,
                      shadow: false
                  },
                  ambient: {
                      intensity: 0.3
                  }
              }
            },
          series: [{
                type: 'bar3D',
                data: data.map(function (item) {
                    return {
                        value: [item[0], item[1], item[2],item[3]],
                    }
                }),
                shading: 'lambert',
                label: {
                    fontSize: 16,
                    borderWidth: 1
                },

                emphasis: {
                    label: {
                        show:false,
                        fontSize: 20,
                        color: '#900'
                    },
                    itemStyle: {
                        color: '#900'
                    }
                }
            }]
        })
     },
    //预期振幅柱状图
    expectedAmplitude(){
      const $ = this.$echarts.init(document.getElementById("charts1"));
      var data=[]
      var data1=[]
       var that = this
      this.amplitudeX.forEach((item,index)=>{
        data=[]
        data.push(index)
        data.push(that.amplitudeY[index])
        data.push(that.amplitudeColor[index])
        data1.push(data)
      })
      if(this.amplitudeX.length>8){
            let endValue = 0
            switch (this.amplitudeX.length) {
              case 16:
                endValue = 50
                break;
              case 32:
                endValue = 22
                break;
              case 64:
                endValue = 11
                break;
            }
            this.dataZoom1=[{
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                left: '9%',
                bottom: -5,
                start: 0,
                end: endValue,//初始化滚动条
                zoomLock:true
            }]
          }else{
            this.dataZoom1=null
          }
        $.setOption({
          visualMap: {
            left: "92%",
            min: -Math.PI,
            max: Math.PI,
            precision:4,
            hoverLink:true,
            inRange: {
                color: ['#313695', '#4575b4', '#74add1', '#abd9e9', '#e0f3f8', '#ffffbf', '#fee090', '#fdae61', '#f46d43', '#d73027', '#a50026']
              }
          },
          dataZoom:this.dataZoom1,
          tooltip: {
            axisPointer: {
              type: "shadow",
            },
            trigger: "axis",
            formatter: function (params) {
              return (
                params[0].name +
                "<br/>" +
                "Amplitude:" +
                (params[0].value[1]-0).toFixed(4) +
                "<br/>"+'相位:'+(that.amplitudeColor[params[0].dataIndex]-0).toFixed(4)
              );
            },
          },
          // legend: {
          //   data: ["测量结果"],
          // },
          xAxis: {
            data: this.amplitudeX,
            axisLine: {
              onZero: true,
            },
            axisTick: {
              show: false,
            },
          },
          // dataZoom: [0.4,0.3,0.6,1],
          yAxis: {
            boundaryGap: false,
            name: "预期结果",
            type: "value",
            min: 0,
            max: 1,
          },
          series: [
            {
              name: "概率",
              type: "bar",
              data: data1,
              color: "#5EA7FB",
              barWidth: 30,
              itemStyle: {
                normal: {
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                    },
                    // color: "green",
                    show: false, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 14,
                    },
                  },
                },
              },
            },
          ],
        });
    },
    //预期投影概率柱状图
    expectedProjection(){
       const $ = this.$echarts.init(document.getElementById("charts"));
       if(this.projectionX.length>8){
            let endValue = 0
            switch (this.projectionX.length) {
              case 16:
                endValue = 50
                break;
              case 32:
                endValue = 22
                break;
              case 64:
                endValue = 11
                break;
            }
            this.dataZoom=[{
                type: 'slider',
                show: true,
                xAxisIndex: [0],
                left: '9%',
                bottom: -5,
                start: 0,
                end: endValue,//初始化滚动条
                zoomLock:true
            }]
          }else{
            this.dataZoom=null
          }
        $.setOption({
          tooltip: {
            axisPointer: {
              type: "shadow",
            },
            trigger: "axis",
          },
          xAxis: {
            data:this.projectionX,
            axisLine: {
              onZero: true,
            },
            axisTick: {
              show: false,
            },
          },
          dataZoom:this.dataZoom,
          yAxis: {
            boundaryGap: false,
            name: "测量结果",
            type: "value",
            min: 0,
            max: 1,
          },
          series: [
            {
              name: "概率",
              type: "bar",
              data: this.projectionY,
              color: "#5EA7FB",
              barWidth: 30,
              itemStyle: {
                normal: {
                  label: {
                    normal: {
                      show: true,
                      position: "top",
                    },
                    // color: "green",
                    show: false, //开启显示
                    position: "top", //在上方显示
                    textStyle: {
                      //数值样式
                      color: "black",
                      fontSize: 14,
                    },
                  },
                },
              },
            },
          ],
        });
    },
    //角度更改事件
    angleChange(e){
      // this.angleform.angle = e -0
      // this.qasmShow()
      // this.angleform.angle = 1.570796
    },
    //更改角度
    changeAngle(){
      const _this = this
      this.$refs['angleForm'].validate((valid)=>{
          if(valid){
            // this.codeChange()
            if(_this.angleQuantum.getAttribute('name') == 'u1'||_this.angleQuantum.getAttribute('name') == 'rx'||_this.angleQuantum.getAttribute('name') == 'ry'||_this.angleQuantum.getAttribute('name') == 'rz'){
              try {
                eval(_this.angleform.angle.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              var degreeVal = eval(_this.angleform.angle.replace(/pi/gi,'3.141593'))
              _this.angleform.angle = degreeVal
             _this.angleQuantum.setAttribute('angle',_this.angleform.angle.toFixed(6))
            //  _this.angle = _this.angleform.angle
            }else if(_this.angleQuantum.getAttribute('name') == 'u2'){
              try {
                eval(_this.angleform.angle1.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              try {
                eval(_this.angleform.angle2.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              var degreeVal = eval( _this.angleform.angle1.replace(/pi/gi,'3.141593'))
              _this.angleform.angle1 = degreeVal
              var degreeVal = eval( _this.angleform.angle2.replace(/pi/gi,'3.141593'))
              _this.angleform.angle2 = degreeVal
              _this.angleQuantum.setAttribute('angle1',_this.angleform.angle1.toFixed(6))
              _this.angleQuantum.setAttribute('angle2',_this.angleform.angle2.toFixed(6))
            }else if(_this.angleQuantum.getAttribute('name') == 'u3'){
              try {
                eval(_this.angleform.angle1.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              try {
                eval(_this.angleform.angle3.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              try {
                eval(_this.angleform.angle4.replace(/pi/gi,'3.141593'))
              } catch (error) {
                this.$message.error('请输入合法表达式！')
                return false
              }
              var degreeVal = eval(_this.angleform.angle1.replace(/pi/gi,'3.141593'))
              _this.angleform.angle1 = degreeVal
              var degreeVal = eval( _this.angleform.angle3.replace(/pi/gi,'3.141593'))
              _this.angleform.angle3 = degreeVal
              var degreeVal = eval(_this.angleform.angle4.replace(/pi/gi,'3.141593'))
              _this.angleform.angle4 = degreeVal
              _this.angleQuantum.setAttribute('angle1',_this.angleform.angle1.toFixed(6))
              _this.angleQuantum.setAttribute('angle2',_this.angleform.angle3.toFixed(6))
              _this.angleQuantum.setAttribute('angle3',_this.angleform.angle4.toFixed(6))
            }
            this.qasmShow()
            this.dialogEditAngle = false
          }else{
           this.$message.error('请输入合法数值或表达式！')
           return false
          }
      })
      
    },
    //去帮助文档
    toHelp(){
      window.open("http://10.58.96.25:7777/help/3-quickstart.html#量子门词汇表说明",'_blank')
    },
    //返回上一页
    back(){
      // this.$router.push({
      //   path:'/circuitProgram/index'
      // })
    },
    //删除标签
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    //下载导出代码
    downloadCode(){
     //定义文件内容，类型必须为Blob 否则createObjectURL会报错
      let content = new Blob([this.publicCode+this.code])
       //生成url对象
      let urlObject = window.URL || window.webkitURL || window
      let url = urlObject.createObjectURL(content)
      //生成<a></a>DOM元素
      let el = document.createElement('a')
      //链接赋值
      el.href = url
      el.download ="语言编程代码.txt"
      //必须点击否则不会下载
      el.click()
      //移除链接释放资源
      urlObject.revokeObjectURL(url)
 },
    //导出电路编程图
/**
  * 将页面指定节点内容转为图片
  * 1.拿到想要转换为图片的内容节点DOM；
  * 2.转换，拿到转换后的canvas
  * 3.转换为图片
*/
clickGeneratePicture() { //生成图片
    html2canvas(this.$refs.imageDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL("image/png",1); //可将 canvas 转为 base64 格式
        var eleLink = document.createElement("a");
        eleLink.href = this.imgUrl; // 转换后的图片地址
        eleLink.download = "电路编程图";
        document.body.appendChild(eleLink);
        // 触发点击
        eleLink.click();
        // 然后移除
        document.body.removeChild(eleLink);
    });
},
    //创建语言编辑器
    createQasm(){
      let mime = 'text/html'
      let editor = CodeMirror.fromTextArea(this.$refs.mycode, {
      mode: mime, // 选择对应代码编辑器的语言
      indentWithTabs: true,
      smartIndent: true,
      lineNumbers: true,
      lineWrapping:true,
      matchBrackets: true,
      hintOptions: {
        // 自定义提示选项
        tables: {
          users: ['name', 'score', 'birthDate'],
          countries: ['name', 'population', 'size']
        }
      }
    })
    this.codeChange(editor)
    this.editor = editor
    return editor
    },
    //语言编程数组变化
    codeChange(editor){
      let that = this
      let zrr=[]
      editor.on('change', function () {//代码编辑器中发生变化时执行的方法
      let codeEdite = editor.getValue().substring(62)//截取纯量子门代码部分
      // that.code = codeEdite.substring(2)
      that.codeEdite = codeEdite
      let qrr=[]
      qrr = codeEdite.split(';\n')//按量子门把代码分开放到数组中
      let maxcol = 0 //量子门的最大列
      let prr=[]
      let indexDict = []
      for(var l=0;l<that.num;l++){//量子寄存器（线）的数量
        indexDict.push(0)
      }
      for(var i=0;i<that.arr.length;i++){//获取到此时电路中量子门中的最大列
        if(maxcol<that.arr[i].length){
          maxcol = that.arr[i].length
        }
      }
      for(var j=0;j<100;j++){
          prr.push([])
      }
       let num = 0
      for(var m=0;m<qrr.length;m++){
        qrr[m]=qrr[m].replace(/[\r\n]/g,"");//去除多余换行
      }
      let measureNum = 0
      let frequency = 0 
      let tempArr=[]
      // console.log(qrr)
      for(var q=0;q<qrr.length-1;q++){
       
       let tempList = qrr[q].split(' ')//把每个量子门代码把名字和位置信息拆分
       let name = tempList[0]//量子门名称
       let rowList = []
       rowList = tempList[2].replace(/[\rq]/g,'').replace(/\[|]/g,'').split(',')//获取此量子门的位置
      if(rowList.length==1||rowList[1].substr(0, 1)=='('){//如果是单量子比特门
          if(name == 'measure'){
              measureNum++
              if(tempArr.indexOf(rowList[0])==-1){
                tempArr.push(rowList[0])
              }else{
                frequency++
              }
              if(measureNum>=1&&frequency>=1){
                  that.$message.error('测量门数量超出限制！')
                  that.qasmShow()
                  break
              }else{
                indexDict[Number(rowList[0])] = indexDict[Number(rowList[0])] + 1
              }
          }else{
            indexDict[Number(rowList[0])] = indexDict[Number(rowList[0])] + 1
          }
          
          if(Number(indexDict[Number(rowList[0])])-1>=100){
          that.$message({
            message: '超出数量限制',
            type: 'warning',
            duration:6000
          });
          that.isoverLimit = true
            break
          }else{
            prr[Number(indexDict[Number(rowList[0])])-1].push(qrr[q])
            that.isoverLimit = false
          }
      }else if(name=='cz'||name=='cx'||name=='swap') {//如果是两量子比特门
        let maxindex = 0
        let min=0 
        let max=0
        min = Math.min(Number(rowList[0]), Number(rowList[1]))  
        max = Math.max(Number(rowList[0]), Number(rowList[1]))  
        for(var i=min;i<=max;i++){
            if(indexDict[i]>maxindex){
              maxindex = indexDict[i]
           }
         }
         for(var i=min;i<=max;i++){
           indexDict[i] = maxindex + 1
         }
         if(Number(indexDict[Number(rowList[0])])-1>=100){
           that.$message({
            message: '超出数量限制',
            type: 'warning',
            duration:6000
          });
          that.isoverLimit = true
            break
          }else{
            prr[Number(indexDict[Number(rowList[0])])-1].push(qrr[q])
            that.isoverLimit = false
          }
      }else if(name == 'toffoli'){
        let maxindex1 = 0
        let min1=0 
        let max1=0
        min1 = Math.min(Number(rowList[0]), Number(rowList[1]),Number(rowList[2]))  
        max1 = Math.max(Number(rowList[0]), Number(rowList[1]),Number(rowList[2]))  
        for(var i=min1;i<=max1;i++){
            if(indexDict[i]>maxindex1){
              maxindex1 = indexDict[i]
           }
         }
         for(var i=min1;i<=max1;i++){
           indexDict[i] = maxindex1 + 1
         }
         if(Number(indexDict[Number(rowList[0])])-1>=100){
           that.$message({
            message: '超出数量限制',
            type: 'warning',
            duration:6000
          });
          that.isoverLimit = true
            break
          }else{
            prr[Number(indexDict[Number(rowList[0])])-1].push(qrr[q])
            that.isoverLimit = false
          }
      }
    }
      zrr=[]
      for(var r=0;r<that.arr.length;r++){
        zrr.push([])
      }
      const tianchong = document.getElementsByClassName("tianchong")[0];
      prr.forEach((item,index)=>{//对实时变化后的代码转化成量子电路编程图
        item.forEach(ele1=>{
          let ele = ele1.split(' ')
           var quantumStart1
           var start
           var endInfo
           var end 
           var angleSimple=0
           var angleDouble1=0
           var angleDouble2=0
           var angletrible1 =0
           var angletrible2 =0
           var angletrible3 =0
           if(ele){
            if(ele[0]=='cx'||ele[0]=='swap'||ele[0]=='cz'){//如果是多量子比特门
            if(ele[2].length > 9){
              if(ele[2].charAt(3)==']'){
                start = ele[2].charAt(2)-0
              }else{
                start = ele[2].substr(2,2)-0
              }
              if(ele[2].charAt(ele[2].length-3)=='['){
                 end = ele[2].charAt(ele[2].length-2)-0
              }else{
                end = ele[2].substr((ele[2].length-3),2)-0
              }
           
            }else{
              start = ele[2].charAt(2)-0
              end = ele[2].charAt(ele[2].length-2)-0
            }
            
             if (ele[0]=='cx'&&end!=start) {//如果是cx门
               if(end>start){
                 const quantumStart = document.getElementsByClassName("circle")[0];
                 const quantumline = document.getElementsByClassName("quantumline")[0];
                 quantumStart1 = quantumStart.cloneNode(true);
                 const quantumline1 = quantumline.cloneNode(true);
                 quantumStart1.setAttribute("class", "circle1");
                 quantumStart1.setAttribute("position", start);
                 quantumStart1.setAttribute("name", "cx");
                 quantumline1.setAttribute("class", "quantumline1");
                 const quantumEnd = quantumStart.cloneNode(true);
                 quantumEnd.setAttribute("class", "circle2");
                 quantumEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
                 quantumEnd.setAttribute("name", "circleEnd");
                 quantumline1.appendChild(quantumEnd);
                 quantumStart1.appendChild(quantumline1);
                 let quantumbox = document.createElement("span");
                 quantumbox.setAttribute("class", "doublequantum");
                 quantumbox.setAttribute("end", end);
                 const close = document.getElementsByClassName("close")[0].cloneNode(true);
                 let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);//编辑按钮
                 quantumbox.appendChild(close);
                 quantumbox.appendChild(edit);//编辑按钮
                 //  quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:-14px;left:-14px;";
                 quantumbox.style.display = 'inline-block'
                 quantumbox.style.width = '40px'
                 quantumbox.style.height = '90px'
                 quantumbox.style.border = '0px dashed #EAEAEA'
                 quantumbox.style.position = 'absolute'
                 quantumbox.style.top = '-14px'
                 quantumbox.style.left = '-14px'
                 //  quantumbox.setAttribute('class','cxQuantum')
                 quantumbox.style.height = 47 * (end - start + 1) + "px";
                 quantumStart1.appendChild(quantumbox);
               }else if(end < start){
                 const quantumStart = document.getElementsByClassName("circle")[0];
                 const quantumline = document.getElementsByClassName("quantumline")[0];
                 quantumStart1 = quantumStart.cloneNode(true);
                 const quantumline1 = quantumline.cloneNode(true);
                 quantumStart1.setAttribute("class", "circle1");
                 quantumStart1.setAttribute("position", start);
                 quantumStart1.setAttribute("name", "cx");
                 quantumline1.setAttribute("class", "quantumline1");
                 const quantumEnd = quantumStart.cloneNode(true);
                 quantumEnd.setAttribute("class", "circle2");
                 quantumEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
                 quantumEnd.setAttribute("name", "circleEnd");
                 quantumline1.appendChild(quantumEnd);
                 quantumStart1.appendChild(quantumline1);
                 let quantumbox = document.createElement("span");
                 quantumbox.setAttribute("class", "doublequantum");
                 quantumbox.setAttribute("end", end);
                 const close = document.getElementsByClassName("close")[0].cloneNode(true);
                 let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);//编辑按钮
                 quantumbox.appendChild(close);
                 quantumbox.appendChild(edit);//编辑按钮
                 //  quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:-14px;left:-14px;";
                 quantumbox.style.display = 'inline-block'
                 quantumbox.style.width = '40px'
                 quantumbox.style.height = '90px'
                 quantumbox.style.border = '0px dashed #EAEAEA'
                 quantumbox.style.position = 'absolute'
                 quantumbox.style.top = '-14px'
                 quantumbox.style.left = '-14px'
                 //  quantumbox.setAttribute('class','cxQuantum')
                 quantumbox.style.height = 47 * (Math.abs(end - start) + 1) + "px";
                 quantumStart1.appendChild(quantumbox);
                const firstchild = quantumStart1.firstChild.firstChild
                quantumStart1.removeChild(quantumStart1.firstChild)
                quantumStart1.setAttribute('class','turnCx')
                quantumStart1.appendChild(firstchild)
                quantumStart1.firstChild.setAttribute('style','display: none; width: 40px; height: 94px; ') 
                quantumStart1.lastChild.setAttribute('style','bottom:7px;left:-13px')
                // that.column = quantumStart1.getAttribute('index')
                quantumStart1.firstChild.style.height = 94+45*(Math.abs(end - start)-1)+'px'
                const cnotLine = document.createElement('div')
                cnotLine.innerHTML = '<div class="cnotLine" style="display:inline-block;position: absolute;top:37px;left:'+(23+(that.column)*46)+'px;width: 2px;height: '+(36 + 50*(Math.abs(end - start)-1))+'px;background-color: blue;"><span class="cnotBottom" style="display: inline-block;width: 14px;height: 14px;background-color: blue;position: absolute;bottom: -10px;left: -6px;border-radius: 50%;"></span></div>'
                quantumStart1.appendChild(cnotLine.firstChild)
                quantumStart1.setAttribute('start',start)
               }
               
              }else if(ele[0]=='swap'&&end!=start) {//如果是swap门
               const quantumStart = document.getElementsByClassName("xStart")[0];
               const quantumline = document.getElementsByClassName("quantumline")[0];
               quantumStart1 = quantumStart.cloneNode(true);
               const quantumline1 = quantumline.cloneNode(true);
               quantumStart1.setAttribute("class", "xStart1");
               quantumStart1.setAttribute("name", "swap");
               quantumStart1.setAttribute("position", start);
               quantumline1.setAttribute("class", "quantumline2");
               const quantumEnd = quantumStart.cloneNode(true);
               quantumEnd.setAttribute("class", "xStart2");
               quantumEnd.setAttribute("name", "xEnd");
               quantumline1.appendChild(quantumEnd);
               quantumStart1.appendChild(quantumline1);
               let quantumbox = document.createElement("span");
               quantumbox.setAttribute("class", "doublequantum");
               quantumbox.setAttribute("end", end);
               const close = document.getElementsByClassName("close")[0].cloneNode(true);
               let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
               quantumbox.appendChild(close);
               quantumbox.appendChild(edit);
              //  quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:3px;left:-14px;";
               quantumbox.style.display = 'inline-block'
               quantumbox.style.width = '40px'
               quantumbox.style.height = '90px'
               quantumbox.style.border = '0px dashed #EAEAEA'
               quantumbox.style.position = 'absolute'
               quantumbox.style.top = '3px'
               quantumbox.style.left = '-14px'
               quantumbox.style.height = 47 * (end - start + 1) + "px";
               quantumStart1.appendChild(quantumbox);
              }else if(ele[0]=='cz'&&end!=start){
               const quantumStart = document.getElementsByClassName("circle")[0];
               const quantumline = document.getElementsByClassName("quantumline")[0];
               quantumStart1 = quantumStart.cloneNode(true);
               const quantumline1 = quantumline.cloneNode(true);
               quantumStart1.setAttribute("class", "circle1");
               quantumStart1.setAttribute("name", "cz");
                quantumStart1.setAttribute("position", start);
               quantumline1.setAttribute("class", "quantumline3");
               const quantumEnd = quantumStart.cloneNode(true);
               quantumEnd.setAttribute("class", "circle3");
               quantumEnd.setAttribute("name", "xEnd");
               quantumline1.appendChild(quantumEnd);
               quantumStart1.appendChild(quantumline1);
               let quantumbox = document.createElement("span");
               quantumbox.setAttribute("class", "doublequantum");
               quantumbox.setAttribute("end", end);
               const close = document.getElementsByClassName("close")[0].cloneNode(true);
               let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
               quantumbox.appendChild(close);
               quantumbox.appendChild(edit);
              //  quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:3px;left:-14px;";
               quantumbox.style.display = 'inline-block'
               quantumbox.style.width = '40px'
               quantumbox.style.height = '90px'
               quantumbox.style.border = '0px dashed #EAEAEA'
               quantumbox.style.position = 'absolute'
               quantumbox.style.top = '-16px'
               quantumbox.style.left = '-14px'
               quantumbox.style.height = 47 * (end - start + 1) + "px";
               quantumStart1.appendChild(quantumbox);
              }
          }else if(ele[0]=='toffoli'){
            let positionInfo = ele[2].match(/(\-|\+)?\d+(\.\d+)?/g)
             start = positionInfo[0]-0
            let toffolimiddle = positionInfo[1]-0
            let toffoliend = positionInfo[2]-0
            let quantumStart 
            quantumStart= document.getElementsByClassName("circle")[0];
            let quantumline 
            quantumline= document.getElementsByClassName("quantumline")[0];
            if(Math.max(start,toffolimiddle,toffoliend)==toffoliend){
              quantumStart1 = quantumStart.cloneNode(true);
              let toffoliline = quantumline.cloneNode(true);
              quantumStart1.setAttribute("class", "circle1");
              quantumStart1.setAttribute("start", start);
              quantumStart1.setAttribute("name", "toffoli");
              toffoliline.setAttribute("class", "quantumline3");
              toffoliline.style.height = 53+50*(Math.abs(toffolimiddle-start)-1)+'px'
              let toffoliMiddle = quantumStart.cloneNode(true);
              toffoliMiddle.setAttribute("class", "circle3");
              toffoliMiddle.setAttribute("name", "middle");
              quantumStart1.setAttribute("middle", toffolimiddle);
              let toffoliline1 = quantumline.cloneNode(true);
              toffoliline1.setAttribute("class", "toffquantumline");
              toffoliline1.style.height = 37+(50*(Math.abs(toffoliend-toffolimiddle)-1))+'px'
              toffoliMiddle.appendChild(toffoliline1)
              toffoliline.appendChild(toffoliMiddle);
              quantumStart1.appendChild(toffoliline);
              let toffoliEnd = quantumStart.cloneNode(true);
              toffoliEnd.setAttribute("class", "circle2");
              toffoliEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
              toffoliEnd.setAttribute("name", "end");
              quantumStart1.setAttribute("end", toffoliend);
              toffoliline1.appendChild(toffoliEnd)
            }else if(Math.min(start,toffolimiddle,toffoliend)==toffoliend){
              quantumStart1 = quantumStart.cloneNode(true);
              quantumStart1.setAttribute("class", "toffcircle2");
              quantumStart1.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
              quantumStart1.setAttribute("end", toffoliend);
              quantumStart1.setAttribute("name", "toffoli");
              quantumStart1.setAttribute("start", start);
              quantumStart1.setAttribute("middle", toffolimiddle); 
              let toffoliline = quantumline.cloneNode(true);
              toffoliline.setAttribute("class", "quantumline4");
              toffoliline.style.height =38+ (50*(Math.abs(toffolimiddle-toffoliend)-1))+'px'
              let toffoliMiddle = quantumStart.cloneNode(true);
              toffoliMiddle.setAttribute("class", "circle3");
              toffoliMiddle.setAttribute("name", "middle");
              let toffoliline1 = quantumline.cloneNode(true);  
              toffoliline1.setAttribute("class", "toffquantumline");
              toffoliline1.style.height =44+(50*(Math.abs(start-toffolimiddle)-1)) +'px'
              toffoliMiddle.appendChild(toffoliline1)
              toffoliline.appendChild(toffoliMiddle);
              let toffoliEnd = quantumStart.cloneNode(true);
              toffoliEnd.setAttribute("class", "toffcircle");
              toffoliEnd.style.top=33+(50*(Math.abs(start-toffolimiddle)-1)) +'px'
              toffoliline1.appendChild(toffoliEnd)
               quantumStart1.firstChild.appendChild(toffoliline);
            }else{
               quantumStart1 = quantumStart.cloneNode(true);
              let toffoliline = quantumline.cloneNode(true);
              quantumStart1.setAttribute("class", "circle1");
              quantumStart1.setAttribute("start", start);
              quantumStart1.setAttribute("name", "toffoli");
              toffoliline.setAttribute("class", "quantumline3");
              toffoliline.style.height = 42+(50*(Math.abs(toffoliend-start)-1))+'px'
              let toffoliEnd = quantumStart.cloneNode(true);
              toffoliEnd.setAttribute("class", "circle2");
              toffoliEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
              toffoliEnd.setAttribute("name", "end");
              quantumStart1.setAttribute("end", toffoliend);
              let toffoliMiddle = quantumStart.cloneNode(true);
              toffoliMiddle.setAttribute("class", "circle3");
              toffoliMiddle.setAttribute("name", "middle");
              quantumStart1.setAttribute("middle", toffolimiddle);
              let toffoliline1 = quantumline.cloneNode(true);
              toffoliline1.setAttribute("class", "toffquantumline1");
              toffoliline1.style.height = 39+(50*(Math.abs(toffoliend-toffolimiddle)-1))+'px'
              toffoliEnd.appendChild(toffoliline1)
              toffoliline.appendChild(toffoliEnd);
              quantumStart1.appendChild(toffoliline);
              toffoliline1.appendChild(toffoliMiddle)
            }
            let quantumbox = document.createElement("span");
             quantumbox.setAttribute("class", "doublequantum");
            let close = document.getElementsByClassName("close")[0].cloneNode(true);
            let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
            quantumbox.appendChild(close);
            quantumbox.appendChild(edit);
            quantumbox.style.display = 'inline-block'
            quantumbox.style.width = '40px'
            quantumbox.style.height = 138+50*(Math.max(start,toffolimiddle,toffoliend)- Math.min(start,toffolimiddle,toffoliend)-2)+'px'
            quantumbox.style.border = '0px dashed #EAEAEA'
            quantumbox.style.position = 'absolute'
            
            if(ele[0]=='toffoli'&&Math.min(start,toffolimiddle,toffoliend)==toffoliend){
              quantumbox.style.top = '0px'
              quantumbox.style.left = '1px'
            }else{
              quantumbox.style.top = '-12px'
              quantumbox.style.left = '-14px'
            }
            quantumStart1.appendChild(quantumbox);
          }else{//如果是单量子比特门
              if(ele[0]=='u1'||ele[0]=='rx'||ele[0]=='ry'||ele[0]=='rz'){
                // console.log(ele[2].match(/(\-|\+)?\d+(\.\d+)?/g))
                const anglearr =ele[2].match(/(\-|\+)?\d+(\.\d+)?/g)
                angleSimple = Number(anglearr[1]).toFixed(6)
              }else if(ele[0]=='u2'){
                 const anglearr1 = ele[2].match(/(\-|\+)?\d+(\.\d+)?/g)
                 angleDouble1 =  (anglearr1[1]-0).toFixed(6)
                 angleDouble2 =  (anglearr1[2]-0).toFixed(6)
              }else if(ele[0]=='u3'){
                 const anglearr2 = ele[2].match(/(\-|\+)?\d+(\.\d+)?/g)
                 angletrible1 =  (anglearr2[1]-0).toFixed(6)
                 angletrible2 =  (anglearr2[2]-0).toFixed(6)
                 angletrible3 =  (anglearr2[3]-0).toFixed(6)
              }
              // debugger
              if(ele[2].length >= 5){
                start = ele[2].match(/\d+/g)[0]-0
              }else{
                start = ele[2].charAt(2)-0
              }
              quantumStart1 = document.getElementById('lis').firstChild.cloneNode(true)
              quantumStart1.setAttribute('name',ele[0])
              quantumStart1.setAttribute('class','online')
              quantumStart1.setAttribute('draggable','false')
              if(quantumStart1.getAttribute('name')=='u1'||quantumStart1.getAttribute('name')=='rx'||quantumStart1.getAttribute('name')=='rz'||quantumStart1.getAttribute('name')=='ry'){
                 quantumStart1.setAttribute('angle',angleSimple)
              }else if(quantumStart1.getAttribute('name')=='u2'){
                  quantumStart1.setAttribute('angle1',angleDouble1)
                  quantumStart1.setAttribute('angle2',angleDouble2)
              }else if(quantumStart1.getAttribute('name')=='u3'){
                quantumStart1.setAttribute('angle1',angletrible1)
                quantumStart1.setAttribute('angle2',angletrible2)
                quantumStart1.setAttribute('angle3',angletrible3)
              }
             
              const svgName = quantumStart1.firstChild.lastChild.firstChild.firstChild
              switch(ele[0]){//根据获得的名称进行量子门的渲染
                case 'h':
                  quantumStart1.setAttribute('idx','1');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-h.svg'));
                  break;
                case 's':
                  quantumStart1.setAttribute('idx','2');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-s.svg'))
                  break;
                case 'sdg':
                  quantumStart1.setAttribute('idx','3');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-sdg.svg'))
                  break;

                case 'id':
                  quantumStart1.setAttribute('idx','4');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-id.svg'))
                  break;
                case 'x':
                  quantumStart1.setAttribute('idx','5');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-x.svg'))
                  break;
                case 'y':
                  quantumStart1.setAttribute('idx','6');
                 svgName.setAttribute('src',require('../../assets/font/qcicon-y.svg'))
                  break;
                case 'z':
                  quantumStart1.setAttribute('idx','7');
                   svgName.setAttribute('src',require('../../assets/font/qcicon-z.svg'))
                  break;
                case 'measure':
                  quantumStart1.setAttribute('idx','8');
                   svgName.setAttribute('src',require('../../assets/font/qcicon-measure.svg'))
                  break;
                case 't':
                  quantumStart1.setAttribute('idx','11');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-t.svg'))
                  break;
                case 'tdg':
                  quantumStart1.setAttribute('idx','12');
                  svgName.setAttribute('src',require('../../assets/font/qcicon-t1.svg'))
                  break;
                case 'u1':
                  quantumStart1.setAttribute('idx','21');
                  svgName.setAttribute('src',require('../../assets/icon/u1.svg'))
                  break;
                case 'u2':
                  quantumStart1.setAttribute('idx','22');
                  svgName.setAttribute('src',require('../../assets/icon/u2.svg'))
                  break;
                case 'u3':
                  quantumStart1.setAttribute('idx','13');
                  svgName.setAttribute('src',require('../../assets/icon/u3.svg'))
                  break;
                case 'rx':
                  quantumStart1.setAttribute('idx','14');
                  svgName.setAttribute('src',require('../../assets/icon/rx.svg'))
                  break;
                case 'ry':
                  quantumStart1.setAttribute('idx','15');
                  svgName.setAttribute('src',require('../../assets/icon/ry.svg'))
                  break;
                case 'rz':
                  quantumStart1.setAttribute('idx','16');
                  svgName.setAttribute('src',require('../../assets/icon/rz.svg'))
                  break;
                case 'x_half':
                  quantumStart1.setAttribute('idx','17');
                  svgName.setAttribute('src',require('../../assets/icon/x1.svg'))
                  break;
                case 'y_half':
                  quantumStart1.setAttribute('idx','18');
                  svgName.setAttribute('src',require('../../assets/icon/y1.svg'))
                  break;
              }
          }
        }
        if(quantumStart1){
          //   let endPositoin
          //   let colPosition
           if(quantumStart1.getAttribute('class')=='turnCx'){
              zrr[end].push(quantumStart1)
            //  startPositoin = quantumStart1.firstChild.getAttribute('end')-0
            //  endPositoin =quantumStart1.getAttribute('start')-0
            // for(var m=startPositoin+1;m<=endPositoin;m++){
            //     colPosition =zrr[m].length
            //    zrr[m][colPosition]= tianchong.cloneNode(true)
            // }
               
          }else if(quantumStart1.getAttribute('name')=='toffoli'){
            let start1 = quantumStart1.getAttribute('start')-0
            let middle = quantumStart1.getAttribute('middle')-0
            let end1 = quantumStart1.getAttribute('end')-0
              if(Math.min(start1,middle,end1)==end1){
                 zrr[end1].push(quantumStart1)
              }else{
                 zrr[start1].push(quantumStart1)
              }
          }else{
            zrr[start].push(quantumStart1)
            //  startPositoin = quantumStart1.getAttribute('position')-0
            //   endPositoin =quantumStart1.lastChild.getAttribute('end')-0
            // for(var m=startPositoin+1;m<=endPositoin;m++){
            //     colPosition =zrr[m].length
            //    zrr[m][colPosition]= tianchong.cloneNode(true)
            // }
             
          }
        }
      })
          for(var inx =0;inx<that.arr.length;inx++){
            if(!zrr[inx][index]){
              zrr[inx][index] = tianchong.cloneNode(true)
            }
          }
      })
      zrr.forEach(item1=>{
        item1.forEach((ele1,index)=>{
          if(ele1){
            ele1.setAttribute('index',index)

            if(ele1.getAttribute('name')=='cx'||ele1.getAttribute('name')=='swap'||ele1.getAttribute('name')=='cz'){//如果是多量子比特门                                           
                let begin = ele1.getAttribute('position') - 0//开始位置
                let over = ele1.lastChild.getAttribute('end')-0//结束位置
                let col1 = ele1.getAttribute('index') - 0//所在列
              if(ele1.getAttribute('class')=='turnCx'){
                over = ele1.firstChild.getAttribute('end')-0
                ele1.childNodes[1].style.left = -6 + col1*46+'px'
                ele1.lastChild.style.left = 23+col1*46+'px'
                for(var f=over+1;f<=begin;f++){
                  if(!zrr[f][col1]){
                    zrr[f][col1] = tianchong.cloneNode(true)
                    zrr[f][col1].setAttribute('line','line')
                  }else if(zrr[f][col1].getAttribute('name')=='tianchong'){
                    zrr[f][col1].setAttribute('line','line')
                  }
                }
              }else{
                for(var f=begin+1;f<=over;f++){
                  if(!zrr[f][col1]){
                    zrr[f][col1] = tianchong.cloneNode(true)
                    zrr[f][col1].setAttribute('line','line')
                  }else if(zrr[f][col1].getAttribute('name')=='tianchong'){
                    zrr[f][col1].setAttribute('line','line')
                  }
                }
              }
           }else if(ele1.getAttribute('name')=='toffoli'){
            let positionStart = ele1.getAttribute('start') - 0//开始位置
            let positionMiddle = ele1.getAttribute('middle') - 0//中间位置
            let positionEnd = ele1.getAttribute('end') - 0//结束位置
            let col2 = ele1.getAttribute('index') - 0//所在列
            let begin1 = Math.min(positionStart,positionMiddle,positionEnd)
            let over1 = Math.max(positionStart,positionMiddle,positionEnd)
            if(over1>=that.num){
               that.$message.error("请选择正确位置放置")
               return false
            }else{
               for(var f=begin1+1;f<=over1;f++){
                  if(!zrr[f][col2]){
                    zrr[f][col2] = tianchong.cloneNode(true)
                    zrr[f][col2].setAttribute('line','line')
                  }else if(zrr[f][col2].getAttribute('name')=='tianchong'){
                    zrr[f][col2].setAttribute('line','line')
                  }
                }
            }
           
           }
           
          }
        })
      })
      if(that.num>4){
        that.islimit = false
      }else{
        that.islimit = true
      }
      that.drawing(zrr)
      if(that.num > 4){
        return false
      }else{
         that.getChartInfo()
      }
     
    })
  },
    //清除最后一个元素为空的递归
    clearLast(brr){
      for(var i=0;i<brr.length;i++){
        for(var j=brr[i].length-1;j>0;j--){
          if(brr[i][j].getAttribute('name')=='tianchong'&&brr[i][j].getAttribute('line')!='line'){
              brr[i].splice(brr[i].length-1,1)
          }else{
            break
          }
        }
      }
      return brr
    },
    //电路渲染
    drawing(brr){
      //整行为填充时进行清空此行
      let kongNum = 0//填充的数量
      for(var m=0;m<brr.length;m++){
        kongNum = 0
        for(var n=0;n<brr[m].length;n++){
          if(brr[m][n].getAttribute('name')=='tianchong'&&brr[m][n].getAttribute('line')!='line'){
            kongNum++
          }
        }
        if(kongNum==brr[m].length){//如果整列为填充就置空此列
          brr[m]=[]
        }
      }
      this.arr = []
      this.arr=this.arr.concat(this.clearLast(brr))
      for(var cc=0;cc<this.arr.length;cc++){//清空线路上的所有量子比特门
        const box = document.getElementById("box" + cc);
        if(box){
           const boxChild = box.childNodes;
            for (var k = boxChild.length - 1; k >= 0; k--) {
              box.removeChild(boxChild[k]);
            }
        }
      }
      for(var i=0;i<this.arr.length;i++){
        const box1 = document.getElementById("box" + i);
        if(box1){
          for(var j=0;j<this.arr[i].length;j++){//重新渲染线路图上的量子比特门
            if(this.arr[i][j].getAttribute('name')=='cx'){
              if(this.arr[i][j].getAttribute('class') == 'turnCx'){
                  console.log(this.arr[i][j])
              }else{
                let end = this.arr[i][j].lastChild.getAttribute('end')-0
                let start = this.arr[i][j].getAttribute('position')-0
                this.arr[i][j].firstChild.style.height = 42 + 50 * (end - start-1)+'px'
              }
            }else if(this.arr[i][j].getAttribute('name')=='swap'){
              let end = this.arr[i][j].lastChild.getAttribute('end')-0
              let start = this.arr[i][j].getAttribute('position')-0
              this.arr[i][j].childNodes[1].style.height = (54 + 50 * (end - start-1))+ "px";
            }else if(this.arr[i][j].getAttribute('name')=='cz'){
               let end = this.arr[i][j].lastChild.getAttribute('end')-0
               let start = this.arr[i][j].getAttribute('position')-0
               this.arr[i][j].childNodes[0].style.height = (54 + 50 * (end - start-1))+ "px";
            }
              box1.appendChild(this.arr[i][j])
         }
        }
      }
      this.quantumBorder()
    },
    //判断是移动端还是PC端
    _isMobile() {
	    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	    return flag;
   },
    //量子门的插入
    insertQuantum(e){
      let eTarget
      if(this._isMobile()||this.isscreen){
        eTarget = document.elementFromPoint(event.changedTouches[0].pageX,event.changedTouches[0].pageY)
      }else{
         eTarget = e.target
       
      }
      this.brr=[]
      let maxcol = 0
      // let eTarget = e.target
      const tianchong = document.getElementsByClassName("tianchong")[0];
      if(this.moveNode1.getAttribute('name')!='cx'&&this.moveNode1.getAttribute('name')!='swap'&&this.moveNode1.getAttribute('name')!='cz'&&this.moveNode1.getAttribute('name')!='tianchong'&&this.moveNode1.getAttribute('name')!='measure'&&this.moveNode1.getAttribute('name')!='toffoli'){//插入元素为单量子们比特时
        
          if(eTarget.getAttribute('name')=='bitSvg'){//拖放位置是单量子比特门svg图标时
            const item = eTarget.parentNode.parentNode.parentNode.parentNode
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            this.arr[line].splice(column,1,this.moveNode1.cloneNode(true))
          }else if(eTarget.getAttribute('name')=='tianchong'&&eTarget.getAttribute('line')!='line'){//拖放位置为填充但是不是跨线的填充
            const item = eTarget
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            //  for(var i=0;i<this.arr.length;i++){
            //   this.arr[i].splice(column,0,tianchong.cloneNode(true))
            // }
            this.arr[line].splice(column,1,this.moveNode1.cloneNode(true))
          }else if(eTarget.getAttribute('class')=='doublequantum'){//拖放位置为多量子比特门时
            const item = eTarget.parentNode
            let column = item.getAttribute('index')-0
            let line = item.getAttribute('position')-0
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            this.arr[line].splice(column,1,this.moveNode1.cloneNode(true))
          }else if(eTarget.getAttribute('class') == "iconfont icon-tianjiaaddto1"){//拖放位置为cx翻转多量子比特门时
            const item = eTarget.parentNode.parentNode
            let column = item.getAttribute('index')-0
            let line = item.firstChild.getAttribute('end')-0
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            this.arr[line].splice(column,1,this.moveNode1.cloneNode(true))
          }else if(eTarget.getAttribute('line')=='line'){//拖放位置为跨线的填充时
            const item = eTarget
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            this.arr[line].splice(column,1,this.moveNode1.cloneNode(true))
          }
      }else if(this.moveNode1.getAttribute('name')=='cx'){//插入为cx量子门比特时
          const quantumStart = document.getElementsByClassName("circle")[0];
          const quantumline = document.getElementsByClassName("quantumline")[0];
          let quantumStart1 = quantumStart.cloneNode(true);
          const quantumline1 = quantumline.cloneNode(true);
          quantumStart1.setAttribute("class", "circle1");
          // quantumStart1.setAttribute("position", start);
          quantumStart1.setAttribute("name", "cx");
          quantumline1.setAttribute("class", "quantumline1");
          const quantumEnd = quantumStart.cloneNode(true);
          quantumEnd.setAttribute("class", "circle2");
          quantumEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
          quantumEnd.setAttribute("name", "circleEnd");
          quantumline1.appendChild(quantumEnd);
          quantumStart1.appendChild(quantumline1);
          let quantumbox = document.createElement("span");
          quantumbox.setAttribute("class", "doublequantum");
          // quantumbox.setAttribute("end", end);
          const close = document.getElementsByClassName("close")[0].cloneNode(true);
          let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
          quantumbox.appendChild(close);
          quantumbox.appendChild(edit);
          // quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:-14px;left:-14px;";
          quantumbox.style.display = 'inline-block'
          quantumbox.style.width = '40px'
          quantumbox.style.height = '90px'
          quantumbox.style.border = '0px dashed #EAEAEA'
          quantumbox.style.position = 'absolute'
          quantumbox.style.top = '-14px'
          quantumbox.style.left = '-14px'
          // quantumbox.style.height = 47 * (end - start + 1) + "px";
          quantumStart1.appendChild(quantumbox);
          if(eTarget.getAttribute('name')=='bitSvg'){//插入位置为单量子比特门时
            const item1 = eTarget.parentNode.parentNode.parentNode.parentNode
            let column1 = item1.getAttribute('index')-0
            let line1 = item1.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line1+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
            for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column1,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line1)
            quantumStart1.lastChild.setAttribute('end',line1+1)
            this.arr[line1].splice(column1,1,quantumStart1)
            // this.arr[line+1][column].setAttribute('line','line')
          }else if(eTarget.getAttribute('name')=='tianchong'){//插入位置为填充时
            const item = eTarget
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
          }else if(eTarget.getAttribute('class')=='doublequantum'){//插入位置为跨线量子门时
            const item = eTarget.parentNode
            let column = item.getAttribute('index')-0
            let line = item.getAttribute('position')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
            if(!this.arr[line+1][column]){
              for(var k=0;k<this.arr[line+1].length;k++){
                if(!this.arr[line+1][k]){
                  this.arr[line+1][k] = tianchong.cloneNode(true)
                }
              }
            }
            this.arr[line+1][column].setAttribute('line','line')
          }
      }else if(this.moveNode1.getAttribute('name')=='swap'){//插入元素为swap量子门比特时
          const quantumStart = document.getElementsByClassName("xStart")[0];
          const quantumline = document.getElementsByClassName("quantumline")[0];
          let quantumStart1 = quantumStart.cloneNode(true);
          const quantumline1 = quantumline.cloneNode(true);
          quantumStart1.setAttribute("class", "xStart1");
          quantumStart1.setAttribute("name", "swap");
          // quantumStart1.setAttribute("position", start);
          quantumline1.setAttribute("class", "quantumline2");
          const quantumEnd = quantumStart.cloneNode(true);
          quantumEnd.setAttribute("class", "xStart2");
          quantumEnd.setAttribute("name", "xEnd");
          quantumline1.appendChild(quantumEnd);
          quantumStart1.appendChild(quantumline1);
          let quantumbox = document.createElement("span");
          quantumbox.setAttribute("class", "doublequantum");
          // quantumbox.setAttribute("end", end);
          const close = document.getElementsByClassName("close")[0].cloneNode(true);
          let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
          quantumbox.appendChild(close);
          quantumbox.appendChild(edit);
          // quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:3px;left:-14px;";
          quantumbox.style.display = 'inline-block'
          quantumbox.style.width = '40px'
          quantumbox.style.height = '90px'
          quantumbox.style.border = '0px dashed #EAEAEA'
          quantumbox.style.position = 'absolute'
          quantumbox.style.top = '3px'
          quantumbox.style.left = '-14px'
          // quantumbox.style.height = 47 * (end - start + 1) + "px";
          quantumStart1.appendChild(quantumbox);
          if(eTarget.getAttribute('name')=='bitSvg'){//插入位置为单量子比特时
            const item = eTarget.parentNode.parentNode.parentNode.parentNode
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
            for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
          }else if(eTarget.getAttribute('name')=='tianchong'){//插入位置为填充时
            const item = eTarget
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
          }else if(eTarget.getAttribute('class')=='doublequantum'){//插入位置为跨线量子比特时
            const item = eTarget.parentNode
            let column = item.getAttribute('index')-0
            let line = item.getAttribute('position')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
            if(!this.arr[line+1][column]){//如果此跨线量子的下一行没有元素
              for(var k=0;k<this.arr[line+1].length;k++){
                if(!this.arr[line+1][k]){
                  this.arr[line+1][k] = tianchong.cloneNode(true)
                }
              }
            }
            this.arr[line+1][column].setAttribute('line','line')//给此添加的填充元素加上跨线填充的属性
          }
      }else if(this.moveNode1.getAttribute('name')=='cz'){
          const quantumStart = document.getElementsByClassName("circle")[0];
          const quantumline = document.getElementsByClassName("quantumline")[0];
          let quantumStart1 = quantumStart.cloneNode(true);
          const quantumline1 = quantumline.cloneNode(true);
          quantumStart1.setAttribute("class", "circle1");
          quantumStart1.setAttribute("name", "cz");
          // quantumStart1.setAttribute("position", start);
          quantumline1.setAttribute("class", "quantumline3");
          const quantumEnd = quantumStart.cloneNode(true);
          quantumEnd.setAttribute("class", "circle3");
          quantumEnd.setAttribute("name", "xEnd");
          quantumline1.appendChild(quantumEnd);
          quantumStart1.appendChild(quantumline1);
          let quantumbox = document.createElement("span");
          quantumbox.setAttribute("class", "doublequantum");
          // quantumbox.setAttribute("end", end);
          const close = document.getElementsByClassName("close")[0].cloneNode(true);
          let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
          quantumbox.appendChild(close);
          quantumbox.appendChild(edit);
          // quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:3px;left:-14px;";
          quantumbox.style.display = 'inline-block'
          quantumbox.style.width = '40px'
          quantumbox.style.height = '90px'
          quantumbox.style.border = '0px dashed #EAEAEA'
          quantumbox.style.position = 'absolute'
          quantumbox.style.top = '-16px'
          quantumbox.style.left = '-14px'
          // quantumbox.style.height = 47 * (end - start + 1) + "px";
          quantumStart1.appendChild(quantumbox);
          if(eTarget.getAttribute('name')=='bitSvg'){//插入位置为单量子比特时
            const item = eTarget.parentNode.parentNode.parentNode.parentNode
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
            for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
          }else if(eTarget.getAttribute('name')=='tianchong'){//插入位置为填充时
            const item = eTarget
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
          }else if(eTarget.getAttribute('class')=='doublequantum'){//插入位置为跨线量子比特时
            const item = eTarget.parentNode
            let column = item.getAttribute('index')-0
            let line = item.getAttribute('position')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            quantumStart1.setAttribute('position',line)
            quantumStart1.lastChild.setAttribute('end',line+1)
            this.arr[line].splice(column,1,quantumStart1)
            if(!this.arr[line+1][column]){//如果此跨线量子的下一行没有元素
              for(var k=0;k<this.arr[line+1].length;k++){
                if(!this.arr[line+1][k]){
                  this.arr[line+1][k] = tianchong.cloneNode(true)
                }
              }
            }
            this.arr[line+1][column].setAttribute('line','line')//给此添加的填充元素加上跨线填充的属性
          }
      }else if(this.moveNode1.getAttribute('name')=='toffoli'){ 
        let quantumStart = document.getElementsByClassName("circle")[0];
        let quantumline = document.getElementsByClassName("quantumline")[0];
        let toffoliStart = quantumStart.cloneNode(true);
        let toffoliline = quantumline.cloneNode(true);
        toffoliStart.setAttribute("class", "circle1");
        toffoliStart.setAttribute("name", "toffoli");
        toffoliline.setAttribute("class", "quantumline3");
        let toffoliMiddle = toffoliStart.cloneNode(true);
        toffoliMiddle.setAttribute("class", "circle3");
        toffoliMiddle.setAttribute("name", "xEnd");
        let toffoliline1 = quantumline.cloneNode(true);
        toffoliline1.setAttribute("class", "toffoliquantumline");
        toffoliMiddle.appendChild(toffoliline1)
        toffoliline.appendChild(toffoliMiddle);
        toffoliStart.appendChild(toffoliline);
        let toffoliEnd = quantumStart.cloneNode(true);
        toffoliEnd.setAttribute("class", "circle2");
        toffoliEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';
        toffoliEnd.setAttribute("name", "circleEnd");
        let quantumbox = document.createElement("span");
        quantumbox.setAttribute("class", "doublequantum");
        let close0 = document.getElementsByClassName("close")[0].cloneNode(true);
        let edit0 = document.getElementsByClassName("editquantum")[0].cloneNode(true);
        quantumbox.appendChild(close0);
        quantumbox.appendChild(edit0);
        quantumbox.style.display = 'inline-block'
        quantumbox.style.width = '40px'
        quantumbox.style.height = '90px'
        quantumbox.style.border = '0px dashed #EAEAEA'
        quantumbox.style.position = 'absolute'
        quantumbox.style.top = '3px'
        quantumbox.style.left = '-14px'
        quantumbox.setAttribute('onclick',this.quantumBorder())
        toffoliStart.appendChild(quantumbox);
        if(eTarget.getAttribute('name')=='bitSvg'){//插入位置为单量子比特时
            const item = eTarget.parentNode.parentNode.parentNode.parentNode
            let column = item.getAttribute('index')-0
            let line = item.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
            for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            toffoliStart.setAttribute('position',line)
            toffoliStart.setAttribute('start',line)
            toffoliStart.setAttribute('middle',line+1)
            toffoliStart.setAttribute('end',line+2)
            this.arr[line].splice(column,1,toffoliStart)
          }else if(eTarget.getAttribute('name')=='tianchong'){//插入位置为填充时
            let   column = eTarget.getAttribute('index')-0
            let   line1 = eTarget.parentNode.parentNode.firstChild.getAttribute('id')-0
            if(line1+2>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column,0,tianchong.cloneNode(true))
            }
            toffoliStart.setAttribute('position',line1)
            toffoliStart.setAttribute('start',line1)
            toffoliStart.setAttribute('middle',line1+1)
            toffoliStart.setAttribute('end',line1+2)
            this.arr[line1].splice(column,1,toffoliStart)
          }else if(eTarget.getAttribute('class')=='doublequantum'){//插入位置为跨线量子比特时
            let column0 = eTarget.parentNode.getAttribute('index')-0
            let line0 = eTarget.parentNode.getAttribute('position')-0
            if(line0+1>=this.num){
              this.$message.error("请选择正确位置放置")
              return
            }
             for(var i=0;i<this.arr.length;i++){
              this.arr[i].splice(column0,0,tianchong.cloneNode(true))
            }
            toffoliStart.setAttribute('position',line0)
            toffoliStart.setAttribute('start',line0)
            toffoliStart.setAttribute('middle',line0+1)
            toffoliStart.setAttribute('end',line0+2)
            this.arr[line0].splice(column0,1,toffoliStart)
            if(!this.arr[line0+1][column0]){//如果此跨线量子的下一行没有元素
              for(var k=0;k<this.arr[line0+1].length;k++){
                if(!this.arr[line0+1][k]){
                  this.arr[line0+1][k] = tianchong.cloneNode(true)
                }
              }
            }
            this.arr[line0+1][column0].setAttribute('line','line')//给此添加的填充元素加上跨线填充的属性
          }
      }
       for(var m=0;m<this.arr.length;m++){
        for(var n=0;n<this.arr[m].length;n++){
          if(this.arr[m].length>maxcol){//获取该电路编程图的最大列
            maxcol = this.arr[m].length
          }
          this.arr[m][n].setAttribute('index',n)
          this.arr[m][n].setAttribute('position',m)
        }
      }

      for(var l=0;l<this.arr.length;l++){
          let boxNum = document.getElementById("box"+l)
          let boxNumChild = boxNum.childNodes
          for (var k = boxNumChild.length - 1; k >= 0; k--) {//清空线路图上的元素
              boxNum.removeChild(boxNumChild[k]);
           }
            this.arr[l].forEach((ele,index)=>{//重新渲染元素
              if(ele){
                boxNum.appendChild(ele)
              }
          })
      }
      this.brr = this.arr.concat(this.brr)
      this.deletequantum(this.num,maxcol+1)
      this.quantumBorder()
      this.qasmShow()
    },
    //语言编程展示
    qasmShow(){
       let crr = []
       let err = []
       let maxlength = 0 //最大长度
       for(var i=0;i<this.arr.length;i++){//获取所有行的最大长度
         if(this.arr[i].length>maxlength){
           maxlength = this.arr[i].length
         }
       }
       for(var m=0;m<maxlength;m++){
         for(var n=0;n<this.arr.length;n++){//按列遍历
           if(this.arr[n][m]){
               if(this.arr[n][m].getAttribute('name')=='cx'||this.arr[n][m].getAttribute('name')=='swap'||this.arr[n][m].getAttribute('name')=='cz'){//是两量子比特门时
                //  this.arr[n][m].lastChild.setAttribute('end',this.end)
                 err = []
                 let end = 0
                 let start = 0
                 err.push(this.arr[n][m].getAttribute('name'))
                 err[1]=''
                 if(this.arr[n][m].getAttribute('class') == 'turnCx'){
                   end = n
                   start = this.arr[n][m].getAttribute('start') - 0
                   this.arr[n][m].lastChild.setAttribute('end',end)
                    err[1] = err[1] + 'q['+start+'],'
                  //  for(var j= start;j>end;j--){
                  //    err[1] = err[1] + 'q['+j+'],'
                  //  } 
                   err[1]=err[1]+'q['+end+']'
                 }else{
                  start = n
                  end = this.arr[n][m].lastChild.getAttribute('end') - 0
                   err[1]= err[1]+'q['+start+'],'+'q['+end+']'
                  //  for(var j=start;j<end;j++){//量子比特门位置信息拼接
                  //      err[1]= err[1]+'q['+j+'],'
                  //    }
                    //  err[1]=err[1]
                  }
                  
                  crr.push(err)
               }else if(this.arr[n][m].getAttribute('name')!=='cx'&&this.arr[n][m].getAttribute('name')!=='swap'&&this.arr[n][m].getAttribute('name')!=='tianchong'&&this.arr[n][m].getAttribute('name')!=='toffoli'){//是单量子比特时
                 err=[]
                 err.push(this.arr[n][m].getAttribute('name'))
                 if(this.arr[n][m].getAttribute('name')=='u1'||this.arr[n][m].getAttribute('name')=='rx'||this.arr[n][m].getAttribute('name')=='ry'||this.arr[n][m].getAttribute('name')=='rz'){
                  //  debugger
                   if(this.arr[n][m].getAttribute('angle')){
                      err.push('q['+n+'],('+this.arr[n][m].getAttribute('angle')+')')
                   }else{
                     err.push('q['+n+'],(1.570796)')
                   }
                 
                 }else if(this.arr[n][m].getAttribute('name')=='u2'){
                   if(this.arr[n][m].getAttribute('angle1')){
                      err.push('q['+n+'],('+this.arr[n][m].getAttribute('angle1')+','+this.arr[n][m].getAttribute('angle2')+')')
                   }else{
                     err.push('q['+n+'],(1.570796,-3.141593)')
                   }
                 }else if(this.arr[n][m].getAttribute('name')=='u3'){
                   if(this.arr[n][m].getAttribute('angle1')){
                      err.push('q['+n+'],('+this.arr[n][m].getAttribute('angle1')+','+this.arr[n][m].getAttribute('angle2')+','+this.arr[n][m].getAttribute('angle3')+')')
                   }else{
                     err.push('q['+n+'],(1.570796,-3.141593,1.570796)')
                   }
                 }else{
                   err.push('q['+n+']')
                 }
                 
                 crr.push(err)
               }else if(this.arr[n][m].getAttribute('name')=='toffoli'){
                 err=[]
                 err.push(this.arr[n][m].getAttribute('name'))
                let third = 0
                let middle = 0
                let first = 0
                err[1]=''
                first = this.arr[n][m].getAttribute('start') - 0
                middle = this.arr[n][m].getAttribute('middle') - 0
                third = this.arr[n][m].getAttribute('end') - 0
                err[1]= err[1]+'q['+first+'],'+'q['+middle+'],'+'q['+third+']'
                crr.push(err)
               }
           }
         }
       }
       let that = this
       this.publicCode = 'OPENQASM 2.0;'+'\n'+'                     '+'\n'+'\n'+'qreg  q['+this.num+'];'+'\n'+'creg  c['+this.num1+'];'+'\n'+'\n'//公共部分代码
       this.code =''//量子门代码
       if(crr.length>100){
         this.codeArr = crr.slice(100)
       }else{
         this.codeArr = crr.concat([])
       }
       this.codeArr.forEach(ele=>{
        if(ele[0]=='cx'||ele[0]=='swap'||ele[0]=='cz'){//是多量子比特门时代码拼接
          that.code = that.code + ele[0]+"  "+ele[ele.length-1]+';'+'\n'
          // that.code = that.code + ele[1]
          // for(var q=1;q<ele.length-1;q++){
          //   that.code = that.code + ele[q]
          // }
          //  that.code = that.code +ele[ele.length-1]+';'+'\n'
        }else if(ele[0]=='u1'||ele[0]=='rx'||ele[0]=='ry'||ele[0]=='rz'||ele[0]=='u2'||ele[0]=='u3'){
          if(ele[0]=='u1'||ele[0]=='rx'||ele[0]=='ry'||ele[0]=='rz'){
            that.code = that.code + ele[0]+"  "+ele[ele.length-1]+';'+'\n'
          }else if(ele[0]=='u2'){
            that.code = that.code + ele[0]+"  "+ele[ele.length-1]+';'+'\n'
          }else if(ele[0]=='u3'){
            that.code = that.code + ele[0]+"  "+ele[ele.length-1]+';'+'\n'
          }
             
        }else{//单量子比特门代码拼接
           that.code = that.code + ele[0] +'  '+ ele[1]+';'+'\n'
        }
       })
      this.createQasm().setValue(this.publicCode+this.code)//把代码渲染到编辑器里面
      let boxp =  document.getElementsByClassName('mycode_wrap')[0]
      let boxc = boxp.childNodes
      for(var p=boxc.length-1;p>1;p--){
        boxp.removeChild(boxc[p])
      }
      // this.rexCode()
    },
    //语言编程规则制定
    rexCode(){
     let num = this.num -1
     const rex = /^(h|s|(sdg)|(id)|x|y|z|t|(tdg)|(measure)|(u1)|(u2)|(u3)|(rx)|(ry)|(rz)|(x_half)|(y_half))  q\[[0-1]?[0-9]?\](,|;)(\(((\-)?\d+(\.\d{6}),{0,3})*\);)?$/ //单量子比特验证规则
     const rex1 = /^(cx|swap|cz|toffoli)  (q\[[0-1]?[0-9]?\](,|;))+$/  //多量子比特验证规则

    // if(this.code){
      let codeline = document.getElementsByClassName('CodeMirror-code')[0].childNodes
      for(var i=6;i<codeline.length-1;i++){
        if(codeline[i].lastChild.firstChild.innerHTML.split(' ')[0]!='cx'&&codeline[i].lastChild.firstChild.innerHTML.split(' ')[0]!='swap'&&codeline[i].lastChild.firstChild.innerHTML.split(' ')[0]!='cz'&&codeline[i].lastChild.firstChild.innerHTML.split(' ')[0]!='toffoli'){//当是单量子比特时进行验证
         if(!rex.test(codeline[i].lastChild.firstChild.innerHTML)){
            codeline[i].lastChild.firstChild.style.color='red'
            codeline[i].lastChild.firstChild.style.background='rgba(211,211,211,1)'
            this.verifyCode = false
            return
          }else{
            codeline[i].lastChild.firstChild.style.color='#555555'
            codeline[i].lastChild.firstChild.style.background='#fff'
            this.verifyCode = true
          }
        }else{//当是多量子比特时进行验证
          if(!rex1.test(codeline[i].lastChild.firstChild.innerHTML)){
            codeline[i].lastChild.firstChild.style.color='red'
            codeline[i].lastChild.firstChild.style.background='rgba(211,211,211,1)'
            this.verifyCode = false
            return
          }else{
            if(num == 0){
                codeline[i].lastChild.firstChild.style.color='red'
                codeline[i].lastChild.firstChild.style.background='rgba(211,211,211,1)'
                this.verifyCode = false
                return
            }else{
                let codeline1 =  codeline[i].lastChild.firstChild.innerHTML.split('')
              if(codeline1[codeline1.length-1]==';'){
                codeline[i].lastChild.firstChild.style.color='#555555'
                codeline[i].lastChild.firstChild.style.background='#fff'
                this.verifyCode = true
              }else{
                codeline[i].lastChild.firstChild.style.color='red'
                codeline[i].lastChild.firstChild.style.background='rgba(211,211,211,1)'
                this.verifyCode = false
                return
              }
            }

          }
        }
      }
    // }
  },
    //删除单个量子门
    deleteOne(quantum){
         this.brr=[]
         const tianchong = document.getElementsByClassName("tianchong")[0];
         let boxId = quantum.parentNode.parentNode.firstChild.getAttribute("id")-0;//获得此量子比特门的id属性值
         let inx = quantum.getAttribute("index") - 0;//获得此量子比特门的所在列
         this.arr[boxId].splice(inx, 1,tianchong.cloneNode(true));//把此元素换成填充元素
         this.brr = this.arr.concat(this.brr)
          for(var brrl = 0;brrl<this.brr.length;brrl++){
            for(var brrc = this.brr[brrl].length-1;brrc<this.cols;brrc++){
              if(!this.brr[brrl][brrc]){//
                this.brr[brrl].push(tianchong.cloneNode(true))
              }
            }
          }
          let maxlen = 0
          let drr=[]//存储数组每行长度的最大值
          this.brr.forEach((item,index)=>{
            item.forEach((ele,inx)=>{
              if(ele){
                if(ele.getAttribute('name')!=='tianchong'||(ele.getAttribute('name')=='tianchong'&&ele.getAttribute('line')=='line')){//当元素不是纯填充时
                  maxlen = ele.getAttribute('index') - 0;
               }
              }
            })
            drr.push(maxlen)
          })
          let maxvalue = Math.max(...drr)//获取线路图最长长度值
          this.deletequantum(this.brr.length,maxvalue+1)
          this.brr.forEach((item,index)=>{//设置index属性
            item.forEach((ele,inx)=>{
              if(ele){
                 ele.setAttribute('index',inx)
              }
            })
          })
          let maxLength = 0
            this.arr= []
            for(var m=0;m<this.brr.length;m++){
              this.arr.push([])
            }
          this.brr.forEach((item,index)=>{
            item.forEach((ele,inx)=>{
              if(ele){
                if(ele.getAttribute('name')!=='tianchong'||(ele.getAttribute('name')=='tianchong'&&ele.getAttribute('line')=='line')){//是纯填充元素时
                  maxLength = ele.getAttribute('index') - 0 +1
               }
              }
            })
            for(var j=0;j<maxLength;j++){
              this.arr[index].push(item[j])
            }
          })
          if (this.arr[boxId].length != 0) {
              this.arr[boxId].forEach((k, index) => {
                if(k){
                   k.setAttribute("index", index);
                   if (k.getAttribute("name") !== "tianchong") {
                        k.setAttribute("quantum", "quantum");
                   }
                  }
                }
              );
            }
          for (var l = 0; l < this.arr.length; l++) {
                let box = document.getElementById("box"+l)
                let boxChild = box.childNodes
                for (var k = boxChild.length - 1; k >= 0; k--) {
                    box.removeChild(boxChild[k]);
                  }

                  if(!this.$route.query.qobj_id){//无实验id进入页面也就是新页面
                      this.arr[l].forEach((ele,index)=>{
                        if(ele){
                          ele.setAttribute('index',index)
                          box.appendChild(ele)
                        }
                      })
                  }
                if(this.$route.query.qobj_id){//根据实验id进入页面
                  let item;
                  for (var ii = 0; ii < this.arr.length; ii++) {
                      const box = document.getElementById("box" + ii);
                      const boxChild = box.childNodes;
                      for (var k = boxChild.length - 1; k >= 0; k--) {
                        box.removeChild(boxChild[k]);
                      }
                    for (var j = 0; j < this.arr[ii].length; j++) {
                      if(this.arr[ii][j]){//元素存在时
                          item = this.arr[ii][j];
                        if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                           if(item.getAttribute('class')!='turnCx'){
                              item.setAttribute("class", "online");
                           }
                          };
                        // item.setAttribute("index", j);
                        if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){//元素为单量子比特门时
                          item.firstChild.lastChild.setAttribute("class",'bit')
                        }else if(item.getAttribute('name')=='cx'){//元素为cx量子比特时
                          if(item.getAttribute('class')!='turnCx'){
                            item.setAttribute('class','circle1')
                          }
                          let start =Number(item.getAttribute('position'))
                          let end =Number(item.lastChild.getAttribute('end'))
                          for(var dd=start+1;dd<=end;dd++){
                            if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                              this.arr[dd][j].setAttribute("line",'line')
                            }
                          }
                        }else if(item.getAttribute('name')=='swap'){//元素为swap元素时
                          item.setAttribute('class','xStart1')
                          let start =Number(item.getAttribute('position'))
                          let end =Number(item.lastChild.getAttribute('end'))
                          for(var dd=start+1;dd<=end;dd++){
                            if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                              this.arr[dd][j].setAttribute("line",'line')
                            }
                          }
                        }else if(item.getAttribute('name')=='cz'){
                          item.setAttribute('class','circle1')
                          let start =Number(item.getAttribute('position'))
                          let end =Number(item.lastChild.getAttribute('end'))
                          for(var dd=start+1;dd<=end;dd++){
                            if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                              this.arr[dd][j].setAttribute("line",'line')
                            }
                          }
                        }else if(item.getAttribute('name')=='toffoli'){
                          if(item.getAttribute('class')=='toffcircle2'){
                            item.firstChild.firstChild.setAttribute('class','quantumline4')
                          }else if(item.getAttribute('class')=='circle1'){
                             if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                item.firstChild.firstChild.setAttribute('class','circle2')
                              }else{
                                item.firstChild.firstChild.setAttribute('class','circle3')
                              }
                          }
                        }
                      }else{//元素不存在时用填充
                        this.arr[ii][j]=tianchong.cloneNode(true)
                          item = this.arr[ii][j].cloneNode(true);
                      }
                      this.arr.forEach((ele,index) =>{
                          ele.forEach((element,inx) =>{
                            if(element){
                              element.setAttribute("index",inx)
                            }
                          })
                        })
                      box.appendChild(item);
                      };
                    }
                }
          }
      this.qasmShow()
      this.codeChange(this.editor)
    },
    //删除跨线
    deleteTwo(quantum){
      this.brr=[]
      const tianchong = document.getElementsByClassName("tianchong")[0];//填充
      let deleteQuantum =quantum.parentNode//要删除的量子门
      let gateName = deleteQuantum.getAttribute('name')//量子门的名称
      this.position = deleteQuantum.getAttribute("position")-0;//所在行
      this.column =deleteQuantum.getAttribute("index")-0;//所在列
      let end = 0 
      if(deleteQuantum.getAttribute('class')!="turnCx"){
        if(deleteQuantum.getAttribute('name')!="toffoli"){
          end = Number(deleteQuantum.lastChild.getAttribute("end"));//结束位置所在行
        }else{
          end = Number(deleteQuantum.getAttribute("end"));//结束位置所在行
        }
         
         for(var n=this.position+1;n<=end;n++){
          if (this.arr[n][this.column]) {
            if (this.arr[n][this.column].getAttribute("name") === "tianchong"&&this.arr[n][this.column].getAttribute("line")=='line') {//跨线上的填充
              this.arr[n].splice(this.column,1,tianchong.cloneNode(true));
            }
          }
        }
        this.arr[this.position].splice(this.column,1,tianchong.cloneNode(true));
      }else{
         end = Number(quantum.getAttribute("end"));//结束位置所在行
           for(var n=end;n<=this.position;n++){
            if (this.arr[n][this.column]) {
              if (this.arr[n][this.column].getAttribute("name") === "tianchong"&&this.arr[n][this.column].getAttribute("line")=='line') {//跨线上的填充
                this.arr[n].splice(this.column,1,tianchong.cloneNode(true));
              }
            }
          }
          this.arr[end].splice(this.column,1,tianchong.cloneNode(true));
      }
      this.brr = this.arr.concat(this.brr)
      for(var brrl = 0;brrl<this.brr.length;brrl++){
        for(var brrc = this.brr[brrl].length-1;brrc<this.cols;brrc++){
          if(!this.brr[brrl][brrc]){
            this.brr[brrl].push(tianchong.cloneNode(true))
          }
        }
      }
      let maxlen = 0
      let drr=[]//存储数组每行长度的最大值
      this.brr.forEach((item,index)=>{
        item.forEach((ele,inx)=>{
          if(ele){
            if(ele.getAttribute('name')!=='tianchong'||(ele.getAttribute('name')=='tianchong'&&ele.getAttribute('line')=='line')){//不是纯填充元素时
              maxlen = ele.getAttribute('index') - 0;
           }
          }
        })
        drr.push(maxlen)
      })
      let maxvalue = Math.max(...drr)//取最大值
      this.deletequantum(this.brr.length,maxvalue+1)
      this.brr.forEach((item,index)=>{
        item.forEach((ele,inx)=>{
          if(ele){
             ele.setAttribute('index',inx)
          }
        })
      })
      let maxLength = 0
        this.arr= []
        for(var m=0;m<this.brr.length;m++){
          this.arr.push([])
        }
      this.brr.forEach((item,index)=>{
        item.forEach((ele,inx)=>{
          if(ele){
            if(ele.getAttribute('name')!=='tianchong'||(ele.getAttribute('name')=='tianchong'&&ele.getAttribute('line')=='line')){//所有不是纯填充的元素
              maxLength = ele.getAttribute('index') - 0 +1
           }
          }

        })
        for(var j=0;j<maxLength;j++){
          this.arr[index].push(item[j])
        }
      })
      for(var cc=0;cc<this.arr.length;cc++){
        const box = document.getElementById("box" + cc);
        const boxChild = box.childNodes;
        for (var k = boxChild.length - 1; k >= 0; k--) {//清空线路图上的所有量子门
          box.removeChild(boxChild[k]);
        }
        for(var cd = 0;cd<this.arr[cc].length;cd++){//重新渲染线路图上的量子门
          this.arr[cc][cd].setAttribute('index',cd)
          box.appendChild(this.arr[cc][cd])
        }
      }
    for (var l = 0; l < this.arr.length; l++) {
      const box = document.getElementById("box" + l);
      const boxChild = box.childNodes;
      for (var k = boxChild.length - 1; k >= 0; k--) {
        box.removeChild(boxChild[k]);
      }
      this.arr[l].forEach((ele,index)=>{
        if(ele){
          ele.setAttribute("index",index)
        }
      })
    }
    let item;
    for (var i = 0; i < this.arr.length; i++) {
      const box = document.getElementById("box" + i);
      for (var j = 0; j < this.arr[i].length; j++) {
        if(this.arr[i][j]){
            item = this.arr[i][j];
            if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
             if(item.getAttribute('class')!='turnCx'){
                item.setAttribute("class", "online");
              }
            }
          // item.setAttribute("index", j);
          if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
            item.firstChild.lastChild.setAttribute("class",'bit')
          }else if(item.getAttribute('name')=='cx'){
            if(item.getAttribute('class')!='turnCx'){
                item.setAttribute('class','circle1')
            }
            let start =Number(item.getAttribute('position'))
            let end =Number(item.lastChild.getAttribute('end'))
            for(var dd=start+1;dd<=end;dd++){
              if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                this.arr[dd][j].setAttribute("line",'line')
              }
            }
          }else if(item.getAttribute('name')=='swap'){
            item.setAttribute('class','xStart1')
            let start =Number(item.getAttribute('position'))
            let end =Number(item.lastChild.getAttribute('end'))
            for(var dd=start+1;dd<=end;dd++){
              if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                this.arr[dd][j].setAttribute("line",'line')
              }
            }
          }else if(item.getAttribute('name')=='cz'){
            item.setAttribute('class','circle1')
            let start =Number(item.getAttribute('position'))
            let end =Number(item.lastChild.getAttribute('end'))
            for(var dd=start+1;dd<=end;dd++){
              if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                this.arr[dd][j].setAttribute("line",'line')
              }
            }
          }else if(item.getAttribute('name')=='toffoli'){
              if(item.getAttribute('class')=='toffcircle2'){
                item.firstChild.firstChild.setAttribute('class','quantumline4')
              }else if(item.getAttribute('class')=='circle1'){
                 if(item.firstChild.firstChild.getAttribute('name')=='end'){
                    item.firstChild.firstChild.setAttribute('class','circle2')
                  }else{
                    item.firstChild.firstChild.setAttribute('class','circle3')
                  }
              }
            }
        }else{
          this.arr[i][j]=tianchong.cloneNode(true)
            item = this.arr[i][j].cloneNode(true);
        }
        box.appendChild(item);
        };
      }
     
        this.qasmShow()
        // this.quantumBorder()
    },
    //跨线弹窗
    showedit(quantum){
     this.dialogFormVisibledouble = true;
     if(quantum.getAttribute('class') == 'turnCx'){
        this.end = quantum.firstChild.getAttribute('end') - 0
      }else{
        this.end = quantum.lastChild.getAttribute('end') - 0
      }
     
     this.start = quantum.getAttribute('position') - 0
     this.quantumTwo = quantum
     this.oldEnd = this.end
    },
    //三比特跨线弹窗
    toffolishowedit(quantum){
      this.dialogFormVisibledouble1 = true;
      this.quantumThree = quantum
      this.toffstart = quantum.getAttribute('start')-0//开始行
      this.toffmiddle = quantum.getAttribute('middle')-0//中间行
      this.toffend = quantum.getAttribute('end')-0//结束行
    },
    //编辑三比特跨线
    editQuantumThree(quantum){
      this.dialogFormVisibledouble1 = false;
      const tianchong = document.getElementsByClassName("tianchong")[0];
      debugger
      this.column = quantum.getAttribute('index')-0//所在列
      if(Math.max(this.toffstart,this.toffmiddle,this.toffend)>this.num-1){
        this.$message.error("请填写正确的位置信息！");
        return;
      }else{
        if(this.toffstart==this.toffmiddle||this.toffstart==this.toffend||this.toffmiddle==this.toffend){
           this.$message.error("请填写正确的位置信息！");
           return;
        }else {
          quantum.setAttribute('start',this.toffstart)
          quantum.setAttribute('middle',this.toffmiddle)
          quantum.setAttribute('end',this.toffend)
        }
      }
      this.qasmShow()
    },
    //编辑跨线
    editQuantum(quantum){
      this.dialogFormVisibledouble = false;
      const tianchong = document.getElementsByClassName("tianchong")[0];
      this.column = quantum.getAttribute('index')-0//所在列
      
      this.end = this.end-0//跨线结束位置
      const name = quantum.getAttribute('name')
      
      quantum.setAttribute('start',this.start)
      
      if (Number(this.start) > this.end) {//当输入的开始位置大于结束位置时
        if(name == 'cx'){//当编辑的门为cx门时
             const maxline = Math.max(this.start,this.end)
             const minline = Math.min(this.start,this.end)
             if(maxline>this.num-1){
                this.$message.error("请填写正确的位置信息！");
                return;
             }else{
              if(quantum.getAttribute('class')=='turnCx'&&quantum.getElementsByClassName('cnotLine')[0]){
                quantum.firstChild.style.height = 94+45*(Math.abs(this.end - this.start)-1)+'px'
                quantum.firstChild.style.border = 'none'
                quantum.firstChild.style.display = 'inline-block'
                this.oldEnd = quantum.firstChild.getAttribute('end') -0 
              }else{
                const firstchild = quantum.firstChild.firstChild
                quantum.removeChild(quantum.firstChild)
                quantum.setAttribute('class','turnCx')
                quantum.appendChild(firstchild)
                quantum.firstChild.setAttribute('style','display: none; width: 40px; height: 94px; ') 
                quantum.firstChild.setAttribute('end',this.end) 
                quantum.setAttribute('start',this.start)
                quantum.lastChild.setAttribute('style','bottom:7px;left:-13px')
                quantum.lastChild.style.left = -11+this.column * 46+'px';
                quantum.firstChild.style.height = 94+45*(Math.abs(this.end - this.start)-1)+'px'
                const cnotLine = document.createElement('div')
                cnotLine.innerHTML = '<div class="cnotLine" style="display:inline-block;position: absolute;top:37px;left:'+(18+this.column*46)+'px;width: 2px;height: '+(36 + 50*(Math.abs(this.end - this.start)-1))+'px;background-color: blue;"><span class="cnotBottom" style="display: inline-block;width: 14px;height: 14px;background-color: blue;position: absolute;bottom: -10px;left: -6px;border-radius: 50%;"></span></div>'
                quantum.appendChild(cnotLine.firstChild)
                
              }
            //  quantum.appendChild(lastchild.firstChild)
            //  quantum.lastChild.setAttribute('end',this.start)
           
             this.oldStart = quantum.getAttribute('position')-0//上一次的开始位置
            
            
            //  quantum.setAttribute('position',this.start)
            let maxleng = 0
            for(var m=0;m<this.arr.length;m++){
              if(maxleng<this.arr[m].length){
                maxleng= this.arr[m].length
              }
            }
           for(var a=0;a<this.arr.length;a++){
              for(var b=0;b<maxleng;b++){
                if(!this.arr[a][b]){
                  this.arr[a][b] = tianchong.cloneNode(true)
                }
              }
            }
            
       
             if (Number(this.end) != this.oldEnd) {//当结束位置发生变化时
               if (Number(this.end) < this.oldEnd) {//当现在的结束位置比原来的结束位置小时
                //  this.arr[this.end].splice(Number(this.column),1, quantum);
                 if(this.oldEnd>this.oldStart){//翻转之前是正常cx量子门
                     debugger
                     for(var k = minline+1;k<=maxline;k++){
                       this.arr[k].splice(Number(this.column),0,tianchong.cloneNode(true))
                     }
                      this.arr[this.end].splice(Number(this.column),0,quantum)
                      let beforemin = Math.min(this.oldStart,this.oldEnd)
                      let beforemax = Math.max(this.oldStart,this.oldEnd)
                      for(var p = beforemin;p<=beforemax;p++){
                        this.arr[p].splice(Number(this.column)+1,1,tianchong.cloneNode(true))
                      }
                     
                    for(var turnDom = Number(this.end)+1;turnDom<=Number(this.start);turnDom++){
                      if(!this.arr[turnDom][this.column]){
                        this.arr[turnDom][this.column] = tianchong.cloneNode(true)
                        this.arr[turnDom][this.column].setAttribute('line', 'line')
                      }else{
                        if(this.arr[turnDom][this.column].getAttribute('name')=='tianchong'){
                          this.arr[turnDom][this.column].setAttribute('line','line') 
                        }else{
                          this.arr[turnDom].splice(this.column,0,tianchong.cloneNode(true))
                          this.arr[turnDom][this.column].setAttribute('line', 'line')
                        }
                      }

                    }
                 }else{//翻转之前是翻转cx门
                   if(this.arr[this.oldEnd][this.column].getAttribute('class')=='turnCx'){
                    this.arr[this.oldEnd].splice(Number(this.column),1,tianchong.cloneNode(true));
                  }
                 }
               } else {//当现在的结束位置比原来的结束位置大时
                 this.arr[this.end].splice(Number(this.column),0, quantum);
                 if(this.oldEnd>this.oldStart){//翻转之前是正常cx量子门
                    if(this.arr[this.oldStart][this.column].getAttribute('class')=='turnCx'){
                      this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true));
                  } 
                 }else{//翻转之前是翻转cx门
                   if(this.arr[this.oldEnd][this.column].getAttribute('class')=='turnCx'){
                    this.arr[this.oldEnd].splice(Number(this.column),1,tianchong.cloneNode(true));
                  }
                 }
                
               }
               if (Number(this.column) > this.arr[this.end].length) {//当列的位置大于元素所在行的最大拖放长度时
                 for (var i = this.arr[this.end].length;i <= Number(this.column);i++) {
                   this.arr[this.oldEnd][i] = tianchong.cloneNode(true);
                 }
               }
             }else{//结束位置未发生改变
             
                  this.arr[this.end].splice(Number(this.column),1, quantum);
                  if(this.oldEnd>this.oldStart){
                    this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true))
                  }else{
                    this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true))
                  }
             }
              // this.arr[this.end].splice(Number(this.column), 0, quantum);
            
          }
          
        // for(var i=0;i<this.arr.length;i++){
        //   for(var j=0;j<this.arr[i].length;j++){
        //     if(this.arr[i][j]){
        //       this.arr[i][j].setAttribute("line",'')
        //     }
        //   }
        // }
        // for (var s = Number(this.end)+1; s <= Number(this.start); s++) {//跨线的中间元素用填充占位
        //   for (var p = 0; p <=Number(this.column); p++) {
        //     if(!this.arr[s][p]){
        //       this.arr[s][p] = tianchong.cloneNode(true);
        //     }
        //   }
        // }
        for (var m = Number(this.end)+1; m <= Number(this.start); m++) {
          let length = 0;
          if (this.arr[Number(this.start)].length - 1 > Number(this.column)) {//当跨线元素的开始位置所在行的长度比此时元素的所在列大时
            length = this.arr[Number(this.start)].length - 1;
          } else {
            length = this.arr[Number(this.start)].length;
          }
          for (var n = this.arr[m].length; n < length; n++) {
            this.arr[m][n] = tianchong.cloneNode(true);
          }
        }
        for(var a=0;a<this.arr.length;a++){
          for(var b=0;b<this.arr[a].length;b++){
            if(this.arr[a][b]){
               if(this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz'){//是多量子比特门时
               debugger
                  const endline = Number(this.arr[a][b].lastChild.getAttribute('end'))
                  if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&endline){//多量子比特门存在结束位置属性时
                    for(var h=a+1;h<=endline;h++){
                      this.arr[h][b].setAttribute("line",'line')
                   }
                  }else if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&!endline){//多量子比特门不存在结束位置属性时
                      this.arr[a+1][b].setAttribute("line",'line')
                  }
                }
              }
            }
        }
         this.qasmShow()
        for (var i = 0; i < this.arr.length; i++) {
          const box = document.getElementById("box" + i);
          const boxChild = box.childNodes;
          for (var k = boxChild.length - 1; k >= 0; k--) {
            box.removeChild(boxChild[k]);
          }

          this.arr[i].forEach((item, index) => {
            if(item){
              if (item.getAttribute("name") === "cx"||item.getAttribute("name") === "swap"||item.getAttribute("name") === "cz") {
                if(item.getAttribute('class') != 'turnCx'){
                   item.setAttribute('position', i);
                } 
            }
              item.setAttribute("index",index)
              if(!this.$route.query.qobj_id){
                box.appendChild(item);
              }
            }
          });
          if(this.$route.query.qobj_id){//存在实验id时
            let item1;
              for (var ii = 0; ii < this.arr.length; ii++) {
                const box = document.getElementById("box" + ii);
                const boxChild = box.childNodes;
                for (var k = boxChild.length - 1; k >= 0; k--) {
                  box.removeChild(boxChild[k]);
                }
                for (var j = 0; j < this.arr[ii].length; j++) {
                  if(this.arr[ii][j]){
                    item1 = this.arr[ii][j];
                    if(item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                      if(item1.getAttribute('class')!='turnCx'){
                         item1.setAttribute("class", "online");
                       }
                    }
                    if(item1.getAttribute('name')!=='cx'&&item1.getAttribute('name')!=='swap'&&item1.getAttribute('name')!=='cz'&&item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                      item1.firstChild.lastChild.setAttribute("class",'bit')
                    }else if(item1.getAttribute('name')=='cx'){
                      if(item1.getAttribute('class')!='turnCx'){
                        item1.setAttribute('class','circle1')
                      }
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='swap'){
                      item1.setAttribute('class','xStart1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='cz'){
                      item1.setAttribute('class','circle1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='toffoli'){
                          if(item1.getAttribute('class')=='toffcircle2'){
                            item1.firstChild.firstChild.setAttribute('class','quantumline4')
                          }else if(item1.getAttribute('class')=='circle1'){
                            if(item1.firstChild.firstChild.getAttribute('name')=='end'){
                              item1.firstChild.firstChild.setAttribute('class','circle2')
                            }else{
                              item1.firstChild.firstChild.setAttribute('class','circle3')
                            }
                          }
                        }
                  }else{
                    this.arr[ii][j]=tianchong.cloneNode(true)
                    item1 = this.arr[ii][j].cloneNode(true);
                  }
                    this.arr.forEach((ele,index) =>{
                      ele.forEach((element,inx) =>{
                        if(element){
                           element.setAttribute("index",inx)
                        }
                      })
                    })
                  box.appendChild(item1);
                  };
              }
          }
        }


        }else{
          this.$message.error("开始位置应小于结束位置！");
          return;
        }
        
      } else if(Number(this.start) == this.end){
        this.$message.error("请填写正确的位置信息！");
        return;
      }else if (this.end > this.num - 1) {//当结束位置大于最大限制时
        this.$message.error("请选择正确的结束位置！");
        return;
      } else {
         this.dialogFormVisibledouble = false;
         this.oldStart = quantum.getAttribute('position')-0//上一次的开始位置
        if (Number(this.start) != this.oldStart) {//当当前的开始位置与上次开始位置不同时
    
          if (Number(this.start) < this.oldStart) {//当现在的开始位置比原来的开始位置小时
            if(quantum.getAttribute('class')=='turnCx'){
              let endNum = quantum.firstChild.getAttribute('end') - 0
              this.arr[endNum].splice(Number(this.column),1,tianchong.cloneNode(true));
            }else{
              this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true));
            }
          } else {//当现在的开始位置比原来的开始位置大时
            this.arr[this.oldStart].splice(Number(this.column), 1,tianchong.cloneNode(true));
          }
           
          if (Number(this.column) > this.arr[this.start].length) {//当列的位置大于元素所在行的最大拖放长度时
            for (var i = this.arr[this.start].length;i <= Number(this.column);i++) {
              this.arr[this.newStart][i] = tianchong.cloneNode(true);
            }
          }
          // if(this.end>this.oldEnd){
          //     this.arr[Number(this.start)].splice(Number(this.column), 1, quantum);
          // }else{
              
          // }
          this.arr[Number(this.start)].splice(Number(this.column), 0, quantum);
        }else{
         
           if(quantum.getAttribute('class')=='turnCx'){
              let endNum = quantum.firstChild.getAttribute('end') - 0
              this.arr[endNum].splice(Number(this.column),1,tianchong.cloneNode(true));
            }else{
              if(this.start > this.end){
                 this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true));
              }
            }
            if(this.start > this.end){
              this.arr[Number(this.end)].splice(Number(this.column), 0, quantum);
            }else{
              this.arr[Number(this.start)].splice(Number(this.column), 1, quantum);
            }
            
        } 
        if (Number(this.start) < this.oldStart) {//当此前更改开始位置小于原来开始位置时
          for (var m = Number(this.start) + 1; m < Number(this.oldStart); m++) {
            if (this.arr[m][Number(this.column)]) {
              if (this.arr[m][Number(this.column)].getAttribute("name") ==="swap" ||this.arr[m][Number(this.column)].getAttribute("quantum") ==="quantum") {
                this.$message.error("请选择合法位置！");
                return;
              }
            }
          }
        } else {
          for (var m = Number(this.start) + 1; m <= Number(this.end); m++) {
            if (this.arr[m][Number(this.column)]) {
              if (this.arr[m][Number(this.column)].getAttribute("name") ==="cx" ||this.arr[m][Number(this.column)].getAttribute("name")=="swap"||this.arr[m][Number(this.column)].getAttribute("name")=="cz" ||this.arr[m][Number(this.column)].getAttribute("quantum") ==="quantum") {
                this.$message.error("请选择合法位置！");
                return;
              }
            }
          }
        }

        
       
        for (var s = Number(this.start)+1; s <= Number(this.end); s++) {//跨线的中间元素用填充占位
          for (var p = 0; p <=Number(this.column); p++) {
            if(!this.arr[s][p]){
              this.arr[s][p] = tianchong.cloneNode(true);
            }
          }
        }
        for(var i=0;i<this.arr.length;i++){
          for(var j=0;j<this.arr[i].length;j++){
            if(this.arr[i][j]){
              this.arr[i][j].setAttribute("line",'')
            }
          }
        }
        for (var m = Number(this.start)+1; m <= Number(this.end); m++) {
          let length = 0;
          if (this.arr[Number(this.start)].length - 1 > Number(this.column)) {//当跨线元素的开始位置所在行的长度比此时元素的所在列大时
            length = this.arr[Number(this.start)].length - 1;
          } else {
            length = this.arr[Number(this.start)].length;
          }
          for (var n = this.arr[m].length; n < length; n++) {
            this.arr[m][n] = tianchong.cloneNode(true);
          }
        }
          quantum.lastChild.setAttribute('end',this.end)//元素上设置上结束位置属性
        for(var a=0;a<this.arr.length;a++){
          for(var b=0;b<this.arr[a].length;b++){
            if(this.arr[a][b]){
               if(this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz'){//是多量子比特门时
                  var endline = 0
                  if(this.arr[a][b].getAttribute('class')!='turnCx'){
                    endline = Number(this.arr[a][b].lastChild.getAttribute('end'))
                  }else{
                     endline = Number(this.arr[a][b].firstChild.getAttribute('end'))
                  }
                  if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&endline){//多量子比特门存在结束位置属性时
                   if(this.arr[a][b].getAttribute('class') !='turnCx'){
                      for(var h=a+1;h<=endline;h++){
                         this.arr[h][b].setAttribute("line",'line')
                        }
                   }else{
                     for(var h=a;h<endline;h++){
                      this.arr[h][b].setAttribute("line",'line')
                     }
                    }  
                  }else if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&!endline){//多量子比特门不存在结束位置属性时
                      if(this.arr[a][b].getAttribute('class') !='turnCx'){
                        this.arr[a+1][b].setAttribute("line",'line')
                      }else{
                        this.arr[a][b].setAttribute("line",'line')
                      }
                      
                  }
                }
              }
            }
        }
        if(Number(this.start)<this.end){
          this.arr[Number(this.start)][this.column].setAttribute('class','circle1')
        }
         this.qasmShow()
        for (var i = 0; i < this.arr.length; i++) {
          const box = document.getElementById("box" + i);
          const boxChild = box.childNodes;
          for (var k = boxChild.length - 1; k >= 0; k--) {
            box.removeChild(boxChild[k]);
          }

          this.arr[i].forEach((item, index) => {
            if(item){
              if (item.getAttribute("name") === "cx"||item.getAttribute("name") === "swap"||item.getAttribute("name") === "cz") {
              item.setAttribute("position", i);
            }
              item.setAttribute("index",index)
              if(!this.$route.query.qobj_id){
                box.appendChild(item);
              }
            }
          });

          if(this.$route.query.qobj_id){//存在实验id时
            let item1;
              for (var ii = 0; ii < this.arr.length; ii++) {
                const box = document.getElementById("box" + ii);
                const boxChild = box.childNodes;
                for (var k = boxChild.length - 1; k >= 0; k--) {
                  box.removeChild(boxChild[k]);
                }
                for (var j = 0; j < this.arr[ii].length; j++) {
                  if(this.arr[ii][j]){
                    item1 = this.arr[ii][j];
                    if(item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                     if(item1.getAttribute('class')!='turnCx'){
                        item1.setAttribute("class", "online");
                      }
                    }
                    if(item1.getAttribute('name')!=='cx'&&item1.getAttribute('name')!=='swap'&&item1.getAttribute('name')!=='cz'&&item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                      item1.firstChild.lastChild.setAttribute("class",'bit')
                    }else if(item1.getAttribute('name')=='cx'){
                      if(item1.getAttribute('class')!='turnCx'){
                        item1.setAttribute('class','circle1')
                      }
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='swap'){
                      item1.setAttribute('class','xStart1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='cz'){
                      item1.setAttribute('class','circle1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='toffoli'){
                      if(item1.getAttribute('class')=='toffcircle2'){
                        item1.firstChild.firstChild.setAttribute('class','quantumline4')
                      }else if(item1.getAttribute('class')=='circle1'){
                        if(item1.firstChild.firstChild.getAttribute('name')=='end'){
                          item1.firstChild.firstChild.setAttribute('class','circle2')
                        }else{
                          if(item1.firstChild.firstChild.getAttribute('name')=='end'){
                            item1.firstChild.firstChild.setAttribute('class','circle2')
                          }else{
                            item1.firstChild.firstChild.setAttribute('class','circle3')
                          }
                        }
                          
                      }
                    }
                  }else{
                    this.arr[ii][j]=tianchong.cloneNode(true)
                    item1 = this.arr[ii][j].cloneNode(true);
                  }
                    this.arr.forEach((ele,index) =>{
                      ele.forEach((element,inx) =>{
                        if(element){
                           element.setAttribute("index",inx)
                        }
                      })
                    })
                  box.appendChild(item1);
                  };
              }
          }
        }
      
      }
    },
    //编辑量子门角度
    angleEdit(quantum){
      this.dialogEditAngle = true
      this.angleQuantum = quantum
      // console.log(quantum)
    },
    //每个量子门点击出现功能边框
    quantumBorder(){
      let _this = this
      for(var i=0;i<this.arr.length;i++){
        for(var j=0;j<this.arr[i].length;j++){
          if(this.arr[i][j]&&this.arr[i][j].getAttribute('name')!='tianchong'){//元素存在且不为填充元素时
          const item = this.arr[i][j]
          const itempa = item.parentNode
          const itempaBro = itempa.parentNode.parentNode.parentNode.childNodes
          const itemBro = itempa.childNodes
          if(item.getAttribute('name')!='tianchong'&&item.getAttribute('name')!='cx'&&item.getAttribute('name')!='swap'&&item.getAttribute('name')!='cz'&&item.getAttribute('name')!='toffoli'){//元素为单量子比特门时
           item.addEventListener('click',function(){
              if(item.getAttribute('name')=='u1'||item.getAttribute('name')=='rx'||item.getAttribute('name')=='ry'||item.getAttribute('name')=='rz'){
                  _this.isSingleangle = true
                  _this.isDoubleangle = false
                  _this.isMultiangle = false
                  // debugger
                  if(!item.getAttribute('angle')){
                      _this.angleform.angle=1.570796
                  }else{
                      _this.angleform.angle = (item.getAttribute('angle')-0).toFixed(6)
                  }
                }else if(item.getAttribute('name')=='u2'){
                  _this.isSingleangle = false
                  _this.isDoubleangle = true
                  _this.isMultiangle = false
                  if(!item.getAttribute('angle1')){
                        _this.angleform.angle1=1.570796
                  }else{
                      _this.angleform.angle1 = (item.getAttribute('angle1')-0).toFixed(6)
                  }
                  if(!item.getAttribute('angle2')){
                      _this.angleform.angle2=-3.141593
                  }else{
                    _this.angleform.angle2 = (item.getAttribute('angle2')-0).toFixed(6)
                  }
                }else if(item.getAttribute('name')=='u3'){
                  _this.isSingleangle = false
                  _this.isDoubleangle = false
                  _this.isMultiangle = true
                  if(!item.getAttribute('angle1')){
                        _this.angleform.angle1=1.570796
                  }else{
                    _this.angleform.angle1 = (item.getAttribute('angle1')-0).toFixed(6)
                  }
                  if(!item.getAttribute('angle2')){
                        _this.angleform.angle3=4.712389
                  }else{
                    _this.angleform.angle3 = (item.getAttribute('angle2')-0).toFixed(6)
                  }
                  if(!item.getAttribute('angle3')){
                        _this.angleform.angl4=1.570796
                  }else{
                    _this.angleform.angle4 = (item.getAttribute('angle3')-0).toFixed(6)
                  }
                }
              for(var n=0;n<itempaBro.length;n++){
                const itembox = itempaBro[n].lastChild.lastChild.childNodes
                for(var m=0;m<itembox.length;m++){
                  if(itembox[m].getAttribute('name')!='tianchong'&&itembox[m].getAttribute('name')!='cx'&&itembox[m].getAttribute('name')!='swap'&&itembox[m].getAttribute('name')!='cz'&&itembox[m].getAttribute('name')!='toffoli'){
                     if(itembox[m].getAttribute('name')=='u1'||itembox[m].getAttribute('name')=='u2'||itembox[m].getAttribute('name')=='u3'||itembox[m].getAttribute('name')=='rx'||itembox[m].getAttribute('name')=='ry'
                        ||itembox[m].getAttribute('name')=='rz'
                      ){
                        itembox[m].firstChild.childNodes[1].style.display = 'none'

                      }
                    itembox[m].firstChild.style.border = 'none'
                    itembox[m].firstChild.firstChild.style.display = 'none'
                  }else if((itembox[m].getAttribute('name')=='cx'||itembox[m].getAttribute('name')=='swap'||itembox[m].getAttribute('name')=='cz')&&itembox[m].getAttribute('class')!=='turnCx'){//元素为多量子比特门时
                      itembox[m].lastChild.style.border = 'none'
                      itembox[m].lastChild.firstChild.style.display = 'none'
                      itembox[m].lastChild.lastChild.style.display = 'none'
                  }else if(itembox[m].getAttribute('class')=='turnCx'){
                    itembox[m].firstChild.style.border = 'none'
                    itembox[m].firstChild.firstChild.style.display = 'none'
                    itembox[m].firstChild.lastChild.style.display = 'none'
                 }else if(itembox[m].getAttribute('name')=='toffoli'){
                      itembox[m].lastChild.style.border = 'none'
                      itembox[m].lastChild.lastChild.style.display = 'none'
                      itembox[m].lastChild.firstChild.style.display = 'none'
                     
                  }
              }
          }
            item.firstChild.style.border = '1px dashed #EAEAEA'
            item.firstChild.firstChild.style.display = 'inline-block'
            if(item.getAttribute('name')=='u1'||item.getAttribute('name')=='u2'||item.getAttribute('name')=='u3'||item.getAttribute('name')=='rx'||item.getAttribute('name')=='ry'
              ||item.getAttribute('name')=='rz'
            ){
              // debugger
              // item.firstChild.childNodes[1].style.display = 'inline-block'
              item.firstChild.childNodes[1].style.display = 'inline-block'
              item.firstChild.childNodes[1].addEventListener('click',()=>{
                _this.angleEdit(item)
              })
            }
            
          })
          item.firstChild.firstChild.addEventListener('click',function(){
            _this.deleteOne(item)
          })
          }else if(item.getAttribute('name')=='cx'||item.getAttribute('name')=='swap'||item.getAttribute('name')=='cz'){
            item.addEventListener('click',function(){//元素添加点击事件
              for(var i=0;i<itempaBro.length;i++){
                 const itembox = itempaBro[i].lastChild.lastChild.childNodes
                for(var j=0;j<itembox.length;j++){
                  if(itembox[j].getAttribute('name')!='tianchong'&&itembox[j].getAttribute('name')!='cx'&&itembox[j].getAttribute('name')!='swap'&&itembox[j].getAttribute('name')!='cz'&&itembox[j].getAttribute('name')!='toffoli'){//单量子比特
                     if(itembox[j].getAttribute('name')=='u1'||itembox[j].getAttribute('name')=='u2'||itembox[j].getAttribute('name')=='u3'||itembox[j].getAttribute('name')=='rx'||itembox[j].getAttribute('name')=='ry'||itembox[j].getAttribute('name')=='rz'){
                      itembox[j].firstChild.childNodes[1].style.display = 'none'
                    }
                    itembox[j].firstChild.style.border = 'none'
                    itembox[j].firstChild.firstChild.style.display = 'none'
                  }else if((itembox[j].getAttribute('name')=='cx'||itembox[j].getAttribute('name')=='swap'||itembox[j].getAttribute('name')=='cz')&&itembox[j].getAttribute('class')!=='turnCx'){
                      itembox[j].lastChild.style.border = 'none'
                      itembox[j].lastChild.firstChild.style.display = 'none'
                      itembox[j].lastChild.lastChild.style.display = 'none'
                  }else if(itembox[j].getAttribute('class')=='turnCx'){//翻转的cnot门
                    let columnPosition = itembox[j].getAttribute('index')-0
                    itembox[j].firstChild.style.display = 'none'
                    itembox[j].firstChild.style.border = '1px dashed #EAEAEA'
                    itembox[j].firstChild.firstChild.style.right ='-8px'
                    itembox[j].firstChild.lastChild.style.right =  '-8px'
                    
                  }else if(itembox[j].getAttribute('name')=='toffoli'){
                     itembox[j].lastChild.style.border = '0px dashed #EAEAEA'
                      itembox[j].lastChild.firstChild.style.display = 'none'
                      itembox[j].lastChild.lastChild.style.display = 'none'
                    
                  }
                }
              }
              if(item.getAttribute('class')!='turnCx'){
                item.lastChild.style.border = '1px dashed #EAEAEA'
                item.lastChild.firstChild.style.display = 'inline-block'
                item.lastChild.lastChild.style.display = 'inline-block'
              }else{
                item.firstChild.style.display = 'inline-block'
                item.firstChild.style.position = 'relative'
                item.firstChild.style.border = '1px dashed #EAEAEA'
                item.firstChild.firstChild.style.display = 'inline-block'
                item.firstChild.lastChild.style.display = 'inline-block'
              }
                
              
            })
                
            if(item.getAttribute('class') == 'turnCx'){
              item.firstChild.firstChild.addEventListener('click',function(e){
                e.stopPropagation()
               _this.deleteTwo(item.firstChild)
               })
              //编辑按钮点击事件
              item.firstChild.lastChild.addEventListener('click',function(e){
                e.stopPropagation()
                  _this.showedit(item)
              })
            }else{
              item.lastChild.firstChild.addEventListener('click',function(e){
                e.stopPropagation()
               _this.deleteTwo(item.lastChild)
               })
              //编辑按钮点击事件
              item.lastChild.lastChild.addEventListener('click',function(e){
                e.stopPropagation()
                  _this.showedit(item)
              })
            }
           }else if(item.getAttribute('name')=='toffoli'){
               item.addEventListener('click',()=>{
               for(var i=0;i<itempaBro.length;i++){
                 const itembox = itempaBro[i].lastChild.lastChild.childNodes
                for(var j=0;j<itembox.length;j++){
                  if(itembox[j].getAttribute('name')!='tianchong'&&itembox[j].getAttribute('name')!='cx'&&itembox[j].getAttribute('name')!='swap'&&itembox[j].getAttribute('name')!='cz'&&itembox[j].getAttribute('name')!='toffoli'){//单量子比特
                    if(itembox[j].getAttribute('name')=='u1'||itembox[j].getAttribute('name')=='u2'||itembox[j].getAttribute('name')=='u3'||itembox[j].getAttribute('name')=='rx'||itembox[j].getAttribute('name')=='ry'||itembox[j].getAttribute('name')=='rz'){
                      itembox[j].firstChild.childNodes[1].style.display = 'none'
                    }
                     itembox[j].firstChild.style.border = 'none'
                     itembox[j].firstChild.firstChild.style.display = 'none'
                  }else if((itembox[j].getAttribute('name')=='cx'||itembox[j].getAttribute('name')=='swap'||itembox[j].getAttribute('name')=='cz')&&itembox[j].getAttribute('class')!=='turnCx'){
                      itembox[j].lastChild.style.border = 'none'
                      itembox[j].lastChild.firstChild.style.display = 'none'
                      itembox[j].lastChild.lastChild.style.display = 'none'
                  }else if(itembox[j].getAttribute('class')=='turnCx'){//翻转的cnot门
                    let columnPosition = itembox[j].getAttribute('index')-0
                    itembox[j].firstChild.style.display = 'none'
                    itembox[j].firstChild.style.border = '1px dashed #EAEAEA'
                    itembox[j].firstChild.firstChild.style.right ='-8px'
                    itembox[j].firstChild.lastChild.style.right =  '-8px'
                    
                  }else if(itembox[j].getAttribute('name')=='toffoli'){
                      itembox[j].lastChild.style.border = '0px dashed #EAEAEA'
                      itembox[j].lastChild.firstChild.style.display = 'none'
                      itembox[j].lastChild.lastChild.style.display = 'none'
                  }
                }
              }
               item.lastChild.style.border = '1px dashed #EAEAEA'
               item.lastChild.style.display = 'inline-block'
               item.lastChild.lastChild.style.display = 'inline-block'
               item.lastChild.firstChild.style.display = 'inline-block'
               item.lastChild.lastChild.onclick = function(){
                   _this.toffolishowedit(item)
                }
               item.lastChild.firstChild.onclick = function(){
                   _this.deleteTwo(item.lastChild)
                }
             })
           
           }
          }
        }
      }
    },
    //随机实验名称
    setTestName() {
      const date = new Date();//获取此时的实时时间
      //年
      var year=date.getFullYear();
      //月
      var month=(date.getMonth()+1)<10?"0"+(date.getMonth()+1):(date.getMonth()+1);
      //日
      var day=date.getDate()<10?"0"+date.getDate():date.getDate();


      var nowTime = year+"/"+month+"/"+day
      let code = "";
      for (var i = 1; i <= 6; i++) {
        const num = Math.floor(Math.random() * 10);
        code += num;
      }
      this.ruleForm.name = "LZY-" + nowTime.match(/\d+/g) + code;//实验名称
      this.ruleForm.name = this.ruleForm.name.replace(/,+/g,'')
    },
    //查询所有任务列表
    async allTaskList() {
      const params = {
        // user_id: this.user_id,
        page: "1",
        num: "10"
      };
      const { data } = await queyTaskInfoList(params);
      if (data.code === "0") {
      }
    },
    //去详情页
    toDetail(id) {
      this.$router.push({
        path:
          "/about"
      });
    },
    shotsChange(e) {
      console.log(e)
      this.shots = e;
    },
    //运行实验进行的逻辑
    operationTest(ruleForm){
      let that = this
       this.isloadimgbtn  = true     
      // this.$refs['runRuleForm'].validate((valid)=>{
      //     if(valid){
            if(!this.qobj_id&&!this.$route.query.qobj_id){//新创建电路运行
               this.flag = 0
               this.save(ruleForm)
            }else if(this.qobj_id&&!this.$route.query.qobj_id){//新创建电路保存后运行
              this.flag = 1
              this.save(ruleForm)
            }else if(this.$route.query.qobj_id&&!this.qobj_id){//旧电路编辑后没保存运行
              this.flag = 2
              this.save(ruleForm)
            }else if(this.$route.query.qobj_id&&this.qobj_id){//旧电路编辑后保存后运行
              this.validity(ruleForm)
            }
            let timeout = setTimeout(()=>{
              this.isloadimgbtn = false
            },3000)
          // }else{
          //   return false
          // }
      // })
    },
    //验证实验
  async validity(ruleForm) {
    if(this.num>8&&this.selectMechine == 'computer'){
         this.$message({
             message: "该机器只支持8比特，请选择合适的机器！",
             type: "error"
           });
           return false
    }else{
      this.$refs.ruleForm.validate(async valid => {
        if (!valid) {
          return false;
        } else {
          this.instructions = [];
          this.qubit_labels = [];
          this.header = {};
          let beforeline = 0
          let  column=0
          let maxlength = 0
          this.memory_slots=0
          for(var h=0;h<this.arr.length;h++){
            if(this.arr[h].length>maxlength){//获取线路图的最大长度
              maxlength = this.arr[h].length
            }
          }
          for (var j = beforeline; j < maxlength; j++) {
            for(var i=0;i<this.arr.length;i++){
              if(this.arr[i][j]){
                let  name = this.arr[i][j].getAttribute("name");//元素名称
              // this.qubits = [i];
              if(name==='cx'||name==='swap'||name==='cz'||name==='toffoli'){//多量子比特门时
                column = Number(this.arr[i][j].getAttribute("index"))//该量子比特的所在列
                for(var a=0;a<this.num;a++){
                  for(var b=beforeline;b<column;b++){
                    if(this.arr[a][b]!==undefined){
                      const namel = this.arr[a][b].getAttribute('name')
                      if(namel !=='tianchong'&&namel !='cx'&&namel !='swap'&&namel !='cz'&&namel!=='measure'){//该量子比特为单量子比特且不为测量元素时
                        if(namel=='u1'||namel=='rx'||namel=='ry'||namel=='rz'){
                           let angle = this.arr[a][b].getAttribute('angle')-0
                           this.instructions.push({name:namel,qubits:[a],angle:[angle]})
                         }else if(namel=='u2'){
                            let angle1 = this.arr[a][b].getAttribute('angle1')-0
                            let angle2 = this.arr[a][b].getAttribute('angle2')-0
                            this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2]})
                         }else if(namel=='u3'){
                            let angle1 = this.arr[a][b].getAttribute('angle1')-0
                            let angle2 = this.arr[a][b].getAttribute('angle2')-0
                            let angle3 = this.arr[a][b].getAttribute('angle3')-0
                            this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2,angle3]})
                         }else{
                           this.instructions.push({name:namel,qubits:[a]})
                         }
                      }
                    }
                  }
                }
                for(var m=0;m<this.num;m++){
                  if(this.arr[m][column]){
                    let name = this.arr[m][column].getAttribute("name")//元素名称
                   if(name==='cx'||name==='swap'||name==='cz'){//多量子比特门时
                    const start = Number(this.arr[m][column].getAttribute("position"))
                    let end
                    if(this.arr[m][column].getAttribute('class')=='turnCx'){
                      end = Number(this.arr[m][column].firstChild.getAttribute("end"))
                    }else{
                      end = Number(this.arr[m][column].lastChild.getAttribute("end"))
                    }
                    this.qubits = [start,end]
                    this.instructions.push({name:name,qubits:this.qubits})
                  }else if(name==='toffoli'){
                      const start = Number(this.arr[m][column].getAttribute("start"))
                      const middle = Number(this.arr[m][column].getAttribute("middle"))
                      const end = Number(this.arr[m][column].getAttribute("end"))
                      this.qubits = [start,middle,end]
                      this.instructions.push({name:name,qubits:this.qubits})
                  }else if(name !=='tianchong'&&name !='cx'&&name !='swap'&&name !='cz'&&name !=='measure'){//该量子比特为单量子比特且不为测量元素时
                    this.qubits = [m]
                    // this.instructions.push({name:name,qubits:this.qubits})
                    if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                       let angle = this.arr[m][column].getAttribute('angle')-0
                       this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                     }else if(name=='u2'){
                        let angle1 = this.arr[m][column].getAttribute('angle1')-0
                        let angle2 = this.arr[m][column].getAttribute('angle2')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                     }else if(name=='u3'){
                        let angle1 = this.arr[m][column].getAttribute('angle1')-0
                        let angle2 = this.arr[m][column].getAttribute('angle2')-0
                        let angle3 = this.arr[m][column].getAttribute('angle3')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                     }else{
                       this.instructions.push({name:name,qubits:this.qubits})
                     }
                   }
                  }
                }
               beforeline = column +1
              }
              }
            }
          }
          if(beforeline<=maxlength){
               for(var k=0;k<this.arr.length;k++){
                 for(var g=beforeline;g<maxlength;g++){
                   if(this.arr[k][g]){
                       name = this.arr[k][g].getAttribute("name")
                      if(name!=='measure'){//不为测量元素的量子
                        this.qubits = [k]
                        // this.instructions.push({name:name,qubits:this.qubits})
                         if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                           let angle =this.arr[k][g].getAttribute('angle')-0
                           this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                         }else if(name=='u2'){
                            let angle1 =this.arr[k][g].getAttribute('angle1')-0
                            let angle2 =this.arr[k][g].getAttribute('angle2')-0
                            this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                         }else if(name=='u3'){
                            let angle1 =this.arr[k][g].getAttribute('angle1')-0
                            let angle2 =this.arr[k][g].getAttribute('angle2')-0
                            let angle3 =this.arr[k][g].getAttribute('angle3')-0
                            this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                         }else{
                           this.instructions.push({name:name,qubits:this.qubits})
                         }
                     }
                   }
                 }
               }
             }
             for (var j = 0; j < this.arr.length; j++) {
               this.arr[j].forEach(ele => {
                 const name = ele.getAttribute("name");
                 if (name === "measure") {//测量元素的操作
                   this.memory_slots++;
                   this.instructions.push({
                     memory: [j],
                     name: name,
                     qubits: [j]
                   });
                 }
               });
             }
             this.arr.forEach((ele, index) => {
               this.qubit_labels.push(["q", index]);
             });
              this.clbit_labels=[]
             for (var k = 0; k < this.memory_slots; k++) {
               this.clbit_labels.push(["c", k]);
             }
             this.header = {
               creg_sizes: [["c", this.num1]], //[creg_name, size]列表
               name: "circuit0", //提交的此量子实验的量子线路名称
               qubit_labels: this.qubit_labels, //[qreg_name, n]，用于指示相应的物理量子比特作为第n个量子比特的量子寄存器qreg_name
               qreg_sizes: ["q", this.num], //[qreg_name, size]的列表，用于指定QASM量子寄存器和它们的尺寸
               n_qubits: this.num, //后端机器的量子比特数，等于量子实验中最大的量子比特数
               memory_slots: this.memory_slots, //在此量子实验中使用的测量slot总数
               clbit_labels: this.clbit_labels //内存memory_slots列表，每一个元素是[creg_name, n]，用于指示经典寄存器creg_name的第n个元素对应的memory slot
             };
             this.qubitdata = {
               experiments: [
                 {
                   instructions: this.instructions, //量子实验执行的量子指令列表
                   header: this.header,
                   config: {
                     n_qubits: this.num, //后端机器的量子比特数
                     memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
                   }
                 }
               ],
               schema_version: this.schema_version, //用于编译qobj的schema版本
               type: this.selectMechine, //用于量子实验的指令类型，QASM还是PULSE
               qobj_id: this.qobj_id, //用户生成的qobj的id
               device_id: this.device_id?this.device_id:'001', //量子实验任务要运行的计算机ID
               device_name: this.device_name,
               // user_id: this.user_id,
               config: {
                 shots: this.shots, //每个量子实验的重复次数
                 n_qubits: this.num, //后端机器的量子比特数
                 memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
               }
             };
             if (this.checked) {
               this.is_sample = "Y";
             } else {
               this.is_sample = "N";
             }
             if(this.verifyCode == true){
               if(this.isoverLimit == false){
                  const params = {
                  experiments: JSON.parse(
                    JSON.stringify(Object.values(this.qubitdata)[0])
                  ),
                  schema_version: Object.values(this.qubitdata)[1], //用于编译qobj的schema版本
                  type: Object.values(this.qubitdata)[2], //用于量子实验的指令类型，QASM还是PULSE
                  qobj_id: Object.values(this.qubitdata)[3], //用户生成的qobj的id
                  device_id: Object.values(this.qubitdata)[4], //量子实验任务要运行的计算机ID
                  device_name: Object.values(this.qubitdata)[5],
                  // user_id: Object.values(this.qubitdata)[6],
                  config: JSON.parse(JSON.stringify(Object.values(this.qubitdata)[6])),
                  programming:this.publicCode+this.code
                };

                const  {data}  = await getValidate(params);
                if (data.code == "0") {
                  this.$message({
                      message: "运行成功",
                      type: "success"
                    });
                      this.dialogFormVisible = false;
                       this.queryTaskList();
                }else{
                  this.$message.error(data.errMsg)
                  this.dialogFormVisible = false;
                }
               }else{
                this.$message({
                  message: '超出数量限制',
                  type: 'warning',
                  duration:3000
                });
               }

             }else{
                this.$message.error('代码有误，请更正后运行！')
             }
           }
      });
    }

   },
    //当前页改变
    current_change(currentPage) {
      this.currentPage = currentPage;
      this.queryTaskList();
    },
    //查询一个实验的任务列表
    async queryTaskList() {
      const params = {
        pageNum: this.currentPage,//当前页
        pageSize: this.pageSize,//页数
        qobj_id: this.$route.query.qobj_id?this.$route.query.qobj_id:this.qobj_id
      };
      // const {data}  = await queyOneTaskInfoList(params);
      const data = {
        code: "0",
        data: [
          {
            bit_number: "1",
            completetime: "2022-10-19 11:34:53",
            creationtime: "2022-10-19 11:34:42",
            device_id: "001",
            device_name: "浪潮量子计算模拟机",
            errormessage: null,
            estimatedCompletionTime: null,
            experimentname: null,
            id: "aee054f9-bbf2-4860-ae94-5dec49ebc818",
            job_id: "fdfc26ce4f5e11eda5a2fa163e4b0774",
            job_ids: null,
            jsondata: "{\"experiments\":[{\"instructions\":[{\"name\":\"h\",\"qubits\":[0]},{\"memory\":[0],\"name\":\"measure\",\"qubits\":[0]}],\"header\":{\"creg_sizes\":[[\"c\",1]],\"name\":\"circuit0\",\"qubit_labels\":[[\"q\",0]],\"qreg_sizes\":[\"q\",1],\"n_qubits\":1,\"memory_slots\":1,\"clbit_labels\":[[\"c\",0]]},\"config\":{\"n_qubits\":1,\"memory_slots\":1}}],\"schema_version\":\"v1.0\",\"type\":\"simulation\",\"qobj_id\":\"d798a6f8-c2dc-4cd1-a5a1-e290aaee1124\",\"device_id\":\"001\",\"device_name\":\"浪潮量子计算模拟机\",\"config\":{\"shots\":1024,\"n_qubits\":1,\"memory_slots\":1},\"programming\":\"OPENQASM 2.0;\\n                     \\n\\nqreg  q[1];\\ncreg  c[1];\\n\\nh  q[0];\\nmeasure  q[0];\\n\"}",
            jsondataconver: null,
            name: null,
            pageNum: null,
            pageSize: null,
            position: null,
            programming: null,
            programmingconver: null,
            qobj_id: "d798a6f8-c2dc-4cd1-a5a1-e290aaee1124",
            result: "{\"total\":1024,\"data\":[{\"X\":\"0\",\"Y\":510},{\"X\":\"1\",\"Y\":514}]}",
            shots: "1024",
            starttime: "2022-10-19 11:34:52",
            status: "DONE",
            tmpstr: null,
            type: "simulation",
            userId: "5f581993-7847-4e5c-97b5-120807db115f",
          },
          {
            bit_number: "1",
            completetime: "2022-10-19 11:34:53",
            creationtime: "2022-10-19 11:34:39",
            device_id: "001",
            device_name: "浪潮量子计算模拟机",
            errormessage: null,
            estimatedCompletionTime: null,
            experimentname: null,
            id: "e0e4afc1-639c-4084-9ec6-9ad7728b94c4",
            job_id: "fdf863b84f5e11eda2a8fa163e23b6de",
            job_ids: null,
            jsondata: "{\"experiments\":[{\"instructions\":[{\"name\":\"h\",\"qubits\":[0]},{\"memory\":[0],\"name\":\"measure\",\"qubits\":[0]}],\"header\":{\"creg_sizes\":[[\"c\",1]],\"name\":\"circuit0\",\"qubit_labels\":[[\"q\",0]],\"qreg_sizes\":[\"q\",1],\"n_qubits\":1,\"memory_slots\":1,\"clbit_labels\":[[\"c\",0]]},\"config\":{\"n_qubits\":1,\"memory_slots\":1}}],\"schema_version\":\"v1.0\",\"type\":\"simulation\",\"qobj_id\":\"d798a6f8-c2dc-4cd1-a5a1-e290aaee1124\",\"device_id\":\"001\",\"device_name\":\"浪潮量子计算模拟机\",\"config\":{\"shots\":1024,\"n_qubits\":1,\"memory_slots\":1},\"programming\":\"OPENQASM 2.0;\\n                     \\n\\nqreg  q[1];\\ncreg  c[1];\\n\\nh  q[0];\\nmeasure  q[0];\\n\"}",
            jsondataconver: null,
            name: null,
            pageNum: null,
            pageSize: null,
            position: null,
            programming: null,
            programmingconver: null,
            qobj_id: "d798a6f8-c2dc-4cd1-a5a1-e290aaee1124",
            result: "{\"total\":1024,\"data\":[{\"X\":\"0\",\"Y\":513},{\"X\":\"1\",\"Y\":511}]}",
            shots: "1024",
            starttime: "2022-10-19 11:34:52",
            status: "DONE",
            tmpstr: null,
            type: "simulation",
            userId: "5f581993-7847-4e5c-97b5-120807db115f",
          },
          {
            bit_number: "1",
            completetime: "2022-10-19 11:34:40",
            creationtime: "2022-10-19 11:34:35",
            device_id: "001",
            device_name: "浪潮量子计算模拟机",
            errormessage: null,
            estimatedCompletionTime: null,
            experimentname: null,
            id: "1a8d44f4-5d47-4b7c-9776-3d0590b528e5",
            job_id: "f50f6ee04f5e11edb401fa163ef0d0d8",
            job_ids: null,
            jsondata: "{\"experiments\":[{\"instructions\":[{\"name\":\"h\",\"qubits\":[0]},{\"memory\":[0],\"name\":\"measure\",\"qubits\":[0]}],\"header\":{\"creg_sizes\":[[\"c\",1]],\"name\":\"circuit0\",\"qubit_labels\":[[\"q\",0]],\"qreg_sizes\":[\"q\",1],\"n_qubits\":1,\"memory_slots\":1,\"clbit_labels\":[[\"c\",0]]},\"config\":{\"n_qubits\":1,\"memory_slots\":1}}],\"schema_version\":\"v1.0\",\"type\":\"simulation\",\"qobj_id\":\"d798a6f8-c2dc-4cd1-a5a1-e290aaee1124\",\"device_id\":\"001\",\"device_name\":\"浪潮量子计算模拟机\",\"config\":{\"shots\":1024,\"n_qubits\":1,\"memory_slots\":1},\"programming\":\"OPENQASM 2.0;\\n                     \\n\\nqreg  q[1];\\ncreg  c[1];\\n\\nh  q[0];\\nmeasure  q[0];\\n\"}",
            jsondataconver: null,
            name: null,
            pageNum: null,
            pageSize: null,
            position: null,
            programming: null,
            programmingconver: null,
            qobj_id: "d798a6f8-c2dc-4cd1-a5a1-e290aaee1124",
            result: "{\"total\":1024,\"data\":[{\"X\":\"0\",\"Y\":522},{\"X\":\"1\",\"Y\":502}]}",
            shots: "1024",
            starttime: "2022-10-19 11:34:37",
            status: "DONE",
            tmpstr: null,
            type: "simulation",
            userId: "5f581993-7847-4e5c-97b5-120807db115f",
          },
        ],
        errMsg: "",
        message: "查询成功",
        result: "true",
        total: 16,
      }
      this.dataList1 = data.data;
      if(this.dataList1.length!=0){
        this.thisTestList = true
      }
      this.total = data.total;
    },
    //选择机器之前保存更改之前的值
    saveBeforeValue(e,value){
      // this.beforeSaveId = value
      this.beforeSaveValue = this.form.computed[value].machineName
    },
    //选择机器
    changevalue(e) {
      if(this.arr.length == 1&&this.arr[0].length == 0){
        this.device_id = e
        this.selectValue = e
        this.beforeSaveId = e
        this.selectMechine = this.form.computed[e].provider
        this.device_name = this.form.computed[e].machineName;
      }else{
        if(this.beforeSaveId == e){
            return true
        }else{
          let that = this
          this.$confirm('切换后端将清空当前页面的数据，请问是否切换？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.device_id = e
            that.selectValue = e
            that.beforeSaveId = e
            that.selectMechine = that.form.computed[e].provider
            that.device_name = that.form.computed[e].machineName;
            that.code = ''
            that.num = 1
            that.num1 = 1
            that.register = 1
            that.createQasm().setValue(that.code)

            const lineWrap = document.getElementsByClassName('line_wrap')[0] 
            const lineChild = lineWrap.children
            for(var i=lineWrap.children.length;i>1;i--){
              lineWrap.removeChild(lineChild[i-1])
            }
            that.arr=[[]]
            that.qasmShow()
            that.codeChange(that.editor)
          }).catch(() => {
            this.runRuleForm.name = this.beforeSaveValue
            this.$message({
              type: 'info',
              message: '已取消切换'
            });          
          });
        }
      }

    },
    //获取编辑实验的id
    async getEditInfo() {
      const that = this;
      this.arr = [];
      this.testId = this.$route.query.qobj_id;
      var  editQubits;
      const params = {
        qobj_id: this.testId,
      };
      const  {data}  = await queryExperiment(params);
      if(data.code == '0'){
        let data1 = data.data;
        this.ruleForm.name = data1.name;//实验名称
        this.ruleForm.describe = data1.description;//实验描述
        this.num = Number(data1.quantum_register);//量子比特数量
        this.num1 = Number(data1.classic_register);
        const list = JSON.parse(data1.jsondata);
        editQubits = list.experiments[0].instructions;//线路图信息
        this.code = data1.programming//语言代码
      }else{
         this.$message.error(data.errMsg);
         return
      }
      for (var i = 0; i < this.num; i++) {
        this.arr.push([]);
      }
      for (var j = 0; j < this.num - 1; j++) {
        this.register = this.register + 1;//量子寄存器（线）的数量
        let line = document.getElementsByClassName("line")[this.register - 1].cloneNode(true);//克隆量子寄存器（线）的数量
        let lineWrap = document.getElementsByClassName("line_wrap")[0];//量子寄存器（线）的父元素
        lineWrap.appendChild(line);
        let lineid = document.getElementsByClassName("bgline1")[0];
        lineid.setAttribute("class", "bgline");
        lineid.setAttribute("id", this.register - 1);
        let box = document.getElementById("box");
        box.setAttribute("id", "box" + (this.register - 1));
        let icon = document.getElementsByClassName("iconfontPng");
        document.getElementsByClassName("orderValue")[j + 1].setAttribute("value", j + 1);
        this.drop();
        if (this.checked) {
          this.together();
        }
        for (var i = 1; i < icon.length - 1; i++) {
          icon[i].setAttribute("class", "iconfontPng");
          this.deleteLine(i);
        }
      }
      const tianchong = document.getElementsByClassName("tianchong")[0];
       this.createQasm().setValue(this.code)
       this.code = ''
       this.qasmShow()
       this.codeChange(this.editor)

      for(var m=0;m<this.arr.length;m++){
        for(var n=0;n<this.arr[m].length;n++){
          if(this.arr[m][n]){
             this.arr[m][n].setAttribute('index',n)
          }
        }
      }

      let item;
      for (var i = 0; i < this.arr.length; i++) {
        const box = document.getElementById("box" + i);
        for (var j = 0; j < this.arr[i].length; j++) {
          if(this.arr[i][j]){
             item = this.arr[i][j];
           if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                if(item.getAttribute('class')!='turnCx'){
                  item.setAttribute("class", "online");
                }
            }
            // item.setAttribute("index", j);
            if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
              item.firstChild.lastChild.setAttribute("class",'bit')
            }else if(item.getAttribute('name')=='cx'){
              if(item.getAttribute('class')!='turnCx'){
                item.setAttribute('class','circle1')
              }
              let start =Number(item.getAttribute('position'))
              let end =Number(item.lastChild.getAttribute('end'))
              for(var dd=start+1;dd<=end;dd++){
                if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                  this.arr[dd][j].setAttribute("line",'line')
                }
              }
            }else if(item.getAttribute('name')=='swap'){
              item.setAttribute('class','xStart1')
              let start =Number(item.getAttribute('position'))
              let end =Number(item.lastChild.getAttribute('end'))
              for(var dd=start+1;dd<=end;dd++){
                if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                  this.arr[dd][j].setAttribute("line",'line')
                }
              }
            }else if(item.getAttribute('name')=='cz'){
              item.setAttribute('class','circle1')
              let start =Number(item.getAttribute('position'))
              let end =Number(item.lastChild.getAttribute('end'))
              for(var dd=start+1;dd<=end;dd++){
                if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                  this.arr[dd][j].setAttribute("line",'line')
                }
              }
            }else if(item.getAttribute('name')=='toffoli'){
              if(item.getAttribute('class')=='toffcircle2'){
                item.firstChild.firstChild.setAttribute('class','quantumline4')
              }else if(item.getAttribute('class')=='circle1'){
                if(item.firstChild.firstChild.getAttribute('name')=='end'){
                     item.firstChild.firstChild.setAttribute('class','circle2')
                   }else{
                     item.firstChild.firstChild.setAttribute('class','circle3')
                   }
              }
            }
          }else{
            this.arr[i][j]=tianchong.cloneNode(true)
             item = this.arr[i][j].cloneNode(true);
          }
          box.appendChild(item);
          };
        }

      if (data.data.is_sample === "Y") {
        this.checked = true;
        this.disabled = true;
        this.num1 = this.num;
      } else {
        this.checked = false;
        this.disabled = false;
      }
    },
    //获取机器信息
    async getMechineInfo() {
      // this.dialogFormVisible = true;
      const  {data}  = await querymechineInfo();
      if(data.code == '0'){
         this.form.computed = data.data;
        //  this.device_id = Object.keys(this.form.computed)
         this.device_name = this.form.computed[this.selectValue].machineName;
         this.schema_version = this.form.computed[this.selectValue].version;
      }else{
        this.$message.error(data.errMsg);
      }
    },
    //返回列表页
    backList() {
      this.$router.push({
        path: "/circuitProgram/index"
      });
    },
    //保存实验
    async save(ruleForm) {
      // let that = this;
      if(this.num >6&&this.selectMechine == 'computer'){
         this.$message({
             message: "该机器只支持6比特，请选择合适的机器！",
             type: "error"
           });
           return false
      }else{
       this.$refs.ruleForm.validate(async valid => {
        if (!valid) {
          this.$message.error("请按规则填写实验信息！");
          return false;
        } else {
          this.instructions = [];
          this.qubit_labels = [];
          this.header = {};
          let beforeline = 0
          let  column=0
          let maxlength = 0
          this.memory_slots=0
      for(var h=0;h<this.arr.length;h++){
        if(this.arr[h].length>maxlength){
          maxlength = this.arr[h].length
        }
      }
      for (var j = beforeline; j < maxlength; j++) {
        for(var i=0;i<this.arr.length;i++){
          if(this.arr[i][j]!==undefined){
            let name = this.arr[i][j].getAttribute("name");
          if(name==='cx'||name==='swap'||name==='cz'||name==='toffoli'){
            column = Number(this.arr[i][j].getAttribute("index"))
            for(var a=0;a<this.num;a++){
              for(var b=beforeline;b<column;b++){
                if(this.arr[a][b]!==undefined){
                  const namel = this.arr[a][b].getAttribute('name')
                if(namel !=='tianchong'&&namel !='cx'&&namel !='swap'&&namel !='cz'&&namel !=='measure'){
                   if(namel=='u1'||namel=='rx'||namel=='ry'||namel=='rz'){
                     let angle = this.arr[a][b].getAttribute('angle')-0
                     this.instructions.push({name:namel,qubits:[a],angle:[angle]})
                   }else if(namel=='u2'){
                      let angle1 = this.arr[a][b].getAttribute('angle1')-0
                      let angle2 = this.arr[a][b].getAttribute('angle2')-0
                      this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2]})
                   }else if(namel=='u3'){
                      let angle1 = this.arr[a][b].getAttribute('angle1')-0
                      let angle2 = this.arr[a][b].getAttribute('angle2')-0
                      let angle3 = this.arr[a][b].getAttribute('angle3')-0
                      this.instructions.push({name:namel,qubits:[a],angle:[angle1,angle2,angle3]})
                   }else{
                     this.instructions.push({name:namel,qubits:[a]})
                   }
                  }
                }
              }
            }
            for(var m=0;m<this.num;m++){
             if(this.arr[m][column]){
                let name = this.arr[m][column].getAttribute("name")
               if(name==='cx'||name==='swap'||name==='cz'){
                const start = Number(this.arr[m][column].getAttribute("position"))
                let end 
                if(this.arr[m][column].getAttribute('class')=='turnCx'){
                  end = Number(this.arr[m][column].firstChild.getAttribute("end"))
                }else{
                  end = Number(this.arr[m][column].lastChild.getAttribute("end"))
                }
                this.qubits = [start,end]
                this.instructions.push({name:name,qubits:this.qubits})
              }else if(name==='toffoli'){
                const start = Number(this.arr[m][column].getAttribute("start"))
                const middle = Number(this.arr[m][column].getAttribute("middle"))
                const end = Number(this.arr[m][column].getAttribute("end"))
                this.qubits = [start,middle,end]
                this.instructions.push({name:name,qubits:this.qubits})
              }else if(name !=='tianchong'&&name !='cx'&&name !='swap'&&name !='cz'&&name !=='measure'){
                this.qubits = [m]
                // this.instructions.push({name:name,qubits:this.qubits})
                if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                     let angle = this.arr[m][column].getAttribute('angle')-0
                     this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                   }else if(name=='u2'){
                      let angle1 = this.arr[m][column].getAttribute('angle1')-0
                      let angle2 = this.arr[m][column].getAttribute('angle2')-0
                      this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                   }else if(name=='u3'){
                      let angle1 = this.arr[m][column].getAttribute('angle1')-0
                      let angle2 = this.arr[m][column].getAttribute('angle2')-0
                      let angle3 = this.arr[m][column].getAttribute('angle3')-0
                      this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                   }else{
                     this.instructions.push({name:name,qubits:this.qubits})
                   }
              }
             }
            }
           beforeline = column+1
          }
          }
        }
      }
          if(beforeline<=maxlength){
            for(var k=0;k<this.arr.length;k++){
              for(var g=beforeline;g<maxlength;g++){
                if(this.arr[k][g]){
                    name = this.arr[k][g].getAttribute("name")
                   if(name!=='measure'){
                     this.qubits = [k]
                      // this.instructions.push({name:name,qubits:this.qubits})
                      if(name=='u1'||name=='rx'||name=='ry'||name=='rz'){
                       let angle = this.arr[k][g].getAttribute('angle')-0
                       this.instructions.push({name:name,qubits:this.qubits,angle:[angle]})
                     }else if(name=='u2'){
                        let angle1 = this.arr[k][g].getAttribute('angle1')-0
                        let angle2 = this.arr[k][g].getAttribute('angle2')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2]})
                     }else if(name=='u3'){
                        let angle1 = this.arr[k][g].getAttribute('angle1')-0
                        let angle2 = this.arr[k][g].getAttribute('angle2')-0
                        let angle3 = this.arr[k][g].getAttribute('angle3')-0
                        this.instructions.push({name:name,qubits:this.qubits,angle:[angle1,angle2,angle3]})
                     }else{
                       this.instructions.push({name:name,qubits:this.qubits})
                     }
                   }
                }
              }
            }
          }
          for (var j = 0; j < this.arr.length; j++) {
            this.arr[j].forEach(ele => {
              const name = ele.getAttribute("name");
              if (name === "measure") {
                this.memory_slots++;
                this.instructions.push({
                  memory: [j],
                  name: name,
                  qubits: [j]
                });
              }
            });
          }
          this.arr.forEach((ele, index) => {
            this.qubit_labels.push(["q", index]);
          });
          this.clbit_labels=[]
          for (var k = 0; k < this.memory_slots; k++) {
            this.clbit_labels.push(["c", k]);
          }
          this.header = {
            creg_sizes: [["c", this.num1]], //[creg_name, size]列表
            name: "circuit0", //提交的此量子实验的量子线路名称
            qubit_labels: this.qubit_labels, //[qreg_name, n]，用于指示相应的物理量子比特作为第n个量子比特的量子寄存器qreg_name
            qreg_sizes: ["q", this.num], //[qreg_name, size]的列表，用于指定QASM量子寄存器和它们的尺寸
            n_qubits: this.num, //后端机器的量子比特数，等于量子实验中最大的量子比特数
            memory_slots: this.memory_slots, //在此量子实验中使用的测量slot总数
            clbit_labels: this.clbit_labels //内存memory_slots列表，每一个元素是[creg_name, n]，用于指示经典寄存器creg_name的第n个元素对应的memory slot
          };
          this.qubitdata = {
            experiments: [
              {
                instructions: this.instructions, //量子实验执行的量子指令列表
                header: this.header,
                config: {
                  n_qubits: this.num, //后端机器的量子比特数
                  memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
                }
              }
            ],
            schema_version: "1.1.0", //用于编译qobj的schema版本
            // type: this.selectMechine, //用于量子实验的指令类型  computer:真机;simulation:模拟 
            qobj_id: this.qobj_id, //用户生成的qobj的id
            device_id: "", //量子实验任务要运行的计算机ID
            device_name: "",
            // user_id: this.user_id,
            config: {
              shots: 0, //每个量子实验的重复次数
              n_qubits: this.num, //后端机器的量子比特数
              memory_slots: this.memory_slots //在此量子实验中使用的测量slot总数
            }
          };
          if (this.checked) {
            this.is_sample = "Y";
          } else {
            this.is_sample = "N";
          }
          this.deletebtn = false;
          if(this.verifyCode == true){
            if(this.isoverLimit == false){
              if (this.$route.query.qobj_id||this.qobj_id) {
                  const params = {
                    qobj_id: this.$route.query.qobj_id?this.$route.query.qobj_id:this.qobj_id,
                    // user_id: this.user_id,
                    name: this.ruleForm.name,
                    quantum_register: this.num,
                    classic_register: this.num1,
                    type: this.selectMechine,
                    is_sample: this.is_sample,
                    description: this.ruleForm.describe,
                    jsondata: JSON.stringify(this.qubitdata),
                    programming:this.publicCode+this.code
                  };
                  const  {data}  = await editExperiment(params);
                  if (data.code === "0") {
                    if(this.$route.query.qobj_id){
                      this.qobj_id = data.data.qobj_id;
                    }
                    if(this.flag == -1){
                      this.$message({
                        message: "修改成功",
                        type: "success"
                      });
                    }

                  } else {
                    this.$message.error(data.errMsg);
                  }
                  if(this.flag ==2||this.flag ==1){
                    // console.log(this.qobj_id)
                    this.validity(ruleForm)
                    this.flag = -1
                  }
                } else {
                  const params = {
                    // user_id: this.user_id,
                    name: this.ruleForm.name,
                    quantum_register: this.num,
                    classic_register: this.num1,
                    is_sample: this.is_sample,
                    type: this.selectMechine,
                    description: this.ruleForm.describe,
                    jsondata: JSON.stringify(this.qubitdata),
                    programming:this.publicCode+this.code
                  };
                     
                  const  {data}  = await saveExperiment(params);
                  if (data.code === "0") {
                    // debugger
                    this.qobj_id = data.data.qobj_id;
                    this.$message({
                      message: "保存成功",
                      type: "success"
                    });
                  } else {
                    this.$message.error("保存失败");
                  }
                  if(this.flag == 0){
                     this.validity(ruleForm)
                      this.flag = -1
                  }
                }
            }else{
              this.$message({
                  message: '超出数量限制',
                  type: 'warning',
                  duration:3000
                });
            }

        }else{
          this.$message.error("代码有误,保存失败！");
        }
      }
    });
   }

  },
    //删除量子寄存器（横线）数量
    deleteLine(i) {
      let icon = document.getElementsByClassName("iconfontPng");
      let linepa = icon[i].parentNode.parentNode.parentNode;
      let lineDe = icon[i].parentNode.parentNode.parentNode.children[i];//所有量子寄存器（线）
      let that = this;
      icon[i].onclick = function() {
        if(lineDe.lastChild.lastChild.childNodes.length!=0){
          that.$message({
          message: '此线上存在量子门，不可删除！',
          type: 'warning'
        });
         return
        }else{
          that.arr.splice(that.arr.length - 1, 1);
        // that.arr.push([]);
        linepa.removeChild(lineDe);
        that.register = that.register - 1;
        that.num = that.register;
        let orderValue = document.getElementsByClassName("orderValue");
        let boxValue = document.getElementsByClassName('online_wrap')
        let bglineValue = document.getElementsByClassName('bgline')
        for (var j = 0; j < that.arr.length; j++) {
          orderValue[j].setAttribute("value", j);
          boxValue[j].setAttribute('id','box'+j)
          bglineValue[j].setAttribute('id',j)
        }
      }
      if(that.num<=4){
        that.islimit = true
      }else{
         that.islimit = false
      }
         that.together();
         that.qasmShow()
      };
    },

    //删除
    deletequantum(rows,cols){
    const tianchong = document.getElementsByClassName("tianchong")[0];
     for(var i=0;i<cols;i++){
       for(var j=0;j<rows;j++){
         if(this.brr[j][i]){
           if(this.brr[j][i].getAttribute('name')!=='tianchong'){
           if(this.brr[j][i].getAttribute('name')=='cx'||this.brr[j][i].getAttribute('name')=='swap'||this.brr[j][i].getAttribute('name')=='cz'||this.brr[j][i].getAttribute('name')=='toffoli'){ //当元素是跨线的时进行的操作
             let start = this.brr[j][i].getAttribute('position') - 0
             let end = 0 
             if(this.brr[j][i].getAttribute('name')=='toffoli'){
                end = this.brr[j][i].getAttribute('end') - 0
             }else{
                end = this.brr[j][i].lastChild.getAttribute('end') - 0
             }
             
             for(var n=i-1;n>=0;n--){
                let door = false
               for(var m=start;m<=end;m++){
                 if(this.brr[m][n]){
                    if(this.brr[m][n].getAttribute('name')!='tianchong'||this.brr[m][n].getAttribute('line')=='line'){
                   door = true
                  }
                 }
              }
              if(door == false){
                for(var q=start;q<=end;q++){
                  this.brr[q][n] = this.brr[q][n+1]
                  this.brr[q][n+1] = tianchong.cloneNode(true)
                }
              }else{
                n=0
              }
            }
           }else if(this.brr[j][i].getAttribute('name')!='cx'&&this.brr[j][i].getAttribute('name')!='swap'&&this.brr[j][i].getAttribute('name')!='cz'&&this.brr[j][i].getAttribute('line')!='line'){//当元素为单个量子比特时的操作
              let row = j
              for(var h=i-1;h>=0;h--){
                if(this.brr[row][h].getAttribute('name')=='tianchong'&&this.brr[row][h].getAttribute('line')!='line'){
                  this.brr[row][h] = this.brr[row][h+1]
                  this.brr[row][h+1] = tianchong.cloneNode(true)
                }else{
                    h=0
                }
              }
           }
          }
         }
       }
     }
    },

    //寄存器和下面横线保持一致
    eqline() {
      this.num = this.register;
    },
    //两寄存器数值同步
    together() {
      this.num1 = this.num;
      this.qasmShow()
    },
    //改变量子寄存器的值
    changeNum(currentValue, oldValue) {
        this.together();
      if (currentValue > oldValue) {//如果当前值比原来的值大时
        this.addline();
        this.num = this.register;//量子寄存器的数量
      } else {
        let icon = document.getElementsByClassName("iconfontPng");
        let linepa = icon[currentValue].parentNode.parentNode.parentNode;
        let lineDe =icon[currentValue].parentNode.parentNode.parentNode.children[currentValue];
        this.arr.splice(this.arr.length - 1, 1);
        linepa.removeChild(lineDe);
        this.register = this.register - 1;
        this.num = this.register;
        let orderValue = document.getElementsByClassName("orderValue");
        for (var j = 0; j < this.arr.length; j++) {
          orderValue[j].setAttribute("value", j);
        }
      }
    },
    //改变复选框是否选中
    change() {
        this.disabled = true;
        this.together();
        this.changeNum();
    },
    //清空量子
    clear() {
      for (var i = 0; i < this.arr.length; i++) {
        this.arr[i] = [];
      }
      this.qasmShow()
      this.arr.forEach((brr, index) => {
        const box = [];
        const boxChildren = [];
        box[index] = document.getElementById("box" + index);//获取box里的dom元素
        boxChildren[index] = box[index].childNodes.length;
        for (var j = 0; j < boxChildren[index]; j++) {
          box[index].removeChild(box[index].firstChild);
        }
      });
    },
    //增加量子寄存器（横线）
    addline() {
      this.arr.push([]);
      if(this.selectMechine == 'simulation'){
          if (this.arr.length > 20) {//目前只支持20比特
            this.arr.splice(this.arr.length-1,1)
            this.$message({
              message: '目前只支持20比特操作！',
              type: 'warning'
            });
            return;
          } else {
            this.register = this.register + 1;//量子寄存器数量
            let line = document.getElementsByClassName("line")[document.getElementsByClassName("line").length-1].cloneNode(true);//克隆模板寄存器
            let lineWrap = document.getElementsByClassName("line_wrap")[0];//获取存放寄存器的div盒子
            lineWrap.appendChild(line);//把添加的寄存器添加到里面
            let lineid = document.getElementsByClassName("bgline1")[0];//获取寄存器线的id属性值
            lineid.setAttribute("class", "bgline");//设置新的属性
            lineid.setAttribute("id", this.register - 1);//设置最新的id属性值
            let box = document.getElementById("box");
            box.setAttribute("id", "box" + (this.register - 1));//设置boxd的id属性值
            let icon = document.getElementsByClassName("iconfontPng");
            for (var i = 1; i < icon.length - 1; i++) {
              icon[i].setAttribute("class", "iconfontPng");
              this.deleteLine(i);
            }
            for (var j = 0; j < this.arr.length; j++) {
              document.getElementsByClassName("orderValue")[j].setAttribute("value", j);
            }
            if(this.register>4){
              this.islimit = false
            }else{
              this.islimit = true
            }
            this.drop();
            this.eqline();
            this.together();
            this.qasmShow()
          }
      }else {
          if (this.arr.length > 8) {//目前只支持6比特
             this.arr.splice(this.arr.length-1,1)
             this.$message({
               message: '目前该机器只支持8比特操作！',
               type: 'warning'
             });
             return;
           } else {
             this.register = this.register + 1;//量子寄存器数量
             let line = document.getElementsByClassName("line")[document.getElementsByClassName("line").length-1].cloneNode(true);//克隆模板寄存器
             let lineWrap = document.getElementsByClassName("line_wrap")[0];//获取存放寄存器的div盒子
             lineWrap.appendChild(line);//把添加的寄存器添加到里面
             let lineid = document.getElementsByClassName("bgline1")[0];//获取寄存器线的id属性值
             lineid.setAttribute("class", "bgline");//设置新的属性
             lineid.setAttribute("id", this.register - 1);//设置最新的id属性值
             let box = document.getElementById("box");
             box.setAttribute("id", "box" + (this.register - 1));//设置boxd的id属性值
             let icon = document.getElementsByClassName("iconfontPng");
             for (var i = 1; i < icon.length - 1; i++) {
               icon[i].setAttribute("class", "iconfontPng");
               this.deleteLine(i);
             }
             for (var j = 0; j < this.arr.length; j++) {
               document.getElementsByClassName("orderValue")[j].setAttribute("value", j);
             }
             if(this.register>4){
               this.islimit = false
             }else{
               this.islimit = true
             }
             this.drop();
             this.eqline();
             this.together();
             this.qasmShow()
           }
      }
    },
    
    //把量子拖拽到量子寄存器上
    drop(e) {
      this.createQasm().off("change")//取消代码编辑器的change事件
      let _this = this;
      const lineRight = document.getElementsByClassName("right");
      let tianchong = document.getElementsByClassName("tianchong")[0];
      tianchong.setAttribute("name", "tianchong");
      for (var j = 0; j < lineRight.length; j++) {
        //目标对象容许被拖拽元素拖拽进来 默认不容许
        lineRight[j].ondragover = function(e) {
          e.preventDefault();
        };
        //目标对象接受被拖拽元素放下
        lineRight[j].ondrop = function(e) {
          
          if(e.target.getAttribute('class')=='doublequantum'||e.target.getAttribute('name')=='bitSvg'||e.target.getAttribute('name')=='tianchong'||e.target.getAttribute('class') == "iconfont icon-tianjiaaddto1"){
            _this.insertQuantum(e)
          }else{
          let __this = _this;
          // debugger
          let online = document.getElementById("box" + e.target.getAttribute("id"));
          //拖拽两比特跨线量子
          if (__this.moveNode1.getAttribute("name") === "cx"||__this.moveNode1.getAttribute("name") === "swap"||__this.moveNode1.getAttribute("name") === "cz") {
            if(e.target.getAttribute("id")-0+1>=__this.num){
              __this.$message.error("请选择正确位置放置")
              return
            }
            __this.moveNode1.lastChild.setAttribute("end",e.target.getAttribute("id")-0+1)//设置结束位置属性
            const onlineChild = online.childNodes;
            if(onlineChild!==null){
              for (var k = onlineChild.length - 1; k >= 0; k--) {
              online.removeChild(onlineChild[k]);
            }
          }
          let max = 0;
            __this.start = e.target.getAttribute("id") - 0;//开始位置
            __this.end = Number(__this.start) + 1;//结束位置
            for (var q = Number(__this.start); q <= Number(__this.end); q++) {
              if (__this.arr[q].length > max) {
                max = __this.arr[q].length;
              }
            }
            if(__this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length-1]){

              if(__this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length-1].getAttribute('name')==='measure'){//最后一个元素是测量元素时
                for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                  for (var p = __this.arr[s].length; p < max-1; p++) {
                  __this.arr[s][p] = tianchong.cloneNode(true);
                }
             }
            }else{//最后一个元素不是测量元素时

              for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                for (var p = __this.arr[s].length; p < max; p++) {
                __this.arr[s][p] = tianchong.cloneNode(true);
              }
             }
            }
           }
            //保证测量在最后
            let linelength =__this.arr[Number(e.target.getAttribute("id"))].length;//此行长度
            let open = true;
            for (var a = 0; a < linelength; a++) {
              if(__this.arr[Number(e.target.getAttribute("id"))][a].getAttribute("name")==="measure"){//当是测量元素时
                  open = false;
              }
            }
              if(__this.arr[Number(e.target.getAttribute("id"))][linelength - 1] !='undefined'&&open==false){//当此行倒数第二个元素存在且最后一个元素是测量时
                  if (__this.arr[Number(e.target.getAttribute("id"))][linelength - 1].getAttribute("name") === "tianchong") {//当此行倒数第二个元素是填充时
                    for (var i = linelength - 1; i >= 0; i--) {
                      if (__this.arr[Number(e.target.getAttribute("id"))][i].getAttribute("name") === "measure") {//如果该行存在测量元素
                        // __this.arr[e.target.getAttribute("id") - 0 + 1].splice(linelength,1)
                        __this.arr[e.target.getAttribute("id") - 0].splice(i,0,__this.moveNode1);
                        let tianline = tianchong.cloneNode(true)
                        tianline.setAttribute("line",'line')
                        __this.arr[e.target.getAttribute("id") - 0 + 1].splice(i,0,tianline.cloneNode(true));
                      }
                    }
            } else if ( __this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length - 1].getAttribute("name") === "measure") {//如果该行最后一个元素是测量元素
              __this.arr[e.target.getAttribute("id") - 0].splice(
                __this.arr[e.target.getAttribute("id") - 0].length - 1,0,__this.moveNode1);
               let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[e.target.getAttribute("id") - 0 + 1].splice(
                    __this.arr[e.target.getAttribute("id") - 0].length - 2,0,tianline.cloneNode(true)
                  );
            } else if (
              __this.arr[Number(e.target.getAttribute("id")) + 1][__this.arr[Number(e.target.getAttribute("id")) + 1].length - 2].getAttribute("name") === "measure"
            ) {//如果拖放的所在行的下一行的倒数第二个个元素是测量时
              __this.arr[e.target.getAttribute("id") - 0].splice(
                __this.arr[e.target.getAttribute("id") - 0 + 1].length - 1,0, __this.moveNode1
              );
              let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[e.target.getAttribute("id") - 0 + 1].splice(
                    __this.arr[e.target.getAttribute("id") - 0].length - 2,0, tianline.cloneNode(true));
            }
          }else{
            let tianchongQ = tianchong.cloneNode(true)
            tianchongQ.setAttribute('line','line')
            if(__this.arr[e.target.getAttribute("id") - 0].length>=__this.arr[e.target.getAttribute("id") - 0+1].length){//当拖放的所在行比下一行的量子门数量多时
                 __this.arr[e.target.getAttribute("id") - 0].push(__this.moveNode1);
                let col =  __this.arr[e.target.getAttribute("id") - 0].length-1
              if(__this.arr[e.target.getAttribute("id") - 0 +1][col]){
                if(__this.arr[e.target.getAttribute("id") - 0 +1][col].getAttribute('line')=='line'){//如果拖拽的所在行的下一行的位置为填充
                  __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }else if(__this.arr[e.target.getAttribute("id") - 0 +1][col].getAttribute('quantum') == 'quantum'){//如果拖拽的所在行的下一行的位置为量子比特门
                  __this.arr[e.target.getAttribute("id") - 0 +1].splice(col,0,tianchongQ.cloneNode(true))
                }else{//如果拖拽的所在行的下一行的位置没有元素
                  __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }
              }else{
                 __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
              }
            }else{//当拖放的所在行比下一行的量子门数量少时
              let positionCol = __this.arr[e.target.getAttribute("id") - 0+1].length
              __this.arr[e.target.getAttribute("id") - 0][positionCol] = __this.moveNode1
              __this.arr[e.target.getAttribute("id") - 0+1][positionCol] = tianchongQ
              for(var emp = 0;emp<=positionCol;emp++){
                if(!__this.arr[e.target.getAttribute("id") - 0][emp]){//拖放的线上元素之前有不存在元素的位置用填充占位
                  __this.arr[e.target.getAttribute("id") - 0][emp] = tianchong.cloneNode(true)
                }
              }
            }
          }
            for (var b = 0;b < __this.arr.length;b++) {
              var online1 = document.getElementById("box" +b);
                const onlineChild = online1.childNodes;
                if(onlineChild!==null){
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                  online1.removeChild(onlineChild[k]);
                }
              }
                for(var qindex=0;qindex<__this.arr[b].length;qindex++){
                  var i = __this.arr[b][qindex]
                  i.setAttribute("index", qindex);
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position", b);
                  }
                  i.setAttribute("index", qindex);
                  online.appendChild(i);
                  __this.qasmShow()
              };
            }
           } else if(__this.moveNode1.getAttribute("name") === "h"||__this.moveNode1.getAttribute("name") === "s"||__this.moveNode1.getAttribute("name") === "sdg"||__this.moveNode1.getAttribute("name") === "id"||__this.moveNode1.getAttribute("name") === "x"||__this.moveNode1.getAttribute("name") === "y"||__this.moveNode1.getAttribute("name") === "z"||__this.moveNode1.getAttribute("name") === "measure"||__this.moveNode1.getAttribute("name") === "t"||__this.moveNode1.getAttribute("name") === "tdg"
            ||__this.moveNode1.getAttribute("name") ==='u1'||__this.moveNode1.getAttribute("name") ==='u2'||__this.moveNode1.getAttribute("name") ==='u3'||__this.moveNode1.getAttribute("name") ==='rx'||__this.moveNode1.getAttribute("name") ==='ry'||__this.moveNode1.getAttribute("name") ==='rz'||__this.moveNode1.getAttribute("name") ==='x_half'||__this.moveNode1.getAttribute("name") ==='y_half'
           ) {
            
            //拖拽单个量子
            if (__this.arr[e.target.getAttribute("id") - 0].length != 0) {//如果拖放行上已经存在元素
              if (__this.arr[e.target.getAttribute("id") - 0][__this.arr[e.target.getAttribute("id") - 0].length - 1].getAttribute("idx") !== "8") {//如果拖放行的最后一个元素不是测量元素
                const onlineChild = online.childNodes;
                if(__this.arr[e.target.getAttribute("id") - 0][__this.arr[e.target.getAttribute("id") - 0].length-1].getAttribute("name")==='tianchong'&&__this.arr[e.target.getAttribute("id") - 0][__this.arr[e.target.getAttribute("id") - 0].length-1].getAttribute("line")!="line"){
                    __this.arr[e.target.getAttribute("id") - 0].splice(__this.arr[e.target.getAttribute("id") - 0].length-1,1)
                }
                __this.arr[e.target.getAttribute("id") - 0].push(__this.moveNode1);
                __this.arr[e.target.getAttribute("id") - 0].forEach((i, index) => {
                  if(i){//如果元素存在
                    if (i.getAttribute("name") !== "tianchong") {
                      i.setAttribute("quantum", "quantum");
                    }
                    
                    if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {//如果是跨线量子门
                      i.setAttribute("position",Number(e.target.getAttribute("id")));
                    }
                    i.setAttribute("index", index);
                    online.appendChild(i);
                    _this.qasmShow()
                   }
                  }
                );
              } else {//如果拖放行的最后一个元素是测量元素
                if (__this.moveNode1.getAttribute("idx") !== "8") {//如果拖拽的元素不是测量元素
                  const onlineChild = online.childNodes;
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                    online.removeChild(onlineChild[k]);
                  }
                  __this.arr[e.target.getAttribute("id") - 0].splice(
                    __this.arr[e.target.getAttribute("id") - 0].length - 1,
                    0,
                    __this.moveNode1
                  );
                   for (var l = 0; l < __this.arr.length; l++) {
                        let tianNum = 0;
                        let door = 'open'
                        let linetian = 0
                      for (var c = 0; c < __this.arr[l].length; c++) {
                        if (
                          __this.arr[l][c].getAttribute("name") ==="tianchong"
                        ) {//获取填充数量
                          tianNum++;
                        }
                        if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){//如果是跨线的填充
                            door = 'close'
                            linetian=c
                        }
                        if (tianNum === __this.arr[l].length&&door==='open') {//如果此行都是纯填充就置空
                          __this.arr[l] = [];

                        }else if(tianNum === __this.arr[l].length&&door==='close'){//如果此行中存在跨线填充
                        __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                    }
                      }
                      let boxNum = document.getElementById("box"+l)
                        let boxNumChild = boxNum.childNodes
                        for (var k = boxNumChild.length - 1; k >= 0; k--) {
                            boxNum.removeChild(boxNumChild[k]);
                          }
                          if(!__this.$route.query.qobj_id){//如果不存在实验id
                            __this.arr[l].forEach((ele,index)=>{
                              if(ele){
                                  ele.setAttribute("index",index)
                                  boxNum.appendChild(ele)
                              }
                        })
                      }else{//如果存在实验id
                      let item;
                      const box = document.getElementById("box" + l);
                      const boxChild = box.childNodes;
                      for (var k = boxChild.length - 1; k >= 0; k--) {
                        box.removeChild(boxChild[k]);
                      }
                      for (var j = 0; j < __this.arr[l].length; j++) {
                        if(__this.arr[l][j]){//元素存在时
                            item = __this.arr[l][j];
                            if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                              if(item.getAttribute('class')!='turnCx'){
                                 item.setAttribute("class", "online");
                              }
                            }
                          if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){//当是单量子比特门时
                            item.firstChild.lastChild.setAttribute("class",'bit')
                          }else if(item.getAttribute('name')=='cx'){//cx门时
                            if(item.getAttribute('class')!='turnCx'){
                               item.setAttribute('class','circle1')
                            }
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='swap'){//swap门时
                            item.setAttribute('class','xStart1')
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='cz'){
                            item.setAttribute('class','circle1')
                            let start =Number(item.getAttribute('position'))
                            let end =Number(item.lastChild.getAttribute('end'))
                            for(var dd=start+1;dd<=end;dd++){
                              if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                __this.arr[dd][j].setAttribute("line",'line')
                              }
                            }
                          }else if(item.getAttribute('name')=='toffoli'){
                            if(item.getAttribute('class')=='toffcircle2'){
                              item.firstChild.firstChild.setAttribute('class','quantumline4')
                            }else if(item.getAttribute('class')=='circle1'){
                              if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                  item.firstChild.firstChild.setAttribute('class','circle2')
                                }else{
                                  item.firstChild.firstChild.setAttribute('class','circle3')
                                }
                            }
                        }
                        }else{//元素不存在时用填充占位
                          __this.arr[l][j]=tianchong.cloneNode(true)
                            item = __this.arr[l][j].cloneNode(true);
                        }
                        __this.arr.forEach((ele,index) =>{
                            ele.forEach((element,inx) =>{
                              if(element){
                                element.setAttribute("index",inx)
                              }
                            })
                          })
                        box.appendChild(item);
                        };
                      }
                    }
                  __this.arr[e.target.getAttribute("id") - 0].forEach((i, index) => {
                    if(i){
                      if (i.getAttribute("name") !== "tianchong") {//给量子门设置属性
                        i.setAttribute("quantum", "quantum");
                      }
                      if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {//给跨线量子设置位置信息
                        i.setAttribute("position",Number(e.target.getAttribute("id")));
                      }
                      i.setAttribute("index", index);
                      online.appendChild(i);
                     }
                    }
                  );
                } else {//如果拖拽的元素时测量时
                  const onlineChild = online.childNodes;
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                    online.removeChild(onlineChild[k]);
                  }
                   for (var l = 0; l < __this.arr.length; l++) {
                             let tianNum = 0;
                             let door = 'open'
                             let linetian = 0
                            for (var c = 0; c < __this.arr[l].length; c++) {
                              if (__this.arr[l][c].getAttribute("name") ==="tianchong") {//获取填充数量
                                tianNum++;
                              }
                              if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){//是跨线填充元素时
                                  door = 'close'
                                  linetian=c
                              }
                              if (tianNum === __this.arr[l].length&&door==='open') {//一行都是纯填充时就置空
                                __this.arr[l] = [];

                              }else if(tianNum === __this.arr[l].length&&door==='close'){//一行都是填充但是存在跨线填充时
                              __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                            }
                          }
                            let boxNum = document.getElementById("box"+l)
                                let boxNumChild = boxNum.childNodes
                                for (var k = boxNumChild.length - 1; k >= 0; k--) {
                                    boxNum.removeChild(boxNumChild[k]);
                                  }
                                  if(!__this.$route.query.qobj_id){//不存在实验id
                                    __this.arr[l].forEach((ele,index)=>{
                                      if(ele){
                                        ele.setAttribute('index',index)
                                        boxNum.appendChild(ele)
                                      }
                                    })
                                  }else{//存在实验id
                                    let item;
                                    const box = document.getElementById("box" + l);
                                      const boxChild = box.childNodes;
                                      for (var k = boxChild.length - 1; k >= 0; k--) {
                                        box.removeChild(boxChild[k]);
                                      }
                                    for (var j = 0; j < __this.arr[l].length; j++) {
                                      if(__this.arr[l][j]){
                                          item = __this.arr[l][j]
                                        if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){//给量子比特门添加属性
                                             if(item.getAttribute('class')!='turnCx'){
                                                  item.setAttribute("class", "online");
                                               }
                                          }
                                        if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                          item.firstChild.lastChild.setAttribute("class",'bit')
                                        }else if(item.getAttribute('name')=='cx'){
                                          if(item.getAttribute('class')!='turnCx'){
                                            item.setAttribute('class','circle1')
                                          }
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='swap'){
                                          item.setAttribute('class','xStart1')
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='cz'){
                                          item.setAttribute('class','circle1')
                                          let start =Number(item.getAttribute('position'))
                                          let end =Number(item.lastChild.getAttribute('end'))
                                          for(var dd=start+1;dd<=end;dd++){
                                            if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                              __this.arr[dd][j].setAttribute("line",'line')
                                            }
                                          }
                                        }else if(item.getAttribute('name')=='toffoli'){
                                            if(item.getAttribute('class')=='toffcircle2'){
                                              item.firstChild.firstChild.setAttribute('class','quantumline4')
                                            }else if(item.getAttribute('class')=='circle1'){
                                               if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                                  item.firstChild.firstChild.setAttribute('class','circle2')
                                                }else{
                                                  item.firstChild.firstChild.setAttribute('class','circle3')
                                                }
                                            }
                                          }
                                      }else{
                                        __this.arr[l][j]=tianchong.cloneNode(true)
                                          item = __this.arr[l][j].cloneNode(true);
                                      }
                                      __this.arr.forEach((ele,index) =>{
                                          ele.forEach((element,inx) =>{
                                            if(element){
                                               element.setAttribute("index",inx)
                                            }
                                          })
                                        })
                                      box.appendChild(item);
                                      };
                                  }

                          }
                  __this.arr[e.target.getAttribute("id") - 0].forEach((i, index) => {//给拖放行的所有元素重新添加属性
                      if (i.getAttribute("name") !== "tianchong") {
                        i.setAttribute("quantum", "quantum");
                      }
                      if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                        i.setAttribute( "position",Number(e.target.getAttribute("id")));
                      }
                      i.setAttribute("index", index);
                      online.appendChild(i);

                    }
                  );
                }
                _this.qasmShow()
              }
            } else {
               for (var l = 0; l < __this.arr.length; l++) {
                    let tianNum = 0;
                      let door = 'open'
                      let linetian = 0
                    for (var c = 0; c < __this.arr[l].length; c++) {
                      if (
                        __this.arr[l][c].getAttribute("name") ==="tianchong"
                      ) {
                        tianNum++;
                      }
                      if(__this.arr[l][c].getAttribute("name") ==="tianchong"&&__this.arr[l][c].getAttribute("line")==='line'){
                          door = 'close'
                          linetian=c
                      }
                      if (tianNum === __this.arr[l].length&&door==='open') {
                        __this.arr[l] = [];

                      }else if(tianNum === __this.arr[l].length&&door==='close'){
                      __this.arr[l].splice(linetian+1,__this.arr[l].length-1)
                      }
                    }
                  let boxNum = document.getElementById("box"+l)
                  if(boxNum){
                    let boxNumChild = boxNum.childNodes
                    for (var k = boxNumChild.length - 1; k >= 0; k--) {
                        boxNum.removeChild(boxNumChild[k]);
                      }
                    if(!__this.$route.query.qobj_id){
                        __this.arr[l].forEach((ele,index)=>{
                          if(ele){
                             ele.setAttribute('index',index)
                            boxNum.appendChild(ele)
                          }
                        })
                      }else{//存在实验id进行属性的重新设置
                            let item;
                            const box = document.getElementById("box" + l);
                            const boxChild = box.childNodes;
                            for (var k = boxChild.length - 1; k >= 0; k--) {
                              box.removeChild(boxChild[k]);
                            }
                            for (var j = 0; j < __this.arr[l].length; j++) {
                              if(__this.arr[l][j]){
                                item = __this.arr[l][j];
                              if(item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                 if(item.getAttribute('class')!='turnCx'){
                                     item.setAttribute("class", "online");
                                  }
                              }
                              if(item.getAttribute('name')!=='cx'&&item.getAttribute('name')!=='swap'&&item.getAttribute('name')!=='cz'&&item.getAttribute('name')!=='tianchong'&&item.getAttribute('name')!=='toffoli'){
                                item.firstChild.lastChild.setAttribute("class",'bit')
                              }else if(item.getAttribute('name')=='cx'){
                                if(item.getAttribute('class')!='turnCx'){
                                  item.setAttribute('class','circle1')
                                }
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                              }else if(item.getAttribute('name')=='swap'){
                                item.setAttribute('class','xStart1')
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                              }else if(item.getAttribute('name')=='cz'){
                                item.setAttribute('class','circle1')
                                let start =Number(item.getAttribute('position'))
                                let end =Number(item.lastChild.getAttribute('end'))
                                for(var dd=start+1;dd<=end;dd++){
                                  if(__this.arr[dd][j].getAttribute('name') === 'tianchong'){
                                    __this.arr[dd][j].setAttribute("line",'line')
                                  }
                                }
                               }else if(item.getAttribute('name')=='toffoli'){
                                  if(item.getAttribute('class')=='toffcircle2'){
                                    item.firstChild.firstChild.setAttribute('class','quantumline4')
                                  }else if(item.getAttribute('class')=='circle1'){
                                     if(item.firstChild.firstChild.getAttribute('name')=='end'){
                                        item.firstChild.firstChild.setAttribute('class','circle2')
                                      }else{
                                        item.firstChild.firstChild.setAttribute('class','circle3')
                                      }
                                  }
                                }
                              }else{
                                __this.arr[l][j]=tianchong.cloneNode(true)
                                  item = __this.arr[l][j].cloneNode(true);
                                }
                                __this.arr.forEach((ele,index) =>{
                                  ele.forEach((element,inx) =>{
                                    if(element){
                                       element.setAttribute("index",inx)
                                    }
                                  })
                                })
                                box.appendChild(item);
                          };
                      }
                  }
              }
              __this.arr[e.target.getAttribute("id") - 0].push(__this.moveNode1);
              __this.arr[e.target.getAttribute("id") - 0].forEach((i, index) => {
                if(i){
                  if (i.getAttribute("name") !== "tianchong") {
                    i.setAttribute("quantum", "quantum");
                  }
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position",Number(e.target.getAttribute("id")));
                    // i.setAttribute("position", i);
                  }
                  i.setAttribute("index", index);
                  online.appendChild(i);
                 }
                }
               );
              __this.qasmShow()
            }
           }else if(__this.moveNode1.getAttribute("name") ==='toffoli'){
             let start = e.target.getAttribute("id") - 0
             let middle = e.target.getAttribute("id") - 0+1
             let end = e.target.getAttribute("id") - 0+2
             _this.moveNode1.setAttribute('middle',middle)
             _this.moveNode1.setAttribute('start',start)
             _this.moveNode1.setAttribute('end',end)
              if(end>=__this.num){
                __this.$message.error("请选择正确位置放置")
                return 
              }
            if(e.target.getAttribute("id")-0+1>=__this.num){
              __this.$message.error("请选择正确位置放置")
              return 
            }
           
            __this.moveNode1.lastChild.setAttribute("end",e.target.getAttribute("id")-0+1)//设置结束位置属性
            const onlineChild = online.childNodes;
            if(onlineChild!==null){
              for (var k = onlineChild.length - 1; k >= 0; k--) {
              online.removeChild(onlineChild[k]);
            }
          }
          let max = 0;
            __this.start = e.target.getAttribute("id") - 0;//开始位置
            __this.end = Number(__this.start) + 1;//结束位置
            for (var q = Number(__this.start); q <= Number(__this.end); q++) {
              if (__this.arr[q].length > max) {
                max = __this.arr[q].length;
              }
            }
            if(__this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length-1]){

              if(__this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length-1].getAttribute('name')==='measure'){//最后一个元素是测量元素时
                for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                  for (var p = __this.arr[s].length; p < max-1; p++) {
                  __this.arr[s][p] = tianchong.cloneNode(true);
                }
             }
            }else{//最后一个元素不是测量元素时

              for (var s = Number(__this.start); s <= Number(__this.end); s++) {
                for (var p = __this.arr[s].length; p < max; p++) {
                __this.arr[s][p] = tianchong.cloneNode(true);
              }
             }
            }
           }
            //保证测量在最后
            let linelength =__this.arr[Number(e.target.getAttribute("id"))].length;//此行长度
            let open = true;
            for (var a = 0; a < linelength; a++) {
              if(__this.arr[Number(e.target.getAttribute("id"))][a].getAttribute("name")==="measure"){//当是测量元素时
                  open = false;
              }
            }
              if(__this.arr[Number(e.target.getAttribute("id"))][linelength - 1] !='undefined'&&open==false){//当此行倒数第二个元素存在且最后一个元素是测量时
                  if (__this.arr[Number(e.target.getAttribute("id"))][linelength - 1].getAttribute("name") === "tianchong") {//当此行倒数第二个元素是填充时
                    for (var i = linelength - 1; i >= 0; i--) {
                      if (__this.arr[Number(e.target.getAttribute("id"))][i].getAttribute("name") === "measure") {//如果该行存在测量元素
                        // __this.arr[e.target.getAttribute("id") - 0 + 1].splice(linelength,1)
                        __this.arr[e.target.getAttribute("id") - 0].splice(i,0,__this.moveNode1);
                        let tianline = tianchong.cloneNode(true)
                        tianline.setAttribute("line",'line')
                        __this.arr[e.target.getAttribute("id") - 0 + 1].splice(i,0,tianline.cloneNode(true));
                      }
                    }
            } else if ( __this.arr[Number(e.target.getAttribute("id"))][__this.arr[Number(e.target.getAttribute("id"))].length - 1].getAttribute("name") === "measure") {//如果该行最后一个元素是测量元素
              __this.arr[e.target.getAttribute("id") - 0].splice(
                __this.arr[e.target.getAttribute("id") - 0].length - 1,0,__this.moveNode1);
               let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[e.target.getAttribute("id") - 0 + 1].splice(
                    __this.arr[e.target.getAttribute("id") - 0].length - 2,0,tianline.cloneNode(true)
                  );
            } else if (
              __this.arr[Number(e.target.getAttribute("id")) + 1][__this.arr[Number(e.target.getAttribute("id")) + 1].length - 2].getAttribute("name") === "measure"
            ) {//如果拖放的所在行的下一行的倒数第二个个元素是测量时
              __this.arr[e.target.getAttribute("id") - 0].splice(
                __this.arr[e.target.getAttribute("id") - 0 + 1].length - 1,0, __this.moveNode1
              );
              let tianline = tianchong.cloneNode(true)
                  tianline.setAttribute("line",'line')
                  __this.arr[e.target.getAttribute("id") - 0 + 1].splice(
                    __this.arr[e.target.getAttribute("id") - 0].length - 2,0, tianline.cloneNode(true));
            }
          }else{
            let tianchongQ = tianchong.cloneNode(true)
            tianchongQ.setAttribute('line','line')
            if(__this.arr[e.target.getAttribute("id") - 0].length>=__this.arr[e.target.getAttribute("id") - 0+1].length){//当拖放的所在行比下一行的量子门数量多时
                 __this.arr[e.target.getAttribute("id") - 0].push(__this.moveNode1);
                let col =  __this.arr[e.target.getAttribute("id") - 0].length-1
              if(__this.arr[e.target.getAttribute("id") - 0 +1][col]){
                if(__this.arr[e.target.getAttribute("id") - 0 +1][col].getAttribute('line')=='line'){//如果拖拽的所在行的下一行的位置为填充
                  __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }else if(__this.arr[e.target.getAttribute("id") - 0 +1][col].getAttribute('quantum') == 'quantum'){//如果拖拽的所在行的下一行的位置为量子比特门
                  __this.arr[e.target.getAttribute("id") - 0 +1].splice(col,0,tianchongQ.cloneNode(true))
                }else{//如果拖拽的所在行的下一行的位置没有元素
                  __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
                }
              }else{
                 __this.arr[e.target.getAttribute("id") - 0 +1][col] = tianchongQ.cloneNode(true)
              }
            }else{//当拖放的所在行比下一行的量子门数量少时
              let positionCol = __this.arr[e.target.getAttribute("id") - 0+1].length
              __this.arr[e.target.getAttribute("id") - 0][positionCol] = __this.moveNode1
              __this.arr[e.target.getAttribute("id") - 0+1][positionCol] = tianchongQ
              for(var emp = 0;emp<=positionCol;emp++){
                if(!__this.arr[e.target.getAttribute("id") - 0][emp]){//拖放的线上元素之前有不存在元素的位置用填充占位
                  __this.arr[e.target.getAttribute("id") - 0][emp] = tianchong.cloneNode(true)
                }
              }
            }
          }
            for (var b = 0;b < __this.arr.length;b++) {
              var online1 = document.getElementById("box" +b);
                const onlineChild = online1.childNodes;
                if(onlineChild!==null){
                  for (var k = onlineChild.length - 1; k >= 0; k--) {
                  online1.removeChild(onlineChild[k]);
                }
              }
                for(var qindex=0;qindex<__this.arr[b].length;qindex++){
                  var i = __this.arr[b][qindex]
                  i.setAttribute("index", qindex);
                  if (i.getAttribute("name") === "cx"||i.getAttribute("name") === "swap"||i.getAttribute("name") === "cz") {
                    i.setAttribute("position", b);
                  }
                  i.setAttribute("index", qindex);
                  online.appendChild(i);
                  __this.qasmShow()
              };
            }
           }
          }
        };
      }
    },
    //起始位置调整
    startInput(e) {
      this.drr.push(e);//开始数据存储的数组
      this.newStart = this.drr[this.drr.length - 1];//最新的开始位置
      this.oldStart = Number(this.position);//上一次的开始位置
      this.brr = [];
      this.brr = this.arr[this.oldStart].slice(Number(this.column),Number(this.column) + 1);
    },
    //拖拽跨线量子
    dragdouble(e) {
      if (e.target.getAttribute("class") === "circleQuantum") {
        const quantumStart = document.getElementsByClassName("circle")[0];//跨线量子的头
        const quantumline = document.getElementsByClassName("quantumline")[0];//跨线量子的中间线
        const quantumStart1 = quantumStart.cloneNode(true);
        const quantumline1 = quantumline.cloneNode(true);
        quantumStart1.setAttribute("class", "circle1");
        quantumStart1.setAttribute("name", "cx");
        quantumline1.setAttribute("class", "quantumline1");
        const quantumEnd = quantumStart.cloneNode(true);
        quantumEnd.setAttribute("class", "circle2");
        quantumEnd.innerHTML = '<i class="iconfont icon-tianjiaaddto1"></i>';//跨线量子的结束
        quantumEnd.setAttribute("name", "circleEnd");
        quantumline1.appendChild(quantumEnd);
        quantumStart1.appendChild(quantumline1);
        let quantumbox = document.createElement("span");
        quantumbox.setAttribute("class", "doublequantum");
        const close = document.getElementsByClassName("close")[0].cloneNode(true);
        let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
        quantumbox.appendChild(close);
        quantumbox.appendChild(edit);
        // quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:-14px;left:-14px;";
        quantumbox.style.display = 'inline-block'
        quantumbox.style.width = '40px'
        quantumbox.style.height = '90px'
        quantumbox.style.border = '0px dashed #EAEAEA'
        quantumbox.style.position = 'absolute'
        quantumbox.style.top = '-14px'
        quantumbox.style.left = '-14px'
        quantumStart1.appendChild(quantumbox);
        this.moveNode1 = quantumStart1.cloneNode(true);
      } else if (e.target.getAttribute("class") === "xQuantum") {
        const quantumStart = document.getElementsByClassName("xStart")[0];
        const quantumline = document.getElementsByClassName("quantumline")[0];
        const quantumStart1 = quantumStart.cloneNode(true);
        const quantumline1 = quantumline.cloneNode(true);
        quantumStart1.setAttribute("class", "xStart1");
        quantumStart1.setAttribute("name", "swap");
        quantumline1.setAttribute("class", "quantumline2");
        const quantumEnd = quantumStart.cloneNode(true);
        quantumEnd.setAttribute("class", "xStart2");
        quantumEnd.setAttribute("name", "xEnd");
        quantumline1.appendChild(quantumEnd);
        quantumStart1.appendChild(quantumline1);
        let quantumbox = document.createElement("span");
        quantumbox.setAttribute("class", "doublequantum");
        const close = document.getElementsByClassName("close")[0].cloneNode(true);
        let edit = document.getElementsByClassName("editquantum")[0].cloneNode(true);
        quantumbox.appendChild(close);
        quantumbox.appendChild(edit);
        // quantumbox.style ="display:inline-block;width:40px;height:90px;border:0px dashed #333;position:absolute;top:0px;left:-14px;";
        quantumbox.style.display = 'inline-block'
        quantumbox.style.width = '40px'
        quantumbox.style.height = '90px'
        quantumbox.style.border = '0px dashed #EAEAEA'
        quantumbox.style.position = 'absolute'
        quantumbox.style.top = '0px'
        quantumbox.style.left = '-14px'
        quantumStart1.appendChild(quantumbox);
        this.moveNode1 = quantumStart1.cloneNode(true);
      }
    },
    //编辑跨线量子（暂不用）
    doublequantum(quantum) {
      this.start = quantum.getAttribute('position')-0//开始位置
      this.end = quantum.lastChild.getAttribute('end')-0//结束位置
      let cha = Math.abs(this.start - this.end)
      if (this.start >= this.end) {
        this.$message.error("开始位置应小于结束位置！");
        return;
      } else if (this.end > this.num - 1) {
        this.$message.error("请选择正确的结束位置！");
        return;
      } else {
        this.dialogFormVisibledouble = false;
        const tianchong = document.getElementsByClassName("tianchong")[0];
        if (this.oldStart != this.position) {//保证上次开始位置与此元素属性值相同
          this.oldStart = this.position;
        }
        if (Number(this.start) != this.oldStart) {//此时开始位置与上次开始位置不同时
          if (Number(this.start) < this.oldStart) {
            this.arr[this.oldStart].splice(Number(this.column),1,tianchong.cloneNode(true));
          } else {
            this.arr[this.oldStart].splice(Number(this.column), 1,tianchong.cloneNode(true));
          }

          if (Number(this.column) > this.arr[this.start].length) {//此时元素的所在列比所在行的长度大时
            for (var i = this.arr[this.start].length;i <= Number(this.column);i++) {
              this.arr[this.newStart][i] = tianchong.cloneNode(true);
            }
          }
          this.arr[this.start].splice(Number(this.column), 1, this.brr[0]);
        }
        if (Number(this.start) < this.oldStart) {
          for (var m = Number(this.start) + 1; m < Number(this.oldStart); m++) {
            if (this.arr[m][Number(this.column)]) {
              if (this.arr[m][Number(this.column)].getAttribute("name") ==="cx" ||this.arr[m][Number(this.column)].getAttribute("name") ==="swap" ||this.arr[m][Number(this.column)].getAttribute("name") ==="cz" ||this.arr[m][Number(this.column)].getAttribute("quantum") ==="quantum") {
                this.$message.error("请选择合法位置！");                                                                                                                                                                                                                                                                                                                                                                                                                                  
                return;
              }
            }
          }
        } else {
          for (var m = Number(this.start) + 1; m <= Number(this.end); m++) {
            if (this.arr[m][Number(this.column)]) {
              if (this.arr[m][Number(this.column)].getAttribute("name") ==="cx" ||this.arr[m][Number(this.column)].getAttribute("name") ==="swap" ||this.arr[m][Number(this.column)].getAttribute("name") ==="cz" ||this.arr[m][Number(this.column)].getAttribute("quantum") ==="quantum") {
                this.$message.error("请选择合法位置！");
                return;
              }
            }
          }
        }
        let quantumline;
        if(quantum.getAttribute('name')==='cx'){//cx量子比特门时
           quantumline = quantum.firstChild
           if(this.$route.query.qobj_id){//有实验id时
             let line =Number(quantum.getAttribute('position'))//所在行
             let column =Number(quantum.getAttribute('index'))//所在列
             if(line<this.start){//所在行比开始位置小时
               for(var m=line;m<this.start;m++){
               if(this.arr[m][column].getAttribute('name')==='tianchong'){//此元素为填充元素时
                 this.arr[m].splice(column,1)
               }
             }
            }
             this.arr[Number(this.start)][column].lastChild.setAttribute('end',this.end)//设置结束位置属性
             this.arr[Number(this.start)][column].firstChild.style.height = 54 * (this.end - this.start) + "px";//设置跨线元素的高度
           }
           if(Number(this.end) - Number(this.start) == 1){//跨线元素为两条线纠缠时
             quantumline.style.height = (43 * (Number(this.end) - Number(this.start)))  + "px";//量子门的中间线的高度
           }else{//跨线元素多于两条线纠缠时
             quantumline.style.height = (47.5 * (Number(this.end) - Number(this.start)) + (Number(this.end) - Number(this.start)-2))  + "px";//量子门的中间线的高度
           }

        }else if(quantum.getAttribute('name')==='swap'){//swap门
           quantumline = quantum.firstChild;
           if(this.$route.query.qobj_id){//有实验id时
             let line = Number(quantumbox.parentNode.getAttribute('position'))//所在行
             let column =Number(quantumbox.parentNode.getAttribute('index')) //所在列
             this.arr[Number(this.start)][column].lastChild.setAttribute('end',this.end)//结束位置
             this.arr[Number(this.start)][column].childNodes[1].style.height = 42 * (this.end - this.start) + "px";//量子门的中间线的高度
           }
          quantumline.style.height = (52 * (this.end - this.start)-(this.end - this.start-1))+ "px";//量子门的中间线的高度
        }else if(quantum.getAttribute('name')==='cz'){
           quantumline = quantum.firstChild;
           if(this.$route.query.qobj_id){//有实验id时
             let line = Number(quantumbox.parentNode.getAttribute('position'))//所在行
             let column =Number(quantumbox.parentNode.getAttribute('index')) //所在列
             this.arr[Number(this.start)][column].lastChild.setAttribute('end',this.end)//结束位置
             this.arr[Number(this.start)][column].childNodes[1].style.height = 42 * (this.end - this.start) + "px";//量子门的中间线的高度
           }
          quantumline.style.height = (52 * (this.end - this.start)-(this.end - this.start-1))+ "px";//量子门的中间线的高度
        }
        quantumbox.setAttribute("end", this.end);//设置结束位置属性
        quantumbox.style.height = 47 * (this.end - this.start + 1) + "px";//边框高度
        for(var i=0;i<this.arr.length;i++){
          for(var j=0;j<this.arr[i].length;j++){
            this.arr[i][j].setAttribute("line",'')
          }
        }
        for (var s = Number(this.start)+1; s <= Number(this.end); s++) {
          for (var p = 0; p <=Number(this.column); p++) {
            if(!this.arr[s][p]){
              this.arr[s][p] = tianchong.cloneNode(true);
            }
          }
        }
        for (var m = Number(this.start)+1; m <= Number(this.end); m++) {
          let length = 0;
          if (this.arr[Number(this.start)].length - 1 > Number(this.column)) {//元素所在行的长度大于列数时
            length = this.arr[Number(this.start)].length - 1;
          } else {
            length = this.arr[Number(this.start)].length;
          }
          for (var n = this.arr[m].length; n < length; n++) {
            this.arr[m][n] = tianchong.cloneNode(true);
          }
        }
        for(var a=0;a<this.arr.length;a++){
          for(var b=0;b<this.arr[a].length;b++){
            if(this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz'){
              const endline = Number(this.arr[a][b].lastChild.getAttribute('end'))//结束位置
              if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&endline){
                for(var h=a+1;h<=endline;h++){
                this.arr[h][b].setAttribute("line",'line')
              }
              }else if((this.arr[a][b].getAttribute("name")==='cx'||this.arr[a][b].getAttribute("name")==='swap'||this.arr[a][b].getAttribute("name")==='cz')&&!endline){
                  this.arr[a+1][b].setAttribute("line",'line')
              }
            }
          }
        }

        for (var i = 0; i < this.arr.length; i++) {
          const box = document.getElementById("box" + i);
          const boxChild = box.childNodes;
          for (var k = boxChild.length - 1; k >= 0; k--) {
            box.removeChild(boxChild[k]);
          }

          this.arr[i].forEach((item, index) => {
            if(item){
              if (item.getAttribute("name") === "cx"||item.getAttribute("name") === "swap"||item.getAttribute("name") === "cz") {
                item.setAttribute("position", i);
              }
              item.setAttribute("index",index)
              if(!this.$route.query.qobj_id){
                box.appendChild(item);
              }
            }
          });
          this.qasmShow()
          if(this.$route.query.qobj_id){//有实验id时
            let item1;
              for (var ii = 0; ii < this.arr.length; ii++) {
                const box = document.getElementById("box" + ii);
                const boxChild = box.childNodes;
                for (var k = boxChild.length - 1; k >= 0; k--) {
                  box.removeChild(boxChild[k]);
                }
                for (var j = 0; j < this.arr[ii].length; j++) {
                  if(this.arr[ii][j]){
                    item1 = this.arr[ii][j];
                    if(item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                      if(item1.getAttribute('class')!='turnCx'){
                          item1.setAttribute("class", "online");
                        }
                    }
                    if(item1.getAttribute('name')!=='cx'&&item1.getAttribute('name')!=='swap'&&item1.getAttribute('name')!=='tianchong'&&item1.getAttribute('name')!=='toffoli'){
                      item1.firstChild.lastChild.setAttribute("class",'bit')
                    }else if(item1.getAttribute('name')=='cx'){
                      if(item1.getAttribute('class')!='turnCx'){
                        item1.setAttribute('class','circle1')
                      }
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='swap'){
                      item1.setAttribute('class','xStart1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='cz'){
                      item1.setAttribute('class','circle1')
                      let start =Number(item1.getAttribute('position'))
                      let end =Number(item1.lastChild.getAttribute('end'))
                      for(var dd=start+1;dd<=end;dd++){
                        if(this.arr[dd][j].getAttribute('name') === 'tianchong'){
                          this.arr[dd][j].setAttribute("line",'line')
                        }
                      }
                    }else if(item1.getAttribute('name')=='toffoli'){
                          if(item1.getAttribute('class')=='toffcircle2'){
                            item1.firstChild.firstChild.setAttribute('class','quantumline4')
                          }else if(item1.getAttribute('class')=='circle1'){
                             if(item1.firstChild.firstChild.getAttribute('name')=='end'){
                                item1.firstChild.firstChild.setAttribute('class','circle2')
                              }else{
                                item1.firstChild.firstChild.setAttribute('class','circle3')
                              }
                          }
                        }
                  }else{
                    this.arr[ii][j]=tianchong.cloneNode(true)
                    item1 = this.arr[ii][j].cloneNode(true);
                  }
                    this.arr.forEach((ele,index) =>{
                      ele.forEach((element,inx) =>{
                        if(element){
                          element.setAttribute("index",inx)
                        }
                      })
                    })
                  box.appendChild(item1);
                  };
                }
          }
        }
      }
    },

    //拖拽量子
    dragstart(e) {
      const li = document.getElementsByTagName("li");
      this.moveNode1 = e.target.cloneNode(true);//克隆拖拽元素
      this.moveNode1.setAttribute("class", "online");
      this.moveNode1.setAttribute("draggable", "false");//克隆的元素设置为不可再拖拽
      this.isscreen = false
    },
    //销毁定时器
    Onclear(){
      clearInterval(this.allTaskListTime);    //清除定时器
      this.allTaskListTime = null;
    },
  }
};
</script>

<style lang="less" scoped>
* {
  list-style: none;
  text-decoration: none;
  font-size: 12px;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', STHeiti,SimSun,sans-serif
}
html { -webkit-text-size-adjust: none; }
/deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label{
  position: relative;
}

/deep/.el-pagination .el-select .el-input{
  margin:0;
}
/deep/.el-input__inner{
      border-radius: 0%;
      height: 32px;
      color: rgba(0, 0, 0, 0.45);
    }
/deep/.el-pagination__sizes{
    margin: 0;
}
/deep/ .el-input.is-disabled .el-input__icon{
  display: none;
}
.el-pagination {
    display: flex;
    justify-content: flex-end;
    margin-top:12px;
    padding:0;
    /deep/.el-pager .active{
      background: #2492FC !important;
      color: #FFFFFF !important;
    }
    /deep/.btn-prev{
      padding: 0;
      height: 32px;
      width: 32px;
      margin-right: 8px;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      box-sizing: border-box;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.btn-next{
      padding: 0;
      height: 32px;
      width: 32px;
      margin-right: 8px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.el-pager li{
      height: 32px;
      width: 32px;
      line-height: 32px;
      margin-right: 8px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.el-pagination__total{
      font-size: 12px;
    }
    /deep/.el-input{
      width: 85px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 0%;
    }
    /deep/.el-input__inner{
      border-radius: 0% !important;
      height: 32px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
.demo-ruleForm{
  /deep/.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
    content: '*';
    color: #F04134;
    position:absolute;
    top: 3px;
    left: 60px
  }
}
.runTest{
  /deep/.el-form-item__label{
    text-align: left;
  }
}
.editQuantum{
  /deep/.el-input__inner{
    height: 30px;
  }
  /deep/.el-form-item__label{
    text-align: left;
    font-size: 12px;
    width: 100px;
  }
}
.el-button{
  width: 74px;
  height: 32px;
  border-radius: 0%;
  line-height: 8px;
}
.el-input{
  border-radius: 0%;
}

/deep/.el-select{
    width: 300px;
    height: 30px;
}
/deep/.el-input__inner{
  border-radius: 0%;
}
/deep/.el-textarea{
   height: 80px;
  font-size: 12px;
}
/deep/.el-textarea__inner{
  border-radius: 0%;
  height: 80px;
  font-size: 12px;
}
  /deep/.el-dialog__header{
    padding: 14px 20px 13px;
    font-weight: 600;
    color: #404040;
    background: #F6F7FB;
    border-bottom: 1px solid #E8E8E8;
  }
  /deep/.dialog_delect .el-dialog__body{
    padding:30px;
  }
  /deep/.el-dialog__footer{
    padding: 0;
    width: 100%;
    height: 59px;
    background: #F6F7FB;
    text-align: center;
    line-height: 65px;
  }
  .dialog_delect {
      .el-dialog__header {
        background-color: #f6f7fb;
        border-bottom: 1px solid #e8e8e8;
        padding-top: 1rem;
      }
      .el-dialog__body {
        padding: 0.8rem 1.5rem 1.5rem 1.5rem;
      }
      .el-dialog__footer {
        text-align: center;
      }
      .el-table__body-wrapper {
        height: 100% !important;
      }
    }
  /deep/.el-dialog{
    box-sizing: border-box;

    /deep/.el-dialog__close{
      color: #404040;
    }
    /deep/.dialog-footer{
        /deep/.el-button{
          width: 74px;
          height: 30px;
          line-height: 8px;

        }
      }
    .text_tip{
      position: absolute;
      top: 5px;
      left: 45px;

    }
    /deep/.el-form-item__label{
      width: 100px;
      text-align:left;
      color: #262626;
      font-size: 12px;
    }
  }
/deep/.el-pagination{
  margin-top: 16px;
  font-size: 12px;
  /deep/.el-pager .active{
      background: #2492FC !important;
      color: #FFFFFF !important;
    }
    /deep/.btn-prev{
      padding: 0;
      height: 32px;
      width: 32px;
      margin-right: 8px;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      box-sizing: border-box;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.btn-next{
      padding: 0;
      height: 32px;
      width: 32px;
      margin-right: 8px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.el-pager li{
      height: 32px;
      width: 32px;
      line-height: 32px;
      margin-right: 8px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.15);;
      border-radius: 0%;
      background: #FFFFFF !important;
      color: rgba(0, 0, 0, 0.65) !important;
    }
    /deep/.el-pagination__total{
      font-size: 12px;
    }
    /deep/.el-input{
      width: 85px;
      height: 32px;
      background: #FFFFFF;
      border-radius: 0%;
    }
    /deep/.el-input__inner{
      border-radius: 0%;
      height: 32px;
    }
}
.tianchong {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin: 0 2.7px;
}
/deep/.CodeMirror {
  height: 100% !important;
  color: #555555 !important;
  font-size: 12px !important;
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Arial, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft Yahei', STHeiti,SimSun,sans-serif;
  line-height: 18px;
  /deep/.CodeMirror-line {

      //  color: #555555 !important;

  }
}
/deep/.CodeMirror-scroll{
  height: 97% !important;
  color: #555555 !important;
}
.icon {
    display:inline-block;
    width: 25px;
    height: 25px;
    // vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
}
.close {
  cursor: pointer;
  display: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  position: absolute;
  top: 5px;
  right: -8px;
  z-index: 9999;
  background-image: url('../../assets/images/guanbi.png');
  background-size: 100% 100%;
}
.editquantum {
  cursor: pointer;
  display: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 12px;
  line-height: 12px;
  text-align: center;
  // border: 1px solid #333;
  position: absolute;
  top: 25px;
  right: -8px;
  z-index: 9999;
  background-image: url("../../assets/images/edit.png");
  background-size: 100% 100%;
}
.quantumbox {
  display: inline-block;
  width: 50px;
  text-align: center;
  height: 200px;
  border: 1px solid #000000;
}
.quantumline {
  display: block;
  width: 2px;
  height: 15px;
  background-color: blue;
  position: absolute;
  top: 10px;
  left: 12px;
}
.quantumline1 {
  display: block;
  width: 2px;
  height: 42px;
  background-color: blue;
  margin: 6px;
  position: relative;
}
.quantumline2 {
  display: inline-block;
  width: 2px;
  height: 54px;
  background-color: blue;
  margin: 6px;
  position: absolute;
  top: 20px;
  left: 0px;
}
.quantumline3 {
  display: inline-block;
  width: 2px;
  height: 54px;
  background-color: blue;
  margin: 6px;
  margin-top: 2px;
  position: absolute;
  top: 3px;
  left: 0px;
}
.quantumline4 {
  display: inline-block;
  width: 2px;
  height: 35px;
  background-color: blue;
  margin: 6px;
  margin-top: 2px;
  position: absolute;
  top: 33px;
  left: 15px;
}
.toffquantumline {
  display: inline-block;
  width: 2px;
  height: 44px;
  background-color: blue;
  margin: 6px;
  margin-top: 0px;
  position: absolute;
  top: 10px;
  left: 0px;
}
.toffquantumline1 {
  display: inline-block;
  width: 2px;
  height: 44px;
  background-color: blue;
  margin: 6px;
  margin-top: 0px;
  position: absolute;
  top: 20px;
  left: 8px;
}
.circle {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: blue;
  position: absolute;
  top: 5px;
  left: 8px;
}
.xStart {
  display: inline-block;
  width: 10px;
  height: 10px;
  font-size: 40px;
  color: blue;
  position: absolute;
  font-weight: 800;
  top: -8px;
  left: 8px;
}
.toffcircle {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: blue;
  margin: 7px 15px;
  margin-right: 15.5px;
  box-sizing: border-box;
  position: absolute;
  top: 33px;
  left: -21px;
}
.circle1 {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: blue;
  margin: 7px 15px;
  margin-right: 15.5px;
  // margin-bottom: 7px;
  box-sizing: border-box;
  position: relative;
}
.circle3 {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: blue;
  // margin: 7px 15px;
  margin-right: 15.5px;
  // margin-bottom: 7px;
  box-sizing: border-box;
  position: absolute;
  bottom: -7px;
  left: -6.5px;
}
.xStart1 {
  display: inline-block;
  width: 15px;
  height: 15px;
  font-size: 20px;
  font-weight: 800;
  color: blue;
  margin: 7px 15px;
  box-sizing: border-box;
  position: relative;
  top: -18.8px;
  .iconfont{
    font-size: 20px;
    position: absolute;
    left: -3.1px;
    top:2px;
  }
}
.xStart2 {
  display: inline-block;
  width: 15px;
  height: 15px;
  font-size: 20px;
  font-weight: 800;
  color: blue;
  margin: 7px 15px;
  box-sizing: border-box;
  position: absolute;
  bottom: 3px;
  left: -21px;
  .iconfont{
    font-size: 20px;
    position: absolute;
    left: -3.1px;
    top:-2px;
  }
}
.circle2 {
  display: inline-block;
  text-align: center;
  line-height: 19px;
  font-size: 30px;
  color: blue;
  margin: 7px 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  bottom: -28px;
  left: -29px;
  /deep/.iconfont{
    font-size: 30px !important;
  }
}
.toffcircle2 {
  display: inline-block;
  width:45px;
  height: 45px;
  text-align: center;
  line-height: 46px;
  font-size: 30px;
  color: blue;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
  /deep/.iconfont{
    font-size: 30px !important;
  }
}
.circleend {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  color: blue;
  position: absolute;
  bottom: 5px;
  left: 8.5px;

}
.xEnd {
  display: inline-block;
  width: 10px;
  height: 10px;
  // border-radius: 50%;
  font-weight: 800;
  font-size: 40px;
  color: blue;
  position: absolute;
  bottom: 17px;
  left: 8px;

}
.circleQuantum,
.xQuantum {
  display: inline-block;
  box-sizing: border-box;
  width: 35px;
  height: 35px;
  text-align: center;
  // line-height: 40px;
  border-radius: 50%;
  background-color: #00a854;
  position: relative;
  em {
    font-style: normal;
    width: 100%;
    height: 100%;
    display: inline-block;
    line-height: 35px;
    position: relative;
    margin-left: 5px;
    b {
      display: none;
      width: 12px;
      height: 12px;
      background: #333;
      color: #ffffff;
      font-size: 8px;
      line-height: 12px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: -5px;
      right: -5px;
    }
  }
}

.noclick {
  pointer-events: none;
}
.el-table {
  font-size: 12px;
}
.edit {
  display: inline-block;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  margin-right: 6px;
  em {
    font-style: normal;
    width: 100%;
    height: 100%;
    display: inline-block;
    line-height: 35px;
    position: relative;
    top: 5px;
    margin-left: 5px;
    b {
      display: none;
      width: 12px;
      height: 12px;
      background: #333;
      color: #ffffff;
      font-size: 8px;
      line-height: 12px;
      text-align: center;
      border-radius: 50%;
      position: absolute;
      top: -5px;
      right: -5px;
    }
    .bit {
      display: inline-block;
      width: 25px;
      height: 25px;
      // background: green;
      color: aliceblue;
      line-height: 25px;
      text-align: center;
      margin-right: 20px;
      font-size: 10px;
      position: absolute;
      top: 7.5px;
      left: 7.5px;
    }
  }
}
.orderValue {
  width: 14px;
  height: 20px;
  font-size: 12px;
  border: none;
  text-align: center;
  line-height: 20px;
  background: none;
}
.clearfix:after {
  /*伪元素是行内元素 正常浏览器清除浮动方法*/
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.clearfix {
  *zoom: 1; /*ie6清除浮动的方式 *号只有IE6-IE7执行，其他浏览器不执行*/
}
.success_status {
  b {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #00a854;
    margin-right: 5px;
  }
.start{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #2186FC;
  border-radius: 50%;
}
.wrong{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #F04134;
  border-radius: 50%;
}
.quit{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #DDDDDD;
  border-radius: 50%;
}
}
.error_status {
  b {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: red;
    margin-right: 5px;
  }
.start{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #2186FC;
  border-radius: 50%;
}
.wrong{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #F04134;
  border-radius: 50%;
}
.quit{
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #DDDDDD;
  border-radius: 50%;
}
}
.el-main {
  height: calc(100vh - 50px) !important;
  background-color: #e9eef3;
  color: #333;
  padding: 0;

}
.programbox{
  width: 98%;
  height: 350px;
  background: #FFFFFF;
  box-shadow: 0rem 0.2rem 0.3rem 0rem #EBE9E9;
  display: flex;
  padding: 24px 0 0 24px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: flex-start;
  /deep/.el-form-item__label{
    width: 100px;
    text-align: left;
  }
  /deep/.el-form-item__error{
    padding: 0;
  }
}
.create_wrap{
  width: 98%;
  height: 560px;
  background: #FFFFFF;
  box-shadow: 0 2px 3px 0 #EBE9E9;
  margin: 12px 0;
  box-sizing: border-box;
  padding: 24px;
  .create_title{

    .title_text{
      display: inline-block;
      width: 70.6%;
      font-size: 14px;
      color: #5A5A5A;
      .title_info{
        font-size: 12px;
      }
    }
    .title_text1{
      display: inline-block;
      width: 29%;
      font-size: 14px;
      color: #5A5A5A;
      .title_info{
        font-size: 12px;
      }
    }
  }
  .create_box{
    display: flex;
    justify-content: space-between;
  .create {
    background-color: #FFFFFF;
    width: 70%;
    height: 434px;
    border:1px solid #EAEAEA;
    margin: 18px 0 16px 0 ;
    overflow-y: auto;
    .tip {
      margin: 0 auto;
      text-align: center;
      width: 500px;
      height: 20px;
      font-size: 12px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 20px;
    }
    #lis {
      text-align: center;
      margin: 0;
      margin-top: 20px;
    }
    #lis li {
      display: inline-block;
      box-sizing: border-box;
      width: 40px;
      height: 40px;
      cursor: pointer;
      em {
        font-style: normal;
        width: 100%;
        height: 100%;
        display: inline-block;
        line-height: 35px;
        position: relative;
        margin-left: 5px;
        i {
          display: none;
          font-size: 14px;
          position: absolute;
          top: -17px;
          right: -6px;
          cursor: pointer;
        }
        .bit {
          display: inline-block;
          width: 30px;
          height: 30px;
          // background: green;
          // color: aliceblue;
          line-height: 25px;
          text-align: center;
          margin-right: 20px;
          font-size: 10px;
          position: absolute;
          top: 7.5px;
          left: 7.5px;
        }
      }
    }
  }
}

}
.submitButton {
  width: 45rem;
  margin-top: 4px;
}
.bar_wrap{
  width: 98%;
  height: 400px;
  background: #FFFFFF;
  box-shadow: 0 2px 3px 0 #EBE9E9;
  margin-bottom: 24px;
  padding: 12px 16px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .bar1{
    width: 33%;
    height: 400px;
    border-right: 1px solid #e6e6e6;
    font-size: 14px;
    .tip{
      border: 1px solid #000000;
      width: 80%;
      font-size: 14px;
      height: 20%;
      line-height: 20px;
      padding: 20px;
      box-sizing: border-box;
      margin: 20% auto;
    }
     /deep/#charts{
      width: 100%;
      height: 330px;
      margin: 0 auto;
    }
     /deep/#charts0{
      width: 100%;
      height: 330px;
      margin: 0 auto;
    }
  }
  .bar2{
    width: 33%;
    height: 400px;
    font-size: 14px;
     /deep/#charts1{
      width: 100%;
      height: 330px;
      margin: 0 auto;
      /deep/div:first-child{
        width: 100%;
        /deep/canvas{
          width: 100%;
        }
      }
    }
  }
}
.taskList {
  width: 98%;
  max-height: 400px;
  background: #FFFFFF;
  box-shadow: 0 2px 3px 0 #EBE9E9;
  margin-bottom: 24px;
  padding: 12px 16px;
  box-sizing: border-box;
  h4{
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: #262626;
    margin-bottom: 8px;
  }
  /deep/.el-table th>.cell{
    font-size: 12px;
    font-weight: 500;
    color: #404040;
  }
}
.el-container {
  height: calc(100vh - 50px) !important;
}
.aside_wrap {
  width: 100%;
  height: 560px;
  div {
    width: 100%;
    height: 50px;
    line-height: 50px;
  }
}
.wrap {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #F5F5F5;
  .title {
    width: 97%;
    height: 64px;
    line-height: 64px;
    background: #FFFFFF;
    padding-left:16px;
    margin: 12px 0;
    i{
      font-size: 16px;
      color: #262626;
      margin-right: 5px;
      cursor: pointer;
    }
    span {
      cursor: pointer;
      font-size: 14px;
      color: #262626;
    }

  }
  .account {
    font-size: 12px;
    width: 98%;
    height: 40px;;
    line-height: 40px;
    margin-bottom: 12px;
    padding: 0 10px;
    color: #555555;
    border: 1px solid #AEDDEE;
    background-color: #F0F8FD;
    border-radius: 0%;
    position: relative;
  span{
    display: inline-block;
    border: 1px solid #1497DD;
    width:12px;
    height: 12px;
    line-height: 12px;
    font-size: 8px;
    text-align: center;
    border-radius: 50%;
    color: #1497DD;
  }
  .glossary{
    cursor: pointer;
    display: inline-block;
    font-size: 12px;
    margin: 0;
    color: #2186FC;
    font-weight: 400;
  }

}
  /deep/.el-tag .el-icon-close{
    position: absolute;
    top: 12px;
    right:10px !important;
   }

}
.line_scroll {
  width: 100%;
  height: 351px;
  overflow-x: auto;
}
.line_wrap {
  width: 5000px;
  overflow-x: hidden;
  overflow-y: hidden;
}
.line {
  width: 5000px;
  height: 50px;
}
.left {
  float: left;
  display: inline-block;
  width: 72px;
  height: 50px;
  line-height: 50px;
  text-align: left;
  position: relative;
  margin-left: 40px;
}
.right {
  float: left;
  display: inline-block;
  width: 4850px;
  height: 50px;
  line-height: 50px;
  position: relative;
}
.right_c1 {
  float: left;
  display: inline-block;
  width: 80%;
  height: 50px;
  line-height: 50px;
  position: relative;
}
.bgline {
  display: inline-block;
  width: 4850px;
  height: 100%;
  background: url("../../assets/images/line.png")  100% 100% ;
}
.bgline1 {
  display: inline-block;
  width: 100%;
  height: 100%;
  background: url("../../assets/images/line.png")  100% 100%;
}
.addline {
  width: 120px;
  text-align: left !important;
  height: 12px;
  text-align: center;
  font-size: 12px;
  color: #2492FC;
  margin-left: 16px;
  cursor: pointer;
  i{
    display: inline-block;
    margin-right: 10px;
  }
}
.c1 {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}
.online_wrap {
  // width: 45px;
  height: 50px;
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 998;
  top: 0;
  left: 0;
}
.online {
  display: inline-block;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  line-height: 40px;
  top: 4.5px;
  left: 5px;
  margin-right: 5.5px;
  position: relative;
  em {
    font-style: normal;
    width: 100%;
    height: 100%;
    display: inline-block;
    line-height: 35px;
    position: relative;
    top: -3px;
    border: 0px dashed #EAEAEA;
  }
  i {
    display: none;
    font-size: 14px;
    position: absolute;
    top: -5px;
    right: -6px;
    cursor: pointer;
    height: 13px;
    line-height: 13px;
  }
  .icon-bianji{
    display: none;
    font-size: 12px;
    position: absolute;
    top: 8px;
    right: -6px;
    cursor: pointer;
    height: 16px;
    line-height: 16px;
  }
  .bit {
    display: inline-block;
    width: 25px;
    height: 25px;
    // background: green;
    color: aliceblue;
    line-height: 25px;
    text-align: center;
    margin-right: 20px;
    font-size: 10px;
    position: absolute;
    top: 7.5px;
    left: 7.5px;
  }
}
.line_wrap_mondel {
  width: 100%;
  display: none;
}
.iconfontPng {
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  color: #2492FC;
  position: absolute;
  top: 0px;
  left: -24px;
}
.codesql {
  font-size: 12px;
}
.mycode_wrap {
  width: 29%;
  height: 435px;
  border: 1px solid #EAEAEA;
  overflow-y: auto;
  margin-top: 18px;
  .codesql {
    width: 600px;
    height: 100%;
  }
}
/deep/ .el-table__header{
  width: 100% !important;
}
/deep/ .el-table__body{
  width: 100% !important;
}
.orderNum{
  font-size: 12px;
}
.turnCx{
  display: inline-block;
  width: 45px;
  height: 42px;
}
.cnotLine{
   display: inline-block;
   position: relative;
   width: 2px;
   height: 50px;
   background-color: #1497DD;
  .cnotBottom{
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: #2186FC;
    position: absolute; 
    bottom: 0px;
    left: 1px;
    border-radius: 50%;
  }
}

</style>
